/*! Zoryn Icons Vue v2.3.2 */


// src/components/add-location.vue
import { defineComponent as _defineComponent } from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _sfc_main = /* @__PURE__ */ _defineComponent({
  name: "AddLocation",
  __name: "add-location",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.1 94.5 272.1 288 456.6C705.5 688 800 534 800 416M512 960Q160 640 160 416a352 352 0 0 1 704 0q0 224-352 544"
      }),
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M544 384h96a32 32 0 1 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96v-96a32 32 0 0 1 64 0z"
      })
    ]));
  }
}), add_location_default = _sfc_main;

// src/components/aim.vue
import { defineComponent as _defineComponent2 } from "vue";
import { createElementVNode as _createElementVNode2, openBlock as _openBlock2, createElementBlock as _createElementBlock2 } from "vue";
var _sfc_main2 = /* @__PURE__ */ _defineComponent2({
  name: "Aim",
  __name: "aim",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock2(), _createElementBlock2("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode2("path", {
      fill: "currentColor",
      d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
    }), _createElementVNode2("path", {
      fill: "currentColor",
      d: "M512 96a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V128a32 32 0 0 1 32-32m0 576a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V704a32 32 0 0 1 32-32M96 512a32 32 0 0 1 32-32h192a32 32 0 0 1 0 64H128a32 32 0 0 1-32-32m576 0a32 32 0 0 1 32-32h192a32 32 0 1 1 0 64H704a32 32 0 0 1-32-32"
    })]));
  }
}), aim_default = _sfc_main2;

// src/components/alarm-clock.vue
import { defineComponent as _defineComponent3 } from "vue";
import { createElementVNode as _createElementVNode3, openBlock as _openBlock3, createElementBlock as _createElementBlock3 } from "vue";
var _sfc_main3 = /* @__PURE__ */ _defineComponent3({
  name: "AlarmClock",
  __name: "alarm-clock",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock3(), _createElementBlock3("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode3("path", {
      fill: "currentColor",
      d: "M512 832a320 320 0 1 0 0-640 320 320 0 0 0 0 640m0 64a384 384 0 1 1 0-768 384 384 0 0 1 0 768"
    }), _createElementVNode3("path", {
      fill: "currentColor",
      d: "m292.3 824.6 55.4 32-48 83.1a32 32 0 1 1-55.4-32zm439.4 0-55.4 32 48 83.1a32 32 0 1 0 55.4-32zM512 512h160a32 32 0 1 1 0 64H480a32 32 0 0 1-32-32V320a32 32 0 0 1 64 0zM90.5 312.3A160 160 0 0 1 312.3 90.5l-46.8 46.8a96 96 0 0 0-128 128zm835.3 0A160 160 0 0 0 704 90.5l46.8 46.8a96 96 0 0 1 128 128z"
    })]));
  }
}), alarm_clock_default = _sfc_main3;

// src/components/apple.vue
import { defineComponent as _defineComponent4 } from "vue";
import { createElementVNode as _createElementVNode4, openBlock as _openBlock4, createElementBlock as _createElementBlock4 } from "vue";
var _sfc_main4 = /* @__PURE__ */ _defineComponent4({
  name: "Apple",
  __name: "apple",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock4(), _createElementBlock4("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode4("path", {
      fill: "currentColor",
      d: "M599.9 203.8a189 189 0 0 1 64.4-4.7l2.6.1c31.1 1 51.2 4.1 79.5 16.4 37.6 16 74.5 45 111.5 89.3 96.3 115.3 82.7 372.8-34.8 521.7-7.7 9.8-32 41.6-30.7 40a427 427 0 0 1-30.1 35.7c-31.2 32.6-65.3 49.3-110 50-31.4.7-53.6-5.2-84.4-18.7l-6.5-2.8c-21-9.3-30.6-12-47.3-12-18.1 0-28.6 3-51.1 12.7l-6.5 2.8c-28.4 12.3-48.3 18-76.1 19.2-74.2 2.8-117-38-180.7-132.1C103 679.3 67 472 144.7 335c46.2-82 129.9-133.7 220.6-135 32.8-.6 60.3 6.8 99.7 22.7a426 426 0 0 0 37.3 14.2q24.4-30.3 34.6-50.2 20.4-39.5 40.7-100.8a32 32 0 1 1 60.8 20.2 837 837 0 0 1-38.5 97.7m-51.5 78a1161 1161 0 0 1-52 58.9 32 32 0 1 1-46.7-43.8l12.3-13.3c-28-11.2-61.2-26.6-95.7-26-70.4 1-135.3 41.5-171.6 105.7C121.6 492.6 176 684.2 247.3 789c34.8 51.3 76.3 109 131 107 52.4-2.2 72.3-34.8 135.8-34.8s81.3 34.7 137 33.6c56.4-1.1 75.7-39 126.8-103.9 108-136.8 108-362.7 35.8-449S689 257.6 662 256.6c-41.5-4.3-81.6 12.5-113.6 25.2"
    })]));
  }
}), apple_default = _sfc_main4;

// src/components/arrow-down-bold.vue
import { defineComponent as _defineComponent5 } from "vue";
import { createElementVNode as _createElementVNode5, openBlock as _openBlock5, createElementBlock as _createElementBlock5 } from "vue";
var _sfc_main5 = /* @__PURE__ */ _defineComponent5({
  name: "ArrowDownBold",
  __name: "arrow-down-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock5(), _createElementBlock5("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode5("path", {
      fill: "currentColor",
      d: "M104.7 338.8a64 64 0 0 1 90.5 0L512 655.6l316.8-316.8a64 64 0 0 1 90.5 90.4l-362 362.1a64 64 0 0 1-90.5 0l-362.1-362a64 64 0 0 1 0-90.5"
    })]));
  }
}), arrow_down_bold_default = _sfc_main5;

// src/components/arrow-down.vue
import { defineComponent as _defineComponent6 } from "vue";
import { createElementVNode as _createElementVNode6, openBlock as _openBlock6, createElementBlock as _createElementBlock6 } from "vue";
var _sfc_main6 = /* @__PURE__ */ _defineComponent6({
  name: "ArrowDown",
  __name: "arrow-down",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock6(), _createElementBlock6("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode6("path", {
      fill: "currentColor",
      d: "M831.9 340.9 512 652.7 192.1 340.9a30.6 30.6 0 0 0-42.7 0 29 29 0 0 0 0 41.6l340.3 331.7a32 32 0 0 0 44.6 0l340.3-331.7a29 29 0 0 0 0-41.7 30.6 30.6 0 0 0-42.7 0z"
    })]));
  }
}), arrow_down_default = _sfc_main6;

// src/components/arrow-left-bold.vue
import { defineComponent as _defineComponent7 } from "vue";
import { createElementVNode as _createElementVNode7, openBlock as _openBlock7, createElementBlock as _createElementBlock7 } from "vue";
var _sfc_main7 = /* @__PURE__ */ _defineComponent7({
  name: "ArrowLeftBold",
  __name: "arrow-left-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock7(), _createElementBlock7("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode7("path", {
      fill: "currentColor",
      d: "M685.2 104.7a64 64 0 0 1 0 90.5L368.4 512l316.8 316.8a64 64 0 0 1-90.4 90.5l-362.1-362a64 64 0 0 1 0-90.5l362-362.1a64 64 0 0 1 90.5 0"
    })]));
  }
}), arrow_left_bold_default = _sfc_main7;

// src/components/arrow-left.vue
import { defineComponent as _defineComponent8 } from "vue";
import { createElementVNode as _createElementVNode8, openBlock as _openBlock8, createElementBlock as _createElementBlock8 } from "vue";
var _sfc_main8 = /* @__PURE__ */ _defineComponent8({
  name: "ArrowLeft",
  __name: "arrow-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock8(), _createElementBlock8("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode8("path", {
      fill: "currentColor",
      d: "M609.4 149.4 277.8 489.6a32 32 0 0 0 0 44.7l331.6 340.3a29 29 0 0 0 41.7 0 30.6 30.6 0 0 0 0-42.7l-311.8-320L651 192.1a30.6 30.6 0 0 0 0-42.7 29 29 0 0 0-41.7 0"
    })]));
  }
}), arrow_left_default = _sfc_main8;

// src/components/arrow-right-bold.vue
import { defineComponent as _defineComponent9 } from "vue";
import { createElementVNode as _createElementVNode9, openBlock as _openBlock9, createElementBlock as _createElementBlock9 } from "vue";
var _sfc_main9 = /* @__PURE__ */ _defineComponent9({
  name: "ArrowRightBold",
  __name: "arrow-right-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock9(), _createElementBlock9("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode9("path", {
      fill: "currentColor",
      d: "M338.8 104.7a64 64 0 0 0 0 90.5L655.6 512 338.8 828.8a64 64 0 0 0 90.4 90.5l362.1-362a64 64 0 0 0 0-90.5l-362-362.1a64 64 0 0 0-90.5 0"
    })]));
  }
}), arrow_right_bold_default = _sfc_main9;

// src/components/arrow-right.vue
import { defineComponent as _defineComponent10 } from "vue";
import { createElementVNode as _createElementVNode10, openBlock as _openBlock10, createElementBlock as _createElementBlock10 } from "vue";
var _sfc_main10 = /* @__PURE__ */ _defineComponent10({
  name: "ArrowRight",
  __name: "arrow-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock10(), _createElementBlock10("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode10("path", {
      fill: "currentColor",
      d: "M340.9 149.3a30.6 30.6 0 0 0 0 42.8L652.7 512 341 831.9a30.6 30.6 0 0 0 0 42.7 29 29 0 0 0 41.7 0l331.6-340.3a32 32 0 0 0 0-44.6L382.6 149.4a29 29 0 0 0-41.7 0z"
    })]));
  }
}), arrow_right_default = _sfc_main10;

// src/components/arrow-up-bold.vue
import { defineComponent as _defineComponent11 } from "vue";
import { createElementVNode as _createElementVNode11, openBlock as _openBlock11, createElementBlock as _createElementBlock11 } from "vue";
var _sfc_main11 = /* @__PURE__ */ _defineComponent11({
  name: "ArrowUpBold",
  __name: "arrow-up-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock11(), _createElementBlock11("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode11("path", {
      fill: "currentColor",
      d: "M104.7 685.2a64 64 0 0 0 90.5 0L512 368.4l316.8 316.8a64 64 0 0 0 90.5-90.4l-362-362.1a64 64 0 0 0-90.5 0l-362.1 362a64 64 0 0 0 0 90.5"
    })]));
  }
}), arrow_up_bold_default = _sfc_main11;

// src/components/arrow-up.vue
import { defineComponent as _defineComponent12 } from "vue";
import { createElementVNode as _createElementVNode12, openBlock as _openBlock12, createElementBlock as _createElementBlock12 } from "vue";
var _sfc_main12 = /* @__PURE__ */ _defineComponent12({
  name: "ArrowUp",
  __name: "arrow-up",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock12(), _createElementBlock12("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode12("path", {
      fill: "currentColor",
      d: "M488.8 344.3 149 701a32 32 0 0 0 0 44.2l.4.3a29.4 29.4 0 0 0 42.7 0l320-335.8 319.8 335.8a29.4 29.4 0 0 0 42.7 0l.4-.3a32 32 0 0 0 0-44.2L535.2 344.3a32 32 0 0 0-46.4 0"
    })]));
  }
}), arrow_up_default = _sfc_main12;

// src/components/avatar.vue
import { defineComponent as _defineComponent13 } from "vue";
import { createElementVNode as _createElementVNode13, openBlock as _openBlock13, createElementBlock as _createElementBlock13 } from "vue";
var _sfc_main13 = /* @__PURE__ */ _defineComponent13({
  name: "Avatar",
  __name: "avatar",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock13(), _createElementBlock13("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode13("path", {
      fill: "currentColor",
      d: "M628.7 528.9A416 416 0 0 1 928 928H96a416 416 0 0 1 299.3-399.1L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"
    })]));
  }
}), avatar_default = _sfc_main13;

// src/components/back.vue
import { defineComponent as _defineComponent14 } from "vue";
import { createElementVNode as _createElementVNode14, openBlock as _openBlock14, createElementBlock as _createElementBlock14 } from "vue";
var _sfc_main14 = /* @__PURE__ */ _defineComponent14({
  name: "Back",
  __name: "back",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock14(), _createElementBlock14("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode14("path", {
      fill: "currentColor",
      d: "M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64"
    }), _createElementVNode14("path", {
      fill: "currentColor",
      d: "m237.2 512 265.5 265.3a32 32 0 0 1-45.4 45.4l-288-288a32 32 0 0 1 0-45.4l288-288a32 32 0 1 1 45.4 45.4z"
    })]));
  }
}), back_default = _sfc_main14;

// src/components/baseball.vue
import { defineComponent as _defineComponent15 } from "vue";
import { createElementVNode as _createElementVNode15, openBlock as _openBlock15, createElementBlock as _createElementBlock15 } from "vue";
var _sfc_main15 = /* @__PURE__ */ _defineComponent15({
  name: "Baseball",
  __name: "baseball",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock15(), _createElementBlock15("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode15("path", {
      fill: "currentColor",
      d: "M195.2 828.8a448 448 0 1 1 633.6-633.6 448 448 0 0 1-633.6 633.6m45.2-45.2a384 384 0 1 0 543.2-543.2 384 384 0 0 0-543.2 543.2"
    }), _createElementVNode15("path", {
      fill: "currentColor",
      d: "M497.5 96.9a1678 1678 0 0 1 64.9 14.5 256.1 256.1 0 0 0 350.2 350.2q7.5 30.7 14.5 65A320.1 320.1 0 0 1 497.5 96.8m-389 395A320.1 320.1 0 0 1 532 915.6q-34.6-5.5-65.7-11.5a256.1 256.1 0 0 0-346.5-346.5 1737 1737 0 0 1-11.4-65.7"
    })]));
  }
}), baseball_default = _sfc_main15;

// src/components/basketball.vue
import { defineComponent as _defineComponent16 } from "vue";
import { createElementVNode as _createElementVNode16, openBlock as _openBlock16, createElementBlock as _createElementBlock16 } from "vue";
var _sfc_main16 = /* @__PURE__ */ _defineComponent16({
  name: "Basketball",
  __name: "basketball",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock16(), _createElementBlock16("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode16("path", {
      fill: "currentColor",
      d: "M778.8 788.2a383 383 0 0 0 116-245.6 257 257 0 0 0-241.7-14 763 763 0 0 1 125.7 259.6m-55 44.2a700 700 0 0 0-125.1-269.6 256 256 0 0 0-56.1 332 383 383 0 0 0 181.1-62.4m-254 61.3a320 320 0 0 1 88-380.1 716 716 0 0 0-48.1-48.1 320 320 0 0 1-379.3 88.4 382 382 0 0 0 110.1 229.7 382 382 0 0 0 229.2 110zM129.2 481.1a256 256 0 0 0 331-56.5 700 700 0 0 0-268.7-124.3A383 383 0 0 0 129.3 481m106.5-235.9a763 763 0 0 1 258.7 125.1 257 257 0 0 0-13.4-241 383 383 0 0 0-245.3 116m318.1-115a321 321 0 0 1-8.4 281.3 780 780 0 0 1 66.1 66.2 321 321 0 0 1 282.2-8.2 382 382 0 0 0-110.2-229A382 382 0 0 0 554 130.2zm274.9 698.5a448 448 0 1 1-633.6-633.6 448 448 0 0 1 633.6 633.6"
    })]));
  }
}), basketball_default = _sfc_main16;

// src/components/bell-filled.vue
import { defineComponent as _defineComponent17 } from "vue";
import { createElementVNode as _createElementVNode17, openBlock as _openBlock17, createElementBlock as _createElementBlock17 } from "vue";
var _sfc_main17 = /* @__PURE__ */ _defineComponent17({
  name: "BellFilled",
  __name: "bell-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock17(), _createElementBlock17("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode17("path", {
      fill: "currentColor",
      d: "M640 832a128 128 0 0 1-256 0zm192-64H134.4a38.4 38.4 0 0 1 0-76.8H192V448a320 320 0 0 1 256.3-313.6 64 64 0 1 1 127.4 0A320 320 0 0 1 832 448v243.2h57.6a38.4 38.4 0 0 1 0 76.8z"
    })]));
  }
}), bell_filled_default = _sfc_main17;

// src/components/bell.vue
import { defineComponent as _defineComponent18 } from "vue";
import { createElementVNode as _createElementVNode18, openBlock as _openBlock18, createElementBlock as _createElementBlock18 } from "vue";
var _sfc_main18 = /* @__PURE__ */ _defineComponent18({
  name: "Bell",
  __name: "bell",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock18(), _createElementBlock18("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode18("path", {
        fill: "currentColor",
        d: "M512 64a64 64 0 0 1 64 64v64H448v-64a64 64 0 0 1 64-64"
      }),
      _createElementVNode18("path", {
        fill: "currentColor",
        d: "M256 768h512V448a256 256 0 1 0-512 0zm256-640a320 320 0 0 1 320 320v384H192V448a320 320 0 0 1 320-320"
      }),
      _createElementVNode18("path", {
        fill: "currentColor",
        d: "M96 768h832q32 0 32 32t-32 32H96q-32 0-32-32t32-32m352 128h128a64 64 0 0 1-128 0"
      })
    ]));
  }
}), bell_default = _sfc_main18;

// src/components/bicycle.vue
import { defineComponent as _defineComponent19 } from "vue";
import { createElementVNode as _createElementVNode19, openBlock as _openBlock19, createElementBlock as _createElementBlock19 } from "vue";
var _sfc_main19 = /* @__PURE__ */ _defineComponent19({
  name: "Bicycle",
  __name: "bicycle",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock19(), _createElementBlock19("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "M256 832a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
      }),
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "M288 672h320q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "M768 832a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
      }),
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "M480 192a32 32 0 0 1 0-64h160a32 32 0 0 1 31 24.3l96 384a32 32 0 0 1-62 15.4L615 192zM96 384a32 32 0 0 1 0-64h128a32 32 0 0 1 30.3 21.9l64 192a32 32 0 1 1-60.6 20.2L201 384z"
      }),
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "m373.4 599.8-42.8-47.6 320-288 42.8 47.6z"
      })
    ]));
  }
}), bicycle_default = _sfc_main19;

// src/components/bottom-left.vue
import { defineComponent as _defineComponent20 } from "vue";
import { createElementVNode as _createElementVNode20, openBlock as _openBlock20, createElementBlock as _createElementBlock20 } from "vue";
var _sfc_main20 = /* @__PURE__ */ _defineComponent20({
  name: "BottomLeft",
  __name: "bottom-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock20(), _createElementBlock20("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode20("path", {
      fill: "currentColor",
      d: "M256 768h416a32 32 0 1 1 0 64H224a32 32 0 0 1-32-32V352a32 32 0 0 1 64 0z"
    }), _createElementVNode20("path", {
      fill: "currentColor",
      d: "M246.7 822.7a32 32 0 0 1-45.4-45.4l544-544a32 32 0 0 1 45.4 45.4z"
    })]));
  }
}), bottom_left_default = _sfc_main20;

// src/components/bottom-right.vue
import { defineComponent as _defineComponent21 } from "vue";
import { createElementVNode as _createElementVNode21, openBlock as _openBlock21, createElementBlock as _createElementBlock21 } from "vue";
var _sfc_main21 = /* @__PURE__ */ _defineComponent21({
  name: "BottomRight",
  __name: "bottom-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock21(), _createElementBlock21("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode21("path", {
      fill: "currentColor",
      d: "M352 768a32 32 0 1 0 0 64h448a32 32 0 0 0 32-32V352a32 32 0 0 0-64 0v416z"
    }), _createElementVNode21("path", {
      fill: "currentColor",
      d: "M777.3 822.7a32 32 0 0 0 45.4-45.4l-544-544a32 32 0 0 0-45.4 45.4z"
    })]));
  }
}), bottom_right_default = _sfc_main21;

// src/components/bottom.vue
import { defineComponent as _defineComponent22 } from "vue";
import { createElementVNode as _createElementVNode22, openBlock as _openBlock22, createElementBlock as _createElementBlock22 } from "vue";
var _sfc_main22 = /* @__PURE__ */ _defineComponent22({
  name: "Bottom",
  __name: "bottom",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock22(), _createElementBlock22("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode22("path", {
      fill: "currentColor",
      d: "M544 805.9V168a32 32 0 1 0-64 0v637.9l-233.3-248a30.7 30.7 0 0 0-45.4 0 35.5 35.5 0 0 0 0 48.1l288 306a30.7 30.7 0 0 0 45.4 0l288-306a35.5 35.5 0 0 0 0-48 30.7 30.7 0 0 0-45.4 0z"
    })]));
  }
}), bottom_default = _sfc_main22;

// src/components/bowl.vue
import { defineComponent as _defineComponent23 } from "vue";
import { createElementVNode as _createElementVNode23, openBlock as _openBlock23, createElementBlock as _createElementBlock23 } from "vue";
var _sfc_main23 = /* @__PURE__ */ _defineComponent23({
  name: "Bowl",
  __name: "bowl",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock23(), _createElementBlock23("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode23("path", {
      fill: "currentColor",
      d: "M714.4 704a352 352 0 0 0 148.2-256H161.4a352 352 0 0 0 148.2 256zM288 766.6A416 416 0 0 1 96 416a32 32 0 0 1 32-32h768a32 32 0 0 1 32 32 416 416 0 0 1-192 350.6V832a64 64 0 0 1-64 64H352a64 64 0 0 1-64-64zM493.2 320h-90.4L657.2 65.6a32 32 0 1 1 45.2 45.2zm187.4 0h-128l269.7-155.7a32 32 0 0 1 32 55.4zM352 768v64h320v-64z"
    })]));
  }
}), bowl_default = _sfc_main23;

// src/components/box.vue
import { defineComponent as _defineComponent24 } from "vue";
import { createElementVNode as _createElementVNode24, openBlock as _openBlock24, createElementBlock as _createElementBlock24 } from "vue";
var _sfc_main24 = /* @__PURE__ */ _defineComponent24({
  name: "Box",
  __name: "box",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock24(), _createElementBlock24("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode24("path", {
        fill: "currentColor",
        d: "M317 128 128 344v552h768V344L707 128zm-14.5-64h419a32 32 0 0 1 24 10.9l206.6 236A32 32 0 0 1 960 332v596a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V332a32 32 0 0 1 8-21L278.3 75a32 32 0 0 1 24.1-11"
      }),
      _createElementVNode24("path", {
        fill: "currentColor",
        d: "M64 320h896v64H64z"
      }),
      _createElementVNode24("path", {
        fill: "currentColor",
        d: "M448 327.9V640h128V327.9L526 128h-28zM448 64h128l64 256v352a32 32 0 0 1-32 32H416a32 32 0 0 1-32-32V320z"
      })
    ]));
  }
}), box_default = _sfc_main24;

// src/components/briefcase.vue
import { defineComponent as _defineComponent25 } from "vue";
import { createElementVNode as _createElementVNode25, openBlock as _openBlock25, createElementBlock as _createElementBlock25 } from "vue";
var _sfc_main25 = /* @__PURE__ */ _defineComponent25({
  name: "Briefcase",
  __name: "briefcase",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock25(), _createElementBlock25("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode25("path", {
      fill: "currentColor",
      d: "M320 320V128h384v192h192v192H128V320zM128 576h768v320H128zm256-256h256V192H384z"
    })]));
  }
}), briefcase_default = _sfc_main25;

// src/components/brush-filled.vue
import { defineComponent as _defineComponent26 } from "vue";
import { createElementVNode as _createElementVNode26, openBlock as _openBlock26, createElementBlock as _createElementBlock26 } from "vue";
var _sfc_main26 = /* @__PURE__ */ _defineComponent26({
  name: "BrushFilled",
  __name: "brush-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock26(), _createElementBlock26("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode26("path", {
      fill: "currentColor",
      d: "M608 704v160a96 96 0 0 1-192 0V704h-96a128 128 0 0 1-128-128h640a128 128 0 0 1-128 128zM192 512V128h640v384z"
    })]));
  }
}), brush_filled_default = _sfc_main26;

// src/components/brush.vue
import { defineComponent as _defineComponent27 } from "vue";
import { createElementVNode as _createElementVNode27, openBlock as _openBlock27, createElementBlock as _createElementBlock27 } from "vue";
var _sfc_main27 = /* @__PURE__ */ _defineComponent27({
  name: "Brush",
  __name: "brush",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock27(), _createElementBlock27("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode27("path", {
      fill: "currentColor",
      d: "M896 448H128v192a64 64 0 0 0 64 64h192v192h256V704h192a64 64 0 0 0 64-64zm-770.8-64q0-71.4 15.6-128 22.1-81 83.2-160h417.3l-15.4 70.3L736 96h211.2q-37.3 64.4-51.2 160a664 664 0 0 0-6.1 128H960v256a128 128 0 0 1-128 128H704v160a32 32 0 0 1-32 32H352a32 32 0 0 1-32-32V768H192A128 128 0 0 1 64 640V384zm64 0h636.6a730 730 0 0 1 6.8-137.2 619 619 0 0 1 18.7-86.8h-96.6L533.6 301.2 561.9 160H256.5a376 376 0 0 0-54 112.8Q189.5 321 189.3 384"
    })]));
  }
}), brush_default = _sfc_main27;

// src/components/burger.vue
import { defineComponent as _defineComponent28 } from "vue";
import { createElementVNode as _createElementVNode28, openBlock as _openBlock28, createElementBlock as _createElementBlock28 } from "vue";
var _sfc_main28 = /* @__PURE__ */ _defineComponent28({
  name: "Burger",
  __name: "burger",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock28(), _createElementBlock28("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode28("path", {
      fill: "currentColor",
      d: "M160 512a32 32 0 0 0-32 32v64a32 32 0 0 0 30 32h706a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32zm736-58.6a96 96 0 0 1 64 90.6v64a96 96 0 0 1-52 85.3l-52.6 140.3a96 96 0 0 1-89.9 62.3h-507a96 96 0 0 1-89.9-62.3L116 693.4A96 96 0 0 1 64 608v-64a96 96 0 0 1 64-90.6V448a384 384 0 1 1 768 5.4m-64-5.4a320 320 0 0 0-640 0zM512 704H188.4l40.1 107.1a32 32 0 0 0 30 20.8h507a32 32 0 0 0 30-20.8L835.6 704z"
    })]));
  }
}), burger_default = _sfc_main28;

// src/components/calendar.vue
import { defineComponent as _defineComponent29 } from "vue";
import { createElementVNode as _createElementVNode29, openBlock as _openBlock29, createElementBlock as _createElementBlock29 } from "vue";
var _sfc_main29 = /* @__PURE__ */ _defineComponent29({
  name: "Calendar",
  __name: "calendar",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock29(), _createElementBlock29("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode29("path", {
      fill: "currentColor",
      d: "M128 384v512h768V192H768v32a32 32 0 1 1-64 0v-32H320v32a32 32 0 0 1-64 0v-32H128v128h768v64zm192-256h384V96a32 32 0 1 1 64 0v32h160a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h160V96a32 32 0 0 1 64 0zm-32 384h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m192-192h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m192-192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64"
    })]));
  }
}), calendar_default = _sfc_main29;

// src/components/camera-filled.vue
import { defineComponent as _defineComponent30 } from "vue";
import { createElementVNode as _createElementVNode30, openBlock as _openBlock30, createElementBlock as _createElementBlock30 } from "vue";
var _sfc_main30 = /* @__PURE__ */ _defineComponent30({
  name: "CameraFilled",
  __name: "camera-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock30(), _createElementBlock30("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode30("path", {
      fill: "currentColor",
      d: "M160 224a64 64 0 0 0-64 64v512a64 64 0 0 0 64 64h704a64 64 0 0 0 64-64V288a64 64 0 0 0-64-64H748.4L702 131.3A64 64 0 0 0 644.7 96H379.3a64 64 0 0 0-57.2 35.4L275.8 224zm352 435.2a115.2 115.2 0 1 0 0-230.4 115.2 115.2 0 0 0 0 230.4m0 140.8a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
    })]));
  }
}), camera_filled_default = _sfc_main30;

// src/components/camera.vue
import { defineComponent as _defineComponent31 } from "vue";
import { createElementVNode as _createElementVNode31, openBlock as _openBlock31, createElementBlock as _createElementBlock31 } from "vue";
var _sfc_main31 = /* @__PURE__ */ _defineComponent31({
  name: "Camera",
  __name: "camera",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock31(), _createElementBlock31("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode31("path", {
      fill: "currentColor",
      d: "M896 256H128v576h768zm-199.4-64-32-64h-305l-32 64zM96 192h160l46.3-92.6A64 64 0 0 1 359.6 64h305a64 64 0 0 1 57.1 35.3l46.5 92.7H928a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32m416 512a160 160 0 1 0 0-320 160 160 0 0 0 0 320m0 64a224 224 0 1 1 0-448 224 224 0 0 1 0 448"
    })]));
  }
}), camera_default = _sfc_main31;

// src/components/caret-bottom.vue
import { defineComponent as _defineComponent32 } from "vue";
import { createElementVNode as _createElementVNode32, openBlock as _openBlock32, createElementBlock as _createElementBlock32 } from "vue";
var _sfc_main32 = /* @__PURE__ */ _defineComponent32({
  name: "CaretBottom",
  __name: "caret-bottom",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock32(), _createElementBlock32("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode32("path", {
      fill: "currentColor",
      d: "m192 384 320 384 320-384z"
    })]));
  }
}), caret_bottom_default = _sfc_main32;

// src/components/caret-left.vue
import { defineComponent as _defineComponent33 } from "vue";
import { createElementVNode as _createElementVNode33, openBlock as _openBlock33, createElementBlock as _createElementBlock33 } from "vue";
var _sfc_main33 = /* @__PURE__ */ _defineComponent33({
  name: "CaretLeft",
  __name: "caret-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock33(), _createElementBlock33("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode33("path", {
      fill: "currentColor",
      d: "M672 192 288 512l384 320z"
    })]));
  }
}), caret_left_default = _sfc_main33;

// src/components/caret-right.vue
import { defineComponent as _defineComponent34 } from "vue";
import { createElementVNode as _createElementVNode34, openBlock as _openBlock34, createElementBlock as _createElementBlock34 } from "vue";
var _sfc_main34 = /* @__PURE__ */ _defineComponent34({
  name: "CaretRight",
  __name: "caret-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock34(), _createElementBlock34("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode34("path", {
      fill: "currentColor",
      d: "M384 192v640l384-320z"
    })]));
  }
}), caret_right_default = _sfc_main34;

// src/components/caret-top.vue
import { defineComponent as _defineComponent35 } from "vue";
import { createElementVNode as _createElementVNode35, openBlock as _openBlock35, createElementBlock as _createElementBlock35 } from "vue";
var _sfc_main35 = /* @__PURE__ */ _defineComponent35({
  name: "CaretTop",
  __name: "caret-top",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock35(), _createElementBlock35("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode35("path", {
      fill: "currentColor",
      d: "M512 320 192 704h640z"
    })]));
  }
}), caret_top_default = _sfc_main35;

// src/components/cellphone.vue
import { defineComponent as _defineComponent36 } from "vue";
import { createElementVNode as _createElementVNode36, openBlock as _openBlock36, createElementBlock as _createElementBlock36 } from "vue";
var _sfc_main36 = /* @__PURE__ */ _defineComponent36({
  name: "Cellphone",
  __name: "cellphone",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock36(), _createElementBlock36("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode36("path", {
      fill: "currentColor",
      d: "M256 128a64 64 0 0 0-64 64v640a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm0-64h512a128 128 0 0 1 128 128v640a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V192A128 128 0 0 1 256 64m128 128h256a32 32 0 1 1 0 64H384a32 32 0 0 1 0-64m128 640a64 64 0 1 1 0-128 64 64 0 0 1 0 128"
    })]));
  }
}), cellphone_default = _sfc_main36;

// src/components/chat-dot-round.vue
import { defineComponent as _defineComponent37 } from "vue";
import { createElementVNode as _createElementVNode37, openBlock as _openBlock37, createElementBlock as _createElementBlock37 } from "vue";
var _sfc_main37 = /* @__PURE__ */ _defineComponent37({
  name: "ChatDotRound",
  __name: "chat-dot-round",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock37(), _createElementBlock37("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode37("path", {
      fill: "currentColor",
      d: "M174.7 855.7 310 810.6l23.7 11.8A398 398 0 0 0 512 864c211.8 0 384-166.8 384-352S723.8 160 512 160 128 326.8 128 512c0 69.1 25 139.3 70.8 199.2L221 740zm-45.2 82.5A32 32 0 0 1 89.6 896L148 750C94.7 680.4 64 597 64 512 64 299.9 256 96 512 96s448 203.9 448 416-192 416-448 416a461 461 0 0 1-207-48.4z"
    }), _createElementVNode37("path", {
      fill: "currentColor",
      d: "M512 563.2a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m192 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m-384 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4"
    })]));
  }
}), chat_dot_round_default = _sfc_main37;

// src/components/chat-dot-square.vue
import { defineComponent as _defineComponent38 } from "vue";
import { createElementVNode as _createElementVNode38, openBlock as _openBlock38, createElementBlock as _createElementBlock38 } from "vue";
var _sfc_main38 = /* @__PURE__ */ _defineComponent38({
  name: "ChatDotSquare",
  __name: "chat-dot-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock38(), _createElementBlock38("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode38("path", {
      fill: "currentColor",
      d: "M273.5 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64v570.9zm22.5 64L148 918.4a32 32 0 0 1-52-25V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
    }), _createElementVNode38("path", {
      fill: "currentColor",
      d: "M512 499.2a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m192 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m-384 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4"
    })]));
  }
}), chat_dot_square_default = _sfc_main38;

// src/components/chat-line-round.vue
import { defineComponent as _defineComponent39 } from "vue";
import { createElementVNode as _createElementVNode39, openBlock as _openBlock39, createElementBlock as _createElementBlock39 } from "vue";
var _sfc_main39 = /* @__PURE__ */ _defineComponent39({
  name: "ChatLineRound",
  __name: "chat-line-round",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock39(), _createElementBlock39("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode39("path", {
      fill: "currentColor",
      d: "M174.7 855.7 310 810.6l23.7 11.8A398 398 0 0 0 512 864c211.8 0 384-166.8 384-352S723.8 160 512 160 128 326.8 128 512c0 69.1 25 139.3 70.8 199.2L221 740zm-45.2 82.5A32 32 0 0 1 89.6 896L148 750C94.7 680.4 64 597 64 512 64 299.9 256 96 512 96s448 203.9 448 416-192 416-448 416a461 461 0 0 1-207-48.4z"
    }), _createElementVNode39("path", {
      fill: "currentColor",
      d: "M352 576h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m32-192h256q32 0 32 32t-32 32H384q-32 0-32-32t32-32"
    })]));
  }
}), chat_line_round_default = _sfc_main39;

// src/components/chat-line-square.vue
import { defineComponent as _defineComponent40 } from "vue";
import { createElementVNode as _createElementVNode40, openBlock as _openBlock40, createElementBlock as _createElementBlock40 } from "vue";
var _sfc_main40 = /* @__PURE__ */ _defineComponent40({
  name: "ChatLineSquare",
  __name: "chat-line-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock40(), _createElementBlock40("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode40("path", {
      fill: "currentColor",
      d: "M160 826.9 273.5 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64zM296 800 148 918.4a32 32 0 0 1-52-25V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
    }), _createElementVNode40("path", {
      fill: "currentColor",
      d: "M352 512h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m0-192h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32"
    })]));
  }
}), chat_line_square_default = _sfc_main40;

// src/components/chat-round.vue
import { defineComponent as _defineComponent41 } from "vue";
import { createElementVNode as _createElementVNode41, openBlock as _openBlock41, createElementBlock as _createElementBlock41 } from "vue";
var _sfc_main41 = /* @__PURE__ */ _defineComponent41({
  name: "ChatRound",
  __name: "chat-round",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock41(), _createElementBlock41("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode41("path", {
      fill: "currentColor",
      d: "m174.7 855.7 130-43.4 23.5 11.4A418 418 0 0 0 512 864c223.7 0 384-159.9 384-352 0-192.8-159.1-352-384-352S128 319.2 128 512a341 341 0 0 0 69.2 204.3L219 745zm-45.2 82.5A32 32 0 0 1 89.6 896l56.5-141.2A405 405 0 0 1 64 512C64 299.9 235.6 96 512 96s448 203.9 448 416-173.4 416-448 416a481 481 0 0 1-211.7-46.7z"
    })]));
  }
}), chat_round_default = _sfc_main41;

// src/components/chat-square.vue
import { defineComponent as _defineComponent42 } from "vue";
import { createElementVNode as _createElementVNode42, openBlock as _openBlock42, createElementBlock as _createElementBlock42 } from "vue";
var _sfc_main42 = /* @__PURE__ */ _defineComponent42({
  name: "ChatSquare",
  __name: "chat-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock42(), _createElementBlock42("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode42("path", {
      fill: "currentColor",
      d: "M273.5 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64v570.9zm22.5 64L148 918.4a32 32 0 0 1-52-25V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
    })]));
  }
}), chat_square_default = _sfc_main42;

// src/components/check.vue
import { defineComponent as _defineComponent43 } from "vue";
import { createElementVNode as _createElementVNode43, openBlock as _openBlock43, createElementBlock as _createElementBlock43 } from "vue";
var _sfc_main43 = /* @__PURE__ */ _defineComponent43({
  name: "Check",
  __name: "check",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock43(), _createElementBlock43("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode43("path", {
      fill: "currentColor",
      d: "M406.7 707 195.8 496.2a32 32 0 1 0-45.2 45.2l256 256 512-512a32 32 0 0 0-45.3-45.2L406.6 706.9z"
    })]));
  }
}), check_default = _sfc_main43;

// src/components/checked.vue
import { defineComponent as _defineComponent44 } from "vue";
import { createElementVNode as _createElementVNode44, openBlock as _openBlock44, createElementBlock as _createElementBlock44 } from "vue";
var _sfc_main44 = /* @__PURE__ */ _defineComponent44({
  name: "Checked",
  __name: "checked",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock44(), _createElementBlock44("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode44("path", {
      fill: "currentColor",
      d: "M704 192h160v736H160V192h160v64h384zM311.6 537.3l-45.3 45.2 181 181 316.9-316.8-45.4-45.2L447.4 673zM384 192V96h256v96z"
    })]));
  }
}), checked_default = _sfc_main44;

// src/components/cherry.vue
import { defineComponent as _defineComponent45 } from "vue";
import { createElementVNode as _createElementVNode45, openBlock as _openBlock45, createElementBlock as _createElementBlock45 } from "vue";
var _sfc_main45 = /* @__PURE__ */ _defineComponent45({
  name: "Cherry",
  __name: "cherry",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock45(), _createElementBlock45("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode45("path", {
      fill: "currentColor",
      d: "M261 449.6q20.8-104.6 63.4-177.7Q360 210.7 436.7 128H320a32 32 0 0 1 0-64h384a32 32 0 1 1 0 64H554.8q22.3 58.9 79.5 141.8c47.4 68.4 84.8 106.7 106.3 114.3a224 224 0 1 1-85 14.7q-33.7-34.3-73.9-92.6-58.3-84-84.4-149.3-83 87.6-117.7 147.2-34.8 59.7-53.6 147.1a224 224 0 1 1-65-1.6M288 832a160 160 0 1 0 0-320 160 160 0 0 0 0 320m448-64a160 160 0 1 0 0-320 160 160 0 0 0 0 320"
    })]));
  }
}), cherry_default = _sfc_main45;

// src/components/chicken.vue
import { defineComponent as _defineComponent46 } from "vue";
import { createElementVNode as _createElementVNode46, openBlock as _openBlock46, createElementBlock as _createElementBlock46 } from "vue";
var _sfc_main46 = /* @__PURE__ */ _defineComponent46({
  name: "Chicken",
  __name: "chicken",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock46(), _createElementBlock46("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode46("path", {
      fill: "currentColor",
      d: "m350 717 128.7-128.8a107 107 0 0 1-26.2-19.1 107 107 0 0 1-19-26.2L304.7 671.7q1.2 4.7 2 9.3l2.1 31.9 31.9 2zm57.3 33.2A128 128 0 1 1 191 864.6l-2-32-32-2a128 128 0 1 1 114.5-216.3l145.1-145c-2.4-101.5 58.2-239.2 149.1-330.1C673 31.9 797 53.7 882.5 139.2s107.3 209.4 0 316.8c-91 90.9-228.7 151.4-330.1 149zm90.5-226.3c49.5 49.6 233.3-7 339.4-113 78.2-78.3 63.2-163.1 0-226.4-63.2-63.2-148-78.2-226.3 0-106 106.1-162.6 290-113.1 339.4M244.8 709a64 64 0 1 0-59.8 59.9l56.3-3.6zm8.1 127.7a64 64 0 1 0 59.9-59.8l-56.4 3.5z"
    })]));
  }
}), chicken_default = _sfc_main46;

// src/components/chrome-filled.vue
import { defineComponent as _defineComponent47 } from "vue";
import { createElementVNode as _createElementVNode47, openBlock as _openBlock47, createElementBlock as _createElementBlock47 } from "vue";
var _sfc_main47 = /* @__PURE__ */ _defineComponent47({
  name: "ChromeFilled",
  __name: "chrome-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock47(), _createElementBlock47("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode47("path", {
        fill: "currentColor",
        d: "M938.7 512c0-44.6-6.9-87.6-19.6-128H682.7a212 212 0 0 1 42.6 128c.1 38.7-10.4 76.7-30.4 109.9L512 938.7c235.7 0 426.7-191 426.7-426.7"
      }),
      _createElementVNode47("path", {
        fill: "currentColor",
        d: "M576.8 401.6a128 128 0 0 0-63.6-17.6 128 128 0 0 0-111.1 62.4 128 128 0 0 0-2.2 127.5l1.3 2.1a128 128 0 0 0 46.3 46.6A128 128 0 0 0 511 640c22.3.2 44.3-5.4 63.7-16.3a128 128 0 0 0 47.2-45.8l1-1.9a128 128 0 0 0 .4-127.5 128 128 0 0 0-46.4-46.9"
      }),
      _createElementVNode47("path", {
        fill: "currentColor",
        d: "M394.5 334A213 213 0 0 1 512 298.7h369.6A427 427 0 0 0 512 85.3a426 426 0 0 0-171.7 36 426 426 0 0 0-142.7 102.2l118.2 204.7a213 213 0 0 1 78.6-94.2m20.4 368a213 213 0 0 1-89.6-86.9L142.5 298.6a426.8 426.8 0 0 0 276.8 630l118.2-204.7a213 213 0 0 1-122.7-22"
      })
    ]));
  }
}), chrome_filled_default = _sfc_main47;

// src/components/circle-check-filled.vue
import { defineComponent as _defineComponent48 } from "vue";
import { createElementVNode as _createElementVNode48, openBlock as _openBlock48, createElementBlock as _createElementBlock48 } from "vue";
var _sfc_main48 = /* @__PURE__ */ _defineComponent48({
  name: "CircleCheckFilled",
  __name: "circle-check-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock48(), _createElementBlock48("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode48("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-55.8 536.4-99.5-99.6a38.4 38.4 0 1 0-54.4 54.3L429.1 682a38.3 38.3 0 0 0 54.3 0l262.4-262.5a38.4 38.4 0 1 0-54.3-54.3z"
    })]));
  }
}), circle_check_filled_default = _sfc_main48;

// src/components/circle-check.vue
import { defineComponent as _defineComponent49 } from "vue";
import { createElementVNode as _createElementVNode49, openBlock as _openBlock49, createElementBlock as _createElementBlock49 } from "vue";
var _sfc_main49 = /* @__PURE__ */ _defineComponent49({
  name: "CircleCheck",
  __name: "circle-check",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock49(), _createElementBlock49("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode49("path", {
      fill: "currentColor",
      d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
    }), _createElementVNode49("path", {
      fill: "currentColor",
      d: "M745.3 361.3a32 32 0 0 1 45.4 45.4l-288 288a32 32 0 0 1-45.4 0l-160-160a32 32 0 1 1 45.4-45.4L480 626.8z"
    })]));
  }
}), circle_check_default = _sfc_main49;

// src/components/circle-close-filled.vue
import { defineComponent as _defineComponent50 } from "vue";
import { createElementVNode as _createElementVNode50, openBlock as _openBlock50, createElementBlock as _createElementBlock50 } from "vue";
var _sfc_main50 = /* @__PURE__ */ _defineComponent50({
  name: "CircleCloseFilled",
  __name: "circle-close-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock50(), _createElementBlock50("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode50("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 393.7L408 353.6a38.4 38.4 0 1 0-54.4 54.3l104 104.1-104 104a38.4 38.4 0 1 0 54.3 54.4l104.1-104 104 104a38.4 38.4 0 1 0 54.4-54.3L566.4 512l104-104a38.4 38.4 0 1 0-54.3-54.4z"
    })]));
  }
}), circle_close_filled_default = _sfc_main50;

// src/components/circle-close.vue
import { defineComponent as _defineComponent51 } from "vue";
import { createElementVNode as _createElementVNode51, openBlock as _openBlock51, createElementBlock as _createElementBlock51 } from "vue";
var _sfc_main51 = /* @__PURE__ */ _defineComponent51({
  name: "CircleClose",
  __name: "circle-close",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock51(), _createElementBlock51("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode51("path", {
      fill: "currentColor",
      d: "m466.8 512-90.5-90.5a32 32 0 0 1 45.2-45.2l90.5 90.5 90.5-90.5a32 32 0 1 1 45.2 45.2L557.2 512l90.5 90.5a32 32 0 1 1-45.2 45.2L512 557.2l-90.5 90.5a32 32 0 0 1-45.2-45.2z"
    }), _createElementVNode51("path", {
      fill: "currentColor",
      d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
    })]));
  }
}), circle_close_default = _sfc_main51;

// src/components/circle-plus-filled.vue
import { defineComponent as _defineComponent52 } from "vue";
import { createElementVNode as _createElementVNode52, openBlock as _openBlock52, createElementBlock as _createElementBlock52 } from "vue";
var _sfc_main52 = /* @__PURE__ */ _defineComponent52({
  name: "CirclePlusFilled",
  __name: "circle-plus-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock52(), _createElementBlock52("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode52("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-38.4 409.6H326.4a38.4 38.4 0 1 0 0 76.8h147.2v147.2a38.4 38.4 0 0 0 76.8 0V550.4h147.2a38.4 38.4 0 0 0 0-76.8H550.4V326.4a38.4 38.4 0 1 0-76.8 0z"
    })]));
  }
}), circle_plus_filled_default = _sfc_main52;

// src/components/circle-plus.vue
import { defineComponent as _defineComponent53 } from "vue";
import { createElementVNode as _createElementVNode53, openBlock as _openBlock53, createElementBlock as _createElementBlock53 } from "vue";
var _sfc_main53 = /* @__PURE__ */ _defineComponent53({
  name: "CirclePlus",
  __name: "circle-plus",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock53(), _createElementBlock53("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode53("path", {
        fill: "currentColor",
        d: "M352 480h320a32 32 0 1 1 0 64H352a32 32 0 0 1 0-64"
      }),
      _createElementVNode53("path", {
        fill: "currentColor",
        d: "M480 672V352a32 32 0 1 1 64 0v320a32 32 0 0 1-64 0"
      }),
      _createElementVNode53("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
}), circle_plus_default = _sfc_main53;

// src/components/clock.vue
import { defineComponent as _defineComponent54 } from "vue";
import { createElementVNode as _createElementVNode54, openBlock as _openBlock54, createElementBlock as _createElementBlock54 } from "vue";
var _sfc_main54 = /* @__PURE__ */ _defineComponent54({
  name: "Clock",
  __name: "clock",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock54(), _createElementBlock54("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode54("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      _createElementVNode54("path", {
        fill: "currentColor",
        d: "M480 256a32 32 0 0 1 32 32v256a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
      }),
      _createElementVNode54("path", {
        fill: "currentColor",
        d: "M480 512h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32"
      })
    ]));
  }
}), clock_default = _sfc_main54;

// src/components/close-bold.vue
import { defineComponent as _defineComponent55 } from "vue";
import { createElementVNode as _createElementVNode55, openBlock as _openBlock55, createElementBlock as _createElementBlock55 } from "vue";
var _sfc_main55 = /* @__PURE__ */ _defineComponent55({
  name: "CloseBold",
  __name: "close-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock55(), _createElementBlock55("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode55("path", {
      fill: "currentColor",
      d: "M195.2 195.2a64 64 0 0 1 90.5 0L512 421.5l226.3-226.3a64 64 0 0 1 90.5 90.5L602.5 512l226.3 226.3a64 64 0 0 1-90.5 90.5L512 602.5 285.7 828.8a64 64 0 0 1-90.5-90.5L421.5 512 195.2 285.7a64 64 0 0 1 0-90.5"
    })]));
  }
}), close_bold_default = _sfc_main55;

// src/components/close.vue
import { defineComponent as _defineComponent56 } from "vue";
import { createElementVNode as _createElementVNode56, openBlock as _openBlock56, createElementBlock as _createElementBlock56 } from "vue";
var _sfc_main56 = /* @__PURE__ */ _defineComponent56({
  name: "Close",
  __name: "close",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock56(), _createElementBlock56("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode56("path", {
      fill: "currentColor",
      d: "M764.3 214.6 512 466.9 259.7 214.6a32 32 0 0 0-45.1 45.1L466.8 512 214.5 764.2a32 32 0 1 0 45.1 45.2L512 557.2l252.3 252.3a32 32 0 0 0 45.1-45.1L557.1 512l252.3-252.4a32 32 0 1 0-45.1-45.2z"
    })]));
  }
}), close_default = _sfc_main56;

// src/components/cloudy.vue
import { defineComponent as _defineComponent57 } from "vue";
import { createElementVNode as _createElementVNode57, openBlock as _openBlock57, createElementBlock as _createElementBlock57 } from "vue";
var _sfc_main57 = /* @__PURE__ */ _defineComponent57({
  name: "Cloudy",
  __name: "cloudy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock57(), _createElementBlock57("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode57("path", {
      fill: "currentColor",
      d: "M598.4 831.9H328.2a256 256 0 0 1-34.5-510.6A352 352 0 1 1 598.4 832m-271.4-64h272.3a288 288 0 1 0-248.5-417.7L335 381.4l-34.8 3.6A192 192 0 0 0 327.1 768z"
    })]));
  }
}), cloudy_default = _sfc_main57;

// src/components/coffee-cup.vue
import { defineComponent as _defineComponent58 } from "vue";
import { createElementVNode as _createElementVNode58, openBlock as _openBlock58, createElementBlock as _createElementBlock58 } from "vue";
var _sfc_main58 = /* @__PURE__ */ _defineComponent58({
  name: "CoffeeCup",
  __name: "coffee-cup",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock58(), _createElementBlock58("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode58("path", {
      fill: "currentColor",
      d: "M768 192a192 192 0 1 1-8 383.8A256 256 0 0 1 512 768H320A256 256 0 0 1 64 512V160a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 64v256a128 128 0 1 0 0-256M96 832h640a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64m32-640v320a192 192 0 0 0 192 192h192a192 192 0 0 0 192-192V192z"
    })]));
  }
}), coffee_cup_default = _sfc_main58;

// src/components/coffee.vue
import { defineComponent as _defineComponent59 } from "vue";
import { createElementVNode as _createElementVNode59, openBlock as _openBlock59, createElementBlock as _createElementBlock59 } from "vue";
var _sfc_main59 = /* @__PURE__ */ _defineComponent59({
  name: "Coffee",
  __name: "coffee",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock59(), _createElementBlock59("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode59("path", {
      fill: "currentColor",
      d: "M822.6 192h14.3a32 32 0 0 1 31.6 26.8l21.3 128a32 32 0 0 1-31.6 37.2H809l-39 546.3a32 32 0 0 1-32 29.7H286a32 32 0 0 1-32-29.7l-39-546.3h-49.1a32 32 0 0 1-31.6-37.2l21.3-128a32 32 0 0 1 31.6-26.8h14l-6.7-93.7a32 32 0 0 1 32-34.3h571a32 32 0 0 1 32 34.3zm-64.1 0 4.5-64H260.7l4.6 64zM210.3 320h610.2l-10.7-64H214.2l-10.7 64zm68.7 64 36.6 512h392.6l36.5-512z"
    })]));
  }
}), coffee_default = _sfc_main59;

// src/components/coin.vue
import { defineComponent as _defineComponent60 } from "vue";
import { createElementVNode as _createElementVNode60, openBlock as _openBlock60, createElementBlock as _createElementBlock60 } from "vue";
var _sfc_main60 = /* @__PURE__ */ _defineComponent60({
  name: "Coin",
  __name: "coin",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock60(), _createElementBlock60("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode60("path", {
        fill: "currentColor",
        d: "m162 580.7 29.8 59c-20.5 20-31.8 42-31.8 64.3 0 82.3 155.3 160 352 160s352-77.7 352-160c0-22.3-11.4-44.2-31.8-64.3l30.5-58.5C903.9 615.8 928 657.7 928 704c0 129.7-188.5 224-416 224S96 833.7 96 704c0-46.6 24.3-88.6 66-123.3"
      }),
      _createElementVNode60("path", {
        fill: "currentColor",
        d: "m162 388.7 29.8 59c-20.5 20.1-31.8 42-31.8 64.3 0 82.3 155.3 160 352 160s352-77.7 352-160c0-22.3-11.4-44.2-31.8-64.3l30.5-58.5C903.9 423.8 928 465.7 928 512c0 129.7-188.5 224-416 224S96 641.7 96 512c0-46.6 24.3-88.6 66-123.3"
      }),
      _createElementVNode60("path", {
        fill: "currentColor",
        d: "M512 544c-227.5 0-416-94.3-416-224S284.5 96 512 96s416 94.3 416 224-188.5 224-416 224m0-64c196.7 0 352-77.7 352-160S708.7 160 512 160s-352 77.7-352 160 155.3 160 352 160"
      })
    ]));
  }
}), coin_default = _sfc_main60;

// src/components/cold-drink.vue
import { defineComponent as _defineComponent61 } from "vue";
import { createElementVNode as _createElementVNode61, openBlock as _openBlock61, createElementBlock as _createElementBlock61 } from "vue";
var _sfc_main61 = /* @__PURE__ */ _defineComponent61({
  name: "ColdDrink",
  __name: "cold-drink",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock61(), _createElementBlock61("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode61("path", {
      fill: "currentColor",
      d: "M768 64a192 192 0 1 1-70 370.9L480 725.4V896h96a32 32 0 1 1 0 64H320a32 32 0 1 1 0-64h96V725.4L76.8 273.5A64 64 0 0 1 64 235.1v-10.7a32 32 0 0 1 32-32h71.8l-65.5-83.8a32 32 0 0 1 50.4-39.4L249 192.4h337.7A192 192 0 0 1 768 64M656.9 192.4H800a32 32 0 0 1 32 32v10.7a64 64 0 0 1-12.8 38.4l-80.4 107.2a128 128 0 1 0-82-188.2zm-357.9 64 129.5 165.8a32 32 0 0 1-50.5 39.4L217.8 256.4H144l304 405 304-405z"
    })]));
  }
}), cold_drink_default = _sfc_main61;

// src/components/collection-tag.vue
import { defineComponent as _defineComponent62 } from "vue";
import { createElementVNode as _createElementVNode62, openBlock as _openBlock62, createElementBlock as _createElementBlock62 } from "vue";
var _sfc_main62 = /* @__PURE__ */ _defineComponent62({
  name: "CollectionTag",
  __name: "collection-tag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock62(), _createElementBlock62("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode62("path", {
      fill: "currentColor",
      d: "M256 128v698.9L452 670a96 96 0 0 1 120 0l196 156.8V128zm-32-64h576a32 32 0 0 1 32 32v797.4a32 32 0 0 1-52 25L532 720a32 32 0 0 0-40 0L244 918.4a32 32 0 0 1-52-25V96a32 32 0 0 1 32-32"
    })]));
  }
}), collection_tag_default = _sfc_main62;

// src/components/collection.vue
import { defineComponent as _defineComponent63 } from "vue";
import { createElementVNode as _createElementVNode63, openBlock as _openBlock63, createElementBlock as _createElementBlock63 } from "vue";
var _sfc_main63 = /* @__PURE__ */ _defineComponent63({
  name: "Collection",
  __name: "collection",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock63(), _createElementBlock63("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode63("path", {
      fill: "currentColor",
      d: "M192 736h640V128H256a64 64 0 0 0-64 64zm64-672h608a32 32 0 0 1 32 32v672a32 32 0 0 1-32 32H160l-32 57.5V192A128 128 0 0 1 256 64"
    }), _createElementVNode63("path", {
      fill: "currentColor",
      d: "M240 800a48 48 0 1 0 0 96h592v-96zm0-64h656v160a64 64 0 0 1-64 64H240a112 112 0 0 1 0-224m144-608v250.9l96-76.8 96 76.8V128zm-64-64h320v381.4a32 32 0 0 1-52 25L480 384l-108 86.4a32 32 0 0 1-52-25z"
    })]));
  }
}), collection_default = _sfc_main63;

// src/components/comment.vue
import { defineComponent as _defineComponent64 } from "vue";
import { createElementVNode as _createElementVNode64, openBlock as _openBlock64, createElementBlock as _createElementBlock64 } from "vue";
var _sfc_main64 = /* @__PURE__ */ _defineComponent64({
  name: "Comment",
  __name: "comment",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock64(), _createElementBlock64("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode64("path", {
      fill: "currentColor",
      d: "M736 504a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112M128 128v640h192v160l224-160h352V128z"
    })]));
  }
}), comment_default = _sfc_main64;

// src/components/compass.vue
import { defineComponent as _defineComponent65 } from "vue";
import { createElementVNode as _createElementVNode65, openBlock as _openBlock65, createElementBlock as _createElementBlock65 } from "vue";
var _sfc_main65 = /* @__PURE__ */ _defineComponent65({
  name: "Compass",
  __name: "compass",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock65(), _createElementBlock65("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode65("path", {
      fill: "currentColor",
      d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
    }), _createElementVNode65("path", {
      fill: "currentColor",
      d: "M725.9 315q-74.1 170.6-157.3 253.6Q485.5 652 315 726a12.8 12.8 0 0 1-16.9-16.9q74.3-170.6 157.3-253.6t253.7-157.3a12.8 12.8 0 0 1 16.8 16.8"
    })]));
  }
}), compass_default = _sfc_main65;

// src/components/connection.vue
import { defineComponent as _defineComponent66 } from "vue";
import { createElementVNode as _createElementVNode66, openBlock as _openBlock66, createElementBlock as _createElementBlock66 } from "vue";
var _sfc_main66 = /* @__PURE__ */ _defineComponent66({
  name: "Connection",
  __name: "connection",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock66(), _createElementBlock66("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode66("path", {
      fill: "currentColor",
      d: "M640 384v64H448a128 128 0 0 0-128 128v128a128 128 0 0 0 128 128h320a128 128 0 0 0 128-128V576a128 128 0 0 0-64-110.8v-70.3a192 192 0 0 1 128 181v128a192 192 0 0 1-192 192H448a192 192 0 0 1-192-192V576a192 192 0 0 1 192-192z"
    }), _createElementVNode66("path", {
      fill: "currentColor",
      d: "M384 640v-64h192a128 128 0 0 0 128-128V320a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v128a128 128 0 0 0 64 110.8v70.3A192 192 0 0 1 64 448V320a192 192 0 0 1 192-192h320a192 192 0 0 1 192 192v128a192 192 0 0 1-192 192z"
    })]));
  }
}), connection_default = _sfc_main66;

// src/components/coordinate.vue
import { defineComponent as _defineComponent67 } from "vue";
import { createElementVNode as _createElementVNode67, openBlock as _openBlock67, createElementBlock as _createElementBlock67 } from "vue";
var _sfc_main67 = /* @__PURE__ */ _defineComponent67({
  name: "Coordinate",
  __name: "coordinate",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock67(), _createElementBlock67("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode67("path", {
      fill: "currentColor",
      d: "M480 512h64v320h-64z"
    }), _createElementVNode67("path", {
      fill: "currentColor",
      d: "M192 896h640a64 64 0 0 0-64-64H256a64 64 0 0 0-64 64m64-128h512a128 128 0 0 1 128 128v64H128v-64a128 128 0 0 1 128-128m256-256a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
    })]));
  }
}), coordinate_default = _sfc_main67;

// src/components/copy-document.vue
import { defineComponent as _defineComponent68 } from "vue";
import { createElementVNode as _createElementVNode68, openBlock as _openBlock68, createElementBlock as _createElementBlock68 } from "vue";
var _sfc_main68 = /* @__PURE__ */ _defineComponent68({
  name: "CopyDocument",
  __name: "copy-document",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock68(), _createElementBlock68("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode68("path", {
      fill: "currentColor",
      d: "M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64z"
    }), _createElementVNode68("path", {
      fill: "currentColor",
      d: "M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64"
    })]));
  }
}), copy_document_default = _sfc_main68;

// src/components/cpu.vue
import { defineComponent as _defineComponent69 } from "vue";
import { createElementVNode as _createElementVNode69, openBlock as _openBlock69, createElementBlock as _createElementBlock69 } from "vue";
var _sfc_main69 = /* @__PURE__ */ _defineComponent69({
  name: "Cpu",
  __name: "cpu",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock69(), _createElementBlock69("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode69("path", {
      fill: "currentColor",
      d: "M320 256a64 64 0 0 0-64 64v384a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V320a64 64 0 0 0-64-64zm0-64h384a128 128 0 0 1 128 128v384a128 128 0 0 1-128 128H320a128 128 0 0 1-128-128V320a128 128 0 0 1 128-128"
    }), _createElementVNode69("path", {
      fill: "currentColor",
      d: "M512 64a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m160 0a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m-320 0a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m160 896a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32m160 0a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32m-320 0a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32M64 512a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m0-160a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m0 320a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m896-160a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32m0-160a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32m0 320a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32"
    })]));
  }
}), cpu_default = _sfc_main69;

// src/components/credit-card.vue
import { defineComponent as _defineComponent70 } from "vue";
import { createElementVNode as _createElementVNode70, openBlock as _openBlock70, createElementBlock as _createElementBlock70 } from "vue";
var _sfc_main70 = /* @__PURE__ */ _defineComponent70({
  name: "CreditCard",
  __name: "credit-card",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock70(), _createElementBlock70("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode70("path", {
      fill: "currentColor",
      d: "M896 324.1c0-42.4-2.5-55.3-9.5-68.5a52 52 0 0 0-22.2-22c-13.1-7.1-26-9.6-68.4-9.6H228.1c-42.4 0-55.3 2.5-68.5 9.5a52 52 0 0 0-22 22.2c-7.1 13.1-9.6 26-9.6 68.4v375.8c0 42.4 2.5 55.3 9.5 68.5a52 52 0 0 0 22.2 22c13.1 7.1 26 9.6 68.4 9.6h567.8c42.4 0 55.3-2.5 68.5-9.5a52 52 0 0 0 22-22.2c7.1-13.1 9.6-26 9.6-68.4zm64 0v375.8c0 57-6 77.8-17 98.6q-17 31.5-48.5 48.4C863 864 853 864 796 864H228c-57 0-77.7-6-98.5-17A116 116 0 0 1 81 798.4C70 777.7 64 757 64 700V324c0-57 5.9-77.7 17-98.5q17-31.6 48.4-48.5c31.4-16.9 41.6-17 98.6-17h567.8c57.1 0 77.8 5.9 98.6 17q31.6 17 48.4 48.4C959.6 256.8 960 267 960 324z"
    }), _createElementVNode70("path", {
      fill: "currentColor",
      d: "M64 320h896v64H64zm0 128h896v64H64zm128 192h256v64H192z"
    })]));
  }
}), credit_card_default = _sfc_main70;

// src/components/crop.vue
import { defineComponent as _defineComponent71 } from "vue";
import { createElementVNode as _createElementVNode71, openBlock as _openBlock71, createElementBlock as _createElementBlock71 } from "vue";
var _sfc_main71 = /* @__PURE__ */ _defineComponent71({
  name: "Crop",
  __name: "crop",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock71(), _createElementBlock71("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode71("path", {
      fill: "currentColor",
      d: "M256 768h672a32 32 0 1 1 0 64H224a32 32 0 0 1-32-32V96a32 32 0 0 1 64 0z"
    }), _createElementVNode71("path", {
      fill: "currentColor",
      d: "M832 224v704a32 32 0 1 1-64 0V256H96a32 32 0 0 1 0-64h704a32 32 0 0 1 32 32"
    })]));
  }
}), crop_default = _sfc_main71;

// src/components/d-arrow-left.vue
import { defineComponent as _defineComponent72 } from "vue";
import { createElementVNode as _createElementVNode72, openBlock as _openBlock72, createElementBlock as _createElementBlock72 } from "vue";
var _sfc_main72 = /* @__PURE__ */ _defineComponent72({
  name: "DArrowLeft",
  __name: "d-arrow-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock72(), _createElementBlock72("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode72("path", {
      fill: "currentColor",
      d: "M529.4 149.4a29 29 0 0 1 41.7 0 30.6 30.6 0 0 1 0 42.7L259.3 511.9 571 832a30.6 30.6 0 0 1-.5 43.2 29 29 0 0 1-41.2-.5L197.8 534.3a32 32 0 0 1 0-44.7zm256 0a29 29 0 0 1 41.7 0 30.6 30.6 0 0 1 0 42.7L515.3 511.9 827 832a30.6 30.6 0 0 1-.5 43.2 29 29 0 0 1-41.2-.5L453.8 534.3a32 32 0 0 1 0-44.7z"
    })]));
  }
}), d_arrow_left_default = _sfc_main72;

// src/components/d-arrow-right.vue
import { defineComponent as _defineComponent73 } from "vue";
import { createElementVNode as _createElementVNode73, openBlock as _openBlock73, createElementBlock as _createElementBlock73 } from "vue";
var _sfc_main73 = /* @__PURE__ */ _defineComponent73({
  name: "DArrowRight",
  __name: "d-arrow-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock73(), _createElementBlock73("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode73("path", {
      fill: "currentColor",
      d: "M452.9 149.3a29 29 0 0 1 41.7 0l331.6 340.4a32 32 0 0 1 0 44.6L494.6 874.6a29 29 0 0 1-41.7 0 30.6 30.6 0 0 1 0-42.7L764.7 512 453 192a30.6 30.6 0 0 1 0-42.7m-256 0a29 29 0 0 1 41.7 0l331.6 340.4a32 32 0 0 1 0 44.6L238.6 874.6a29 29 0 0 1-41.7 0 30.6 30.6 0 0 1 0-42.7L508.7 512 197 192a30.6 30.6 0 0 1 0-42.7"
    })]));
  }
}), d_arrow_right_default = _sfc_main73;

// src/components/d-caret.vue
import { defineComponent as _defineComponent74 } from "vue";
import { createElementVNode as _createElementVNode74, openBlock as _openBlock74, createElementBlock as _createElementBlock74 } from "vue";
var _sfc_main74 = /* @__PURE__ */ _defineComponent74({
  name: "DCaret",
  __name: "d-caret",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock74(), _createElementBlock74("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode74("path", {
      fill: "currentColor",
      d: "m512 128 288 320H224zM224 576h576L512 896z"
    })]));
  }
}), d_caret_default = _sfc_main74;

// src/components/data-analysis.vue
import { defineComponent as _defineComponent75 } from "vue";
import { createElementVNode as _createElementVNode75, openBlock as _openBlock75, createElementBlock as _createElementBlock75 } from "vue";
var _sfc_main75 = /* @__PURE__ */ _defineComponent75({
  name: "DataAnalysis",
  __name: "data-analysis",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock75(), _createElementBlock75("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode75("path", {
      fill: "currentColor",
      d: "m665.2 768 110.9 192h-73.9L591.4 768H433L322.2 960h-73.9l110.9-192H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32zM832 192H192v512h640zM352 448a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0v-64a32 32 0 0 1 32-32m160-64a32 32 0 0 1 32 32v128a32 32 0 0 1-64 0V416a32 32 0 0 1 32-32m160-64a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V352a32 32 0 0 1 32-32"
    })]));
  }
}), data_analysis_default = _sfc_main75;

// src/components/data-board.vue
import { defineComponent as _defineComponent76 } from "vue";
import { createElementVNode as _createElementVNode76, openBlock as _openBlock76, createElementBlock as _createElementBlock76 } from "vue";
var _sfc_main76 = /* @__PURE__ */ _defineComponent76({
  name: "DataBoard",
  __name: "data-board",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock76(), _createElementBlock76("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode76("path", {
        fill: "currentColor",
        d: "M32 128h960v64H32z"
      }),
      _createElementVNode76("path", {
        fill: "currentColor",
        d: "M192 192v512h640V192zm-64-64h768v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32z"
      }),
      _createElementVNode76("path", {
        fill: "currentColor",
        d: "M322.2 960h-73.9L393 709.4l55.4 32zm453.9 0h-73.9L576 741.4l55.4-32z"
      })
    ]));
  }
}), data_board_default = _sfc_main76;

// src/components/data-line.vue
import { defineComponent as _defineComponent77 } from "vue";
import { createElementVNode as _createElementVNode77, openBlock as _openBlock77, createElementBlock as _createElementBlock77 } from "vue";
var _sfc_main77 = /* @__PURE__ */ _defineComponent77({
  name: "DataLine",
  __name: "data-line",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock77(), _createElementBlock77("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode77("path", {
      fill: "currentColor",
      d: "M359.2 768H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32H665.2l110.9 192h-73.9L591.4 768H433L322.2 960h-73.9zM832 192H192v512h640zM342.7 534.7a32 32 0 1 1-45.4-45.4L445 341.8l125.4 94L679 300a32 32 0 1 1 50 40L581.6 524.2l-130.6-98-108.3 108.4z"
    })]));
  }
}), data_line_default = _sfc_main77;

// src/components/delete-filled.vue
import { defineComponent as _defineComponent78 } from "vue";
import { createElementVNode as _createElementVNode78, openBlock as _openBlock78, createElementBlock as _createElementBlock78 } from "vue";
var _sfc_main78 = /* @__PURE__ */ _defineComponent78({
  name: "DeleteFilled",
  __name: "delete-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock78(), _createElementBlock78("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode78("path", {
      fill: "currentColor",
      d: "M352 192V96a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v96h256a32 32 0 1 1 0 64H96a32 32 0 0 1 0-64zm64 0h192v-64H416zM192 960a32 32 0 0 1-32-32V256h704v672a32 32 0 0 1-32 32zm224-192a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32m192 0a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32"
    })]));
  }
}), delete_filled_default = _sfc_main78;

// src/components/delete-location.vue
import { defineComponent as _defineComponent79 } from "vue";
import { createElementVNode as _createElementVNode79, openBlock as _openBlock79, createElementBlock as _createElementBlock79 } from "vue";
var _sfc_main79 = /* @__PURE__ */ _defineComponent79({
  name: "DeleteLocation",
  __name: "delete-location",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock79(), _createElementBlock79("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode79("path", {
        fill: "currentColor",
        d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      _createElementVNode79("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.1 94.5 272.1 288 456.6C705.5 688 800 534 800 416M512 960Q160 640 160 416a352 352 0 0 1 704 0q0 224-352 544"
      }),
      _createElementVNode79("path", {
        fill: "currentColor",
        d: "M384 384h256q32 0 32 32t-32 32H384q-32 0-32-32t32-32"
      })
    ]));
  }
}), delete_location_default = _sfc_main79;

// src/components/delete.vue
import { defineComponent as _defineComponent80 } from "vue";
import { createElementVNode as _createElementVNode80, openBlock as _openBlock80, createElementBlock as _createElementBlock80 } from "vue";
var _sfc_main80 = /* @__PURE__ */ _defineComponent80({
  name: "Delete",
  __name: "delete",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock80(), _createElementBlock80("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode80("path", {
      fill: "currentColor",
      d: "M160 256H96a32 32 0 0 1 0-64h256V96a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v96h256a32 32 0 1 1 0 64h-64v672a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32zm448-64v-64H416v64zM224 896h576V256H224zm192-128a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32m192 0a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32"
    })]));
  }
}), delete_default = _sfc_main80;

// src/components/dessert.vue
import { defineComponent as _defineComponent81 } from "vue";
import { createElementVNode as _createElementVNode81, openBlock as _openBlock81, createElementBlock as _createElementBlock81 } from "vue";
var _sfc_main81 = /* @__PURE__ */ _defineComponent81({
  name: "Dessert",
  __name: "dessert",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock81(), _createElementBlock81("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode81("path", {
      fill: "currentColor",
      d: "M128 416v-48a144 144 0 0 1 168.6-141.9 224.1 224.1 0 0 1 430.8 0A144 144 0 0 1 896 368v48a384 384 0 0 1-352 382.7V896h-64v-97.3A384 384 0 0 1 128 416m287.1-32h193.8a144 144 0 0 1 58.9-132.8 160 160 0 0 0-311.6 0A144 144 0 0 1 415.1 384zm-72.9 0a72 72 0 1 0-140.5 0zm339.6 0h140.4a72 72 0 1 0-140.5 0zM512 736a320 320 0 0 0 318.4-288H193.6A320 320 0 0 0 512 736M384 896h256a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64"
    })]));
  }
}), dessert_default = _sfc_main81;

// src/components/discount.vue
import { defineComponent as _defineComponent82 } from "vue";
import { createElementVNode as _createElementVNode82, openBlock as _openBlock82, createElementBlock as _createElementBlock82 } from "vue";
var _sfc_main82 = /* @__PURE__ */ _defineComponent82({
  name: "Discount",
  __name: "discount",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock82(), _createElementBlock82("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode82("path", {
      fill: "currentColor",
      d: "M224 704h576V318.3L552.5 115.8a64 64 0 0 0-81 0L224 318.3zm0 64v128h576V768zM593 66.3l259.2 212.1a32 32 0 0 1 11.8 24.8V928a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V303.2a32 32 0 0 1 11.7-24.8L431 66.3a128 128 0 0 1 162.1 0"
    }), _createElementVNode82("path", {
      fill: "currentColor",
      d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
    })]));
  }
}), discount_default = _sfc_main82;

// src/components/dish-dot.vue
import { defineComponent as _defineComponent83 } from "vue";
import { createElementVNode as _createElementVNode83, openBlock as _openBlock83, createElementBlock as _createElementBlock83 } from "vue";
var _sfc_main83 = /* @__PURE__ */ _defineComponent83({
  name: "DishDot",
  __name: "dish-dot",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock83(), _createElementBlock83("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode83("path", {
      fill: "currentColor",
      d: "m384 274.6.1-50.7A128 128 0 0 1 512.1 96c70.6 0 127.7 57.2 127.7 127.7v50.7A448 448 0 0 1 955.4 768H68.5A448 448 0 0 1 384 274.6zM96 832h832a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64m32-128h768a384 384 0 1 0-768 0m447.8-448v-32.3a63.7 63.7 0 0 0-63.7-63.7 64 64 0 0 0-64 64v32z"
    })]));
  }
}), dish_dot_default = _sfc_main83;

// src/components/dish.vue
import { defineComponent as _defineComponent84 } from "vue";
import { createElementVNode as _createElementVNode84, openBlock as _openBlock84, createElementBlock as _createElementBlock84 } from "vue";
var _sfc_main84 = /* @__PURE__ */ _defineComponent84({
  name: "Dish",
  __name: "dish",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock84(), _createElementBlock84("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode84("path", {
      fill: "currentColor",
      d: "M480 257.2V192h-96a32 32 0 0 1 0-64h256a32 32 0 1 1 0 64h-96v65.2A448 448 0 0 1 955.5 768h-887A448 448 0 0 1 480 257.2M128 704h768a384 384 0 1 0-768 0M96 832h832a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64"
    })]));
  }
}), dish_default = _sfc_main84;

// src/components/document-add.vue
import { defineComponent as _defineComponent85 } from "vue";
import { createElementVNode as _createElementVNode85, openBlock as _openBlock85, createElementBlock as _createElementBlock85 } from "vue";
var _sfc_main85 = /* @__PURE__ */ _defineComponent85({
  name: "DocumentAdd",
  __name: "document-add",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock85(), _createElementBlock85("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode85("path", {
      fill: "currentColor",
      d: "M832 384H576V128H192v768h640zm-26.5-64L640 154.5V320zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m320 512V448h64v128h128v64H544v128h-64V640H352v-64z"
    })]));
  }
}), document_add_default = _sfc_main85;

// src/components/document-checked.vue
import { defineComponent as _defineComponent86 } from "vue";
import { createElementVNode as _createElementVNode86, openBlock as _openBlock86, createElementBlock as _createElementBlock86 } from "vue";
var _sfc_main86 = /* @__PURE__ */ _defineComponent86({
  name: "DocumentChecked",
  __name: "document-checked",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock86(), _createElementBlock86("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode86("path", {
      fill: "currentColor",
      d: "M805.5 320 640 154.5V320zm26.5 64H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m318.4 582.1 181-181 45.2 45.3-226.2 226.2L320 578.3l45.2-45.3z"
    })]));
  }
}), document_checked_default = _sfc_main86;

// src/components/document-copy.vue
import { defineComponent as _defineComponent87 } from "vue";
import { createElementVNode as _createElementVNode87, openBlock as _openBlock87, createElementBlock as _createElementBlock87 } from "vue";
var _sfc_main87 = /* @__PURE__ */ _defineComponent87({
  name: "DocumentCopy",
  __name: "document-copy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock87(), _createElementBlock87("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode87("path", {
      fill: "currentColor",
      d: "M128 320v576h576V320zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32M960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32M256 672h320v64H256zm0-192h320v64H256z"
    })]));
  }
}), document_copy_default = _sfc_main87;

// src/components/document-delete.vue
import { defineComponent as _defineComponent88 } from "vue";
import { createElementVNode as _createElementVNode88, openBlock as _openBlock88, createElementBlock as _createElementBlock88 } from "vue";
var _sfc_main88 = /* @__PURE__ */ _defineComponent88({
  name: "DocumentDelete",
  __name: "document-delete",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock88(), _createElementBlock88("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode88("path", {
      fill: "currentColor",
      d: "M805.5 320 640 154.5V320zm26.5 64H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m309 546.3-90.5-90.6 45.2-45.3 90.6 90.5 90.5-90.4 45.2 45.2-90.4 90.6 90.4 90.5-45.2 45.2-90.5-90.4-90.6 90.4-45.2-45.2z"
    })]));
  }
}), document_delete_default = _sfc_main88;

// src/components/document-remove.vue
import { defineComponent as _defineComponent89 } from "vue";
import { createElementVNode as _createElementVNode89, openBlock as _openBlock89, createElementBlock as _createElementBlock89 } from "vue";
var _sfc_main89 = /* @__PURE__ */ _defineComponent89({
  name: "DocumentRemove",
  __name: "document-remove",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock89(), _createElementBlock89("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode89("path", {
      fill: "currentColor",
      d: "M805.5 320 640 154.5V320zm26.5 64H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m192 512h320v64H352z"
    })]));
  }
}), document_remove_default = _sfc_main89;

// src/components/document.vue
import { defineComponent as _defineComponent90 } from "vue";
import { createElementVNode as _createElementVNode90, openBlock as _openBlock90, createElementBlock as _createElementBlock90 } from "vue";
var _sfc_main90 = /* @__PURE__ */ _defineComponent90({
  name: "Document",
  __name: "document",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock90(), _createElementBlock90("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode90("path", {
      fill: "currentColor",
      d: "M832 384H576V128H192v768h640zm-26.5-64L640 154.5V320zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m160 448h384v64H320zm0-192h160v64H320zm0 384h384v64H320z"
    })]));
  }
}), document_default = _sfc_main90;

// src/components/download.vue
import { defineComponent as _defineComponent91 } from "vue";
import { createElementVNode as _createElementVNode91, openBlock as _openBlock91, createElementBlock as _createElementBlock91 } from "vue";
var _sfc_main91 = /* @__PURE__ */ _defineComponent91({
  name: "Download",
  __name: "download",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock91(), _createElementBlock91("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode91("path", {
      fill: "currentColor",
      d: "M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m384-253.7L780.3 342l45.2 45.2L508.8 704 192 387.2l45.2-45.2L480 584.7V128h64z"
    })]));
  }
}), download_default = _sfc_main91;

// src/components/drizzling.vue
import { defineComponent as _defineComponent92 } from "vue";
import { createElementVNode as _createElementVNode92, openBlock as _openBlock92, createElementBlock as _createElementBlock92 } from "vue";
var _sfc_main92 = /* @__PURE__ */ _defineComponent92({
  name: "Drizzling",
  __name: "drizzling",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock92(), _createElementBlock92("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode92("path", {
      fill: "currentColor",
      d: "m739.3 291.3-35.2-6.6-12.8-33.4a192 192 0 0 0-366 23.3l-9.8 40.9-41.5 7a176 176 0 0 0-146.3 173.6c0 97.2 78.8 175.9 175.9 175.9h400a192 192 0 0 0 35.7-380.7M959.6 480a256 256 0 0 1-256 256h-400A240 240 0 0 1 63.7 496.2a240 240 0 0 1 199.5-236.8 256.1 256.1 0 0 1 487.9-31A256 256 0 0 1 959.6 480M288 800h64v64h-64zm192 0h64v64h-64zm-96 96h64v64h-64zm192 0h64v64h-64zm96-96h64v64h-64z"
    })]));
  }
}), drizzling_default = _sfc_main92;

// src/components/edit-pen.vue
import { defineComponent as _defineComponent93 } from "vue";
import { createElementVNode as _createElementVNode93, openBlock as _openBlock93, createElementBlock as _createElementBlock93 } from "vue";
var _sfc_main93 = /* @__PURE__ */ _defineComponent93({
  name: "EditPen",
  __name: "edit-pen",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock93(), _createElementBlock93("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode93("path", {
      fill: "currentColor",
      d: "m199 672.6 194 112 224-388-193.9-112-224 388.1zm-23.8 60.2L208 881.1 353 835.4zM455 229.2l194 112 56.7-98-194-112zM104.3 708.8l384-665 304.8 176-384 665h.1l-248.4 78.3zm384 254.3v-64h448v64z"
    })]));
  }
}), edit_pen_default = _sfc_main93;

// src/components/edit.vue
import { defineComponent as _defineComponent94 } from "vue";
import { createElementVNode as _createElementVNode94, openBlock as _openBlock94, createElementBlock as _createElementBlock94 } from "vue";
var _sfc_main94 = /* @__PURE__ */ _defineComponent94({
  name: "Edit",
  __name: "edit",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock94(), _createElementBlock94("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode94("path", {
      fill: "currentColor",
      d: "M832 512a32 32 0 1 1 64 0v352a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h352a32 32 0 0 1 0 64H192v640h640z"
    }), _createElementVNode94("path", {
      fill: "currentColor",
      d: "m470 554.2 52.8-7.5L847 222.4a32 32 0 1 0-45.2-45.2L477.4 501.4l-7.5 52.8zm422.4-422.4a96 96 0 0 1 0 135.8L560.5 599.5a32 32 0 0 1-18.1 9l-105.6 15.2a32 32 0 0 1-36.2-36.2l15-105.6a32 32 0 0 1 9.1-18.2l332-331.8a96 96 0 0 1 135.7 0z"
    })]));
  }
}), edit_default = _sfc_main94;

// src/components/eleme-filled.vue
import { defineComponent as _defineComponent95 } from "vue";
import { createElementVNode as _createElementVNode95, openBlock as _openBlock95, createElementBlock as _createElementBlock95 } from "vue";
var _sfc_main95 = /* @__PURE__ */ _defineComponent95({
  name: "ElemeFilled",
  __name: "eleme-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock95(), _createElementBlock95("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode95("path", {
      fill: "currentColor",
      d: "M176 64h672a112 112 0 0 1 112 112v672a112 112 0 0 1-112 112H176A112 112 0 0 1 64 848V176A112 112 0 0 1 176 64m150.5 173.6a331 331 0 0 0-97.4 457 330.7 330.7 0 0 0 457 96.6c9.2-6 17.6-11.8 25.1-18.6a18 18 0 0 0 4.3-24.3l-15.1-23.5a47.6 47.6 0 0 0-65.6-14.3 234.6 234.6 0 0 1-324.2-68.9 236 236 0 0 1 68.9-325.1 234 234 0 0 1 276.3 15.1c1.7.9 2.6 2.6 3.4 4.3 5.9 8.4 3.3 19.3-5.1 25.2L456.8 489.6a47.6 47.6 0 0 0-14.3 65.5l16 24.4a18 18 0 0 0 25.2 5l308.2-200a19.6 19.6 0 0 0 6.8-23.4v-1c-5-9.1-10-17.5-15.1-26.8a332 332 0 0 0-457-95.7zM787 504.7 724.7 545c-8.3 6-11 16.8-5 25.2l40.3 62.1c5.9 8.5 16.8 11 25.2 5.1l31-20.1a55.4 55.4 0 0 0 16-76.5l-20.2-31a19.5 19.5 0 0 0-25.1-5.2z"
    })]));
  }
}), eleme_filled_default = _sfc_main95;

// src/components/eleme.vue
import { defineComponent as _defineComponent96 } from "vue";
import { createElementVNode as _createElementVNode96, openBlock as _openBlock96, createElementBlock as _createElementBlock96 } from "vue";
var _sfc_main96 = /* @__PURE__ */ _defineComponent96({
  name: "Eleme",
  __name: "eleme",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock96(), _createElementBlock96("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode96("path", {
      fill: "currentColor",
      d: "M300 188.8a379.4 379.4 0 0 1 522.3 109.4c5.7 10.6 11.5 20.2 17.3 30.8v1a22.4 22.4 0 0 1-7.7 26.8L479.6 585.3c-9.6 6.7-22.1 3.8-28.8-5.8l-18.3-27.8a54.3 54.3 0 0 1 16.3-74.9l225.6-146.9c9.6-6.7 12.5-19.2 5.8-28.8-1-1.9-2-3.8-3.8-4.8A268 268 0 0 0 360.5 279a269.4 269.4 0 0 0-78.7 371.6 268 268 0 0 0 370.6 78.7 54.3 54.3 0 0 1 74.8 16.3l17.3 26.9a21 21 0 0 1-4.8 27.8 223 223 0 0 1-28.8 21.1A378 378 0 0 1 188.7 711 378 378 0 0 1 300 188.8m526.1 305.3a22.3 22.3 0 0 1 28.8 5.7l23 35.6a63 63 0 0 1-18.2 87.3l-35.5 23c-9.6 6.8-22 3.9-28.8-5.7l-46-71c-6.8-9.6-4-22.1 5.7-28.8z"
    })]));
  }
}), eleme_default = _sfc_main96;

// src/components/element-plus.vue
import { defineComponent as _defineComponent97 } from "vue";
import { createElementVNode as _createElementVNode97, openBlock as _openBlock97, createElementBlock as _createElementBlock97 } from "vue";
var _sfc_main97 = /* @__PURE__ */ _defineComponent97({
  name: "ElementPlus",
  __name: "element-plus",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock97(), _createElementBlock97("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode97("path", {
      fill: "currentColor",
      d: "M839.7 734.7c0 33.3-17.9 41-17.9 41S519.7 949.8 499.2 960a33 33 0 0 1-30.7 0S153.6 775.7 143.4 768a56 56 0 0 1-12.8-20.5V368.6c0-17.9 20.5-28.2 20.5-28.2L466 158.6q19.2-7.6 38.4 0s279 161.3 309.8 179.2a43 43 0 0 1 25.6 46.1c-.1-5-.1 317.5-.1 350.8M714.2 371.2c-64-35.8-217.6-125.4-217.6-125.4-7.7-5.1-20.5-5.1-30.7 0L217.6 389.1s-17.9 10.2-17.9 23v297c0 5.1 5.1 12.8 7.7 17.9 7.7 5.1 256 148.5 256 148.5a23 23 0 0 0 25.6 0c15.4-7.7 250.9-145.9 250.9-145.9s12.8-5.1 12.8-30.7v-74.2l-276.5 169v-64c0-17.9 7.7-30.7 20.5-46.1L745 535a63 63 0 0 0 10.2-30.7v-66.6l-279 169v-69.1c0-15.4 5.1-30.7 17.9-38.4zM919 135.7c0-5.1-5.1-7.7-7.7-7.7h-58.9V66.6c0-5.1-5.1-5.1-10.2-5.1l-30.7 5.1c-5.1 0-5.1 2.6-5.1 5.1V128h-56.3c-5.1 0-5.1 5.1-7.7 5.1v38.4h69.1v64c0 5.1 5.1 5.1 10.2 5.1l30.7-5.1c5.1 0 5.1-2.6 5.1-5.1v-56.3h64z"
    })]));
  }
}), element_plus_default = _sfc_main97;

// src/components/expand.vue
import { defineComponent as _defineComponent98 } from "vue";
import { createElementVNode as _createElementVNode98, openBlock as _openBlock98, createElementBlock as _createElementBlock98 } from "vue";
var _sfc_main98 = /* @__PURE__ */ _defineComponent98({
  name: "Expand",
  __name: "expand",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock98(), _createElementBlock98("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode98("path", {
      fill: "currentColor",
      d: "M128 192h768v128H128zm0 256h512v128H128zm0 256h768v128H128zm576-352 192 160-192 128z"
    })]));
  }
}), expand_default = _sfc_main98;

// src/components/failed.vue
import { defineComponent as _defineComponent99 } from "vue";
import { createElementVNode as _createElementVNode99, openBlock as _openBlock99, createElementBlock as _createElementBlock99 } from "vue";
var _sfc_main99 = /* @__PURE__ */ _defineComponent99({
  name: "Failed",
  __name: "failed",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock99(), _createElementBlock99("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode99("path", {
      fill: "currentColor",
      d: "M557.2 608 693 472.3 647.7 427 512.1 562.8 376.3 427 331 472.3 466.8 608 331 743.7l45.2 45.3L512 653.2 647.7 789l45.3-45.3L557.3 608zM704 192h160v736H160V192h160v64h384zm-320 0V96h256v96z"
    })]));
  }
}), failed_default = _sfc_main99;

// src/components/female.vue
import { defineComponent as _defineComponent100 } from "vue";
import { createElementVNode as _createElementVNode100, openBlock as _openBlock100, createElementBlock as _createElementBlock100 } from "vue";
var _sfc_main100 = /* @__PURE__ */ _defineComponent100({
  name: "Female",
  __name: "female",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock100(), _createElementBlock100("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode100("path", {
        fill: "currentColor",
        d: "M512 640a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
      }),
      _createElementVNode100("path", {
        fill: "currentColor",
        d: "M512 640q32 0 32 32v256q0 32-32 32t-32-32V672q0-32 32-32"
      }),
      _createElementVNode100("path", {
        fill: "currentColor",
        d: "M352 800h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32"
      })
    ]));
  }
}), female_default = _sfc_main100;

// src/components/files.vue
import { defineComponent as _defineComponent101 } from "vue";
import { createElementVNode as _createElementVNode101, openBlock as _openBlock101, createElementBlock as _createElementBlock101 } from "vue";
var _sfc_main101 = /* @__PURE__ */ _defineComponent101({
  name: "Files",
  __name: "files",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock101(), _createElementBlock101("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode101("path", {
      fill: "currentColor",
      d: "M128 384v448h768V384zm-32-64h832a32 32 0 0 1 32 32v512a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32m64-128h704v64H160zm96-128h512v64H256z"
    })]));
  }
}), files_default = _sfc_main101;

// src/components/film.vue
import { defineComponent as _defineComponent102 } from "vue";
import { createElementVNode as _createElementVNode102, openBlock as _openBlock102, createElementBlock as _createElementBlock102 } from "vue";
var _sfc_main102 = /* @__PURE__ */ _defineComponent102({
  name: "Film",
  __name: "film",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock102(), _createElementBlock102("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode102("path", {
      fill: "currentColor",
      d: "M160 160v704h704V160zm-32-64h768a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32"
    }), _createElementVNode102("path", {
      fill: "currentColor",
      d: "M320 288V128h64v352h256V128h64v160h160v64H704v128h160v64H704v128h160v64H704v160h-64V544H384v352h-64V736H128v-64h192V544H128v-64h192V352H128v-64z"
    })]));
  }
}), film_default = _sfc_main102;

// src/components/filter.vue
import { defineComponent as _defineComponent103 } from "vue";
import { createElementVNode as _createElementVNode103, openBlock as _openBlock103, createElementBlock as _createElementBlock103 } from "vue";
var _sfc_main103 = /* @__PURE__ */ _defineComponent103({
  name: "Filter",
  __name: "filter",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock103(), _createElementBlock103("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode103("path", {
      fill: "currentColor",
      d: "M384 523.4V928a32 32 0 0 0 46.3 28.6l192-96A32 32 0 0 0 640 832V523.4l280.8-343.1a32 32 0 1 0-49.6-40.6l-288 352A32 32 0 0 0 576 512v300.2l-128 64V512a32 32 0 0 0-7.2-20.3L195.5 192H704a32 32 0 1 0 0-64H128a32 32 0 0 0-24.8 52.3z"
    })]));
  }
}), filter_default = _sfc_main103;

// src/components/finished.vue
import { defineComponent as _defineComponent104 } from "vue";
import { createElementVNode as _createElementVNode104, openBlock as _openBlock104, createElementBlock as _createElementBlock104 } from "vue";
var _sfc_main104 = /* @__PURE__ */ _defineComponent104({
  name: "Finished",
  __name: "finished",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock104(), _createElementBlock104("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode104("path", {
      fill: "currentColor",
      d: "M280.8 753.7 691.5 167a32 32 0 1 1 52.4 36.7L314.2 817.5a32 32 0 0 1-45.4 7.3L38.4 652a32 32 0 0 1 38.4-51.2zM736 448a32 32 0 1 1 0-64h192a32 32 0 1 1 0 64zM608 640a32 32 0 0 1 0-64h320a32 32 0 1 1 0 64zM480 832a32 32 0 1 1 0-64h448a32 32 0 1 1 0 64z"
    })]));
  }
}), finished_default = _sfc_main104;

// src/components/first-aid-kit.vue
import { defineComponent as _defineComponent105 } from "vue";
import { createElementVNode as _createElementVNode105, openBlock as _openBlock105, createElementBlock as _createElementBlock105 } from "vue";
var _sfc_main105 = /* @__PURE__ */ _defineComponent105({
  name: "FirstAidKit",
  __name: "first-aid-kit",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock105(), _createElementBlock105("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode105("path", {
      fill: "currentColor",
      d: "M192 256a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V320a64 64 0 0 0-64-64zm0-64h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128"
    }), _createElementVNode105("path", {
      fill: "currentColor",
      d: "M544 512h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96v-96a32 32 0 0 1 64 0zM352 128v64h320v-64zm-32-64h384a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32H320a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
    })]));
  }
}), first_aid_kit_default = _sfc_main105;

// src/components/flag.vue
import { defineComponent as _defineComponent106 } from "vue";
import { createElementVNode as _createElementVNode106, openBlock as _openBlock106, createElementBlock as _createElementBlock106 } from "vue";
var _sfc_main106 = /* @__PURE__ */ _defineComponent106({
  name: "Flag",
  __name: "flag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock106(), _createElementBlock106("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode106("path", {
      fill: "currentColor",
      d: "M288 128h608L736 384l160 256H288v320h-96V64h96z"
    })]));
  }
}), flag_default = _sfc_main106;

// src/components/fold.vue
import { defineComponent as _defineComponent107 } from "vue";
import { createElementVNode as _createElementVNode107, openBlock as _openBlock107, createElementBlock as _createElementBlock107 } from "vue";
var _sfc_main107 = /* @__PURE__ */ _defineComponent107({
  name: "Fold",
  __name: "fold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock107(), _createElementBlock107("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode107("path", {
      fill: "currentColor",
      d: "M896 192H128v128h768zm0 256H384v128h512zm0 256H128v128h768zM320 384 128 512l192 128z"
    })]));
  }
}), fold_default = _sfc_main107;

// src/components/folder-add.vue
import { defineComponent as _defineComponent108 } from "vue";
import { createElementVNode as _createElementVNode108, openBlock as _openBlock108, createElementBlock as _createElementBlock108 } from "vue";
var _sfc_main108 = /* @__PURE__ */ _defineComponent108({
  name: "FolderAdd",
  __name: "folder-add",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock108(), _createElementBlock108("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode108("path", {
      fill: "currentColor",
      d: "M128 192v640h768V320H485.8L357.5 192zm-32-64h287.9l128.4 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m384 416V416h64v128h128v64H544v128h-64V608H352v-64z"
    })]));
  }
}), folder_add_default = _sfc_main108;

// src/components/folder-checked.vue
import { defineComponent as _defineComponent109 } from "vue";
import { createElementVNode as _createElementVNode109, openBlock as _openBlock109, createElementBlock as _createElementBlock109 } from "vue";
var _sfc_main109 = /* @__PURE__ */ _defineComponent109({
  name: "FolderChecked",
  __name: "folder-checked",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock109(), _createElementBlock109("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode109("path", {
      fill: "currentColor",
      d: "M128 192v640h768V320H485.8L357.5 192zm-32-64h287.9l128.4 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m414 502.1 181-181 45.3 45.3-226.2 226.2-158.4-158.3 45.2-45.3z"
    })]));
  }
}), folder_checked_default = _sfc_main109;

// src/components/folder-delete.vue
import { defineComponent as _defineComponent110 } from "vue";
import { createElementVNode as _createElementVNode110, openBlock as _openBlock110, createElementBlock as _createElementBlock110 } from "vue";
var _sfc_main110 = /* @__PURE__ */ _defineComponent110({
  name: "FolderDelete",
  __name: "folder-delete",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock110(), _createElementBlock110("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode110("path", {
      fill: "currentColor",
      d: "M128 192v640h768V320H485.8L357.5 192zm-32-64h287.9l128.4 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m370.8 448-90.5-90.5 45.2-45.2 90.5 90.5 90.5-90.5 45.2 45.2-90.5 90.5 90.5 90.5-45.2 45.2-90.5-90.5-90.5 90.5-45.2-45.2z"
    })]));
  }
}), folder_delete_default = _sfc_main110;

// src/components/folder-opened.vue
import { defineComponent as _defineComponent111 } from "vue";
import { createElementVNode as _createElementVNode111, openBlock as _openBlock111, createElementBlock as _createElementBlock111 } from "vue";
var _sfc_main111 = /* @__PURE__ */ _defineComponent111({
  name: "FolderOpened",
  __name: "folder-opened",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock111(), _createElementBlock111("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode111("path", {
      fill: "currentColor",
      d: "M878 448H242l-96 384h636zm-46-64v-64H485.8L357.5 192H128v448l58-231.7a32 32 0 0 1 31-24.3zm-25 512H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h287.9l128.4 128H864a32 32 0 0 1 32 32v96h23a32 32 0 0 1 31 39.7l-112 448a32 32 0 0 1-31 24.3"
    })]));
  }
}), folder_opened_default = _sfc_main111;

// src/components/folder-remove.vue
import { defineComponent as _defineComponent112 } from "vue";
import { createElementVNode as _createElementVNode112, openBlock as _openBlock112, createElementBlock as _createElementBlock112 } from "vue";
var _sfc_main112 = /* @__PURE__ */ _defineComponent112({
  name: "FolderRemove",
  __name: "folder-remove",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock112(), _createElementBlock112("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode112("path", {
      fill: "currentColor",
      d: "M128 192v640h768V320H485.8L357.5 192zm-32-64h287.9l128.4 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m256 416h320v64H352z"
    })]));
  }
}), folder_remove_default = _sfc_main112;

// src/components/folder.vue
import { defineComponent as _defineComponent113 } from "vue";
import { createElementVNode as _createElementVNode113, openBlock as _openBlock113, createElementBlock as _createElementBlock113 } from "vue";
var _sfc_main113 = /* @__PURE__ */ _defineComponent113({
  name: "Folder",
  __name: "folder",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock113(), _createElementBlock113("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode113("path", {
      fill: "currentColor",
      d: "M128 192v640h768V320H485.8L357.5 192zm-32-64h287.9l128.4 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32"
    })]));
  }
}), folder_default = _sfc_main113;

// src/components/food.vue
import { defineComponent as _defineComponent114 } from "vue";
import { createElementVNode as _createElementVNode114, openBlock as _openBlock114, createElementBlock as _createElementBlock114 } from "vue";
var _sfc_main114 = /* @__PURE__ */ _defineComponent114({
  name: "Food",
  __name: "food",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock114(), _createElementBlock114("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode114("path", {
      fill: "currentColor",
      d: "M128 352.6v-.6a288 288 0 0 1 491-204.2 192 192 0 0 1 274.3 204.5 64 64 0 0 1 57.2 74.2Q907.1 687.5 736 757v43a96 96 0 0 1-96 96H384a96 96 0 0 1-96-96v-43Q117 687.5 73.5 426.5a64 64 0 0 1 54.5-73.9zm64-.6h64a160 160 0 0 1 320 0h64a224 224 0 0 0-448 0m128 0h192a96 96 0 0 0-192 0m439.4 0H828a128.3 128.3 0 0 0-124-160 127 127 0 0 0-43.5 7.6 292 292 0 0 1 27.8 58.3 64.1 64.1 0 0 1 71.1 94.1M672 768H352v32a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32zm-342.5-64h365c101.5-32.6 165.8-125 193-288h-751c27.2 163 91.5 255.4 193 288"
    })]));
  }
}), food_default = _sfc_main114;

// src/components/football.vue
import { defineComponent as _defineComponent115 } from "vue";
import { createElementVNode as _createElementVNode115, openBlock as _openBlock115, createElementBlock as _createElementBlock115 } from "vue";
var _sfc_main115 = /* @__PURE__ */ _defineComponent115({
  name: "Football",
  __name: "football",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock115(), _createElementBlock115("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode115("path", {
      fill: "currentColor",
      d: "M512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896m0-64a384 384 0 1 0 0-768 384 384 0 0 0 0 768"
    }), _createElementVNode115("path", {
      fill: "currentColor",
      d: "M186.8 268.3q24-24.7 47-46a321 321 0 0 0 66 81.2l-32.5 56.4a386 386 0 0 1-80.5-91.6m653.7-5.3a386 386 0 0 1-83.8 97l-32.5-56.4a323 323 0 0 0 68.5-85.8q23.4 21 47.8 45.2M466 445.2l11.1-63a324 324 0 0 0 69.8 0l11.1 63a388 388 0 0 1-92 0m-62.7-12.8a382 382 0 0 1-83.3-35.9l32-55.4a320 320 0 0 0 62.5 27.7zM704 396.6a382 382 0 0 1-83.4 35.8L609.5 369a320 320 0 0 0 62.5-27.7l32 55.4zM183.3 761.4a386 386 0 0 1 84-97.3l32.5 56.3a324 324 0 0 0-67.5 84q-24-20-49-43m657.5.1a1443 1443 0 0 1-49 43.1 321 321 0 0 0-67.6-84.2l32.5-56.3a385 385 0 0 1 84.1 97.4M466 578.8a388 388 0 0 1 92 0l-11 63a324 324 0 0 0-69.8 0zm-62.7 12.8 11.2 63.5a320 320 0 0 0-62.5 27.7L320 627.4a382 382 0 0 1 83.3-35.8zM704 627.4l-32 55.4a318 318 0 0 0-62.5-27.7l11.2-63.5a379 379 0 0 1 83.2 35.8z"
    })]));
  }
}), football_default = _sfc_main115;

// src/components/fork-spoon.vue
import { defineComponent as _defineComponent116 } from "vue";
import { createElementVNode as _createElementVNode116, openBlock as _openBlock116, createElementBlock as _createElementBlock116 } from "vue";
var _sfc_main116 = /* @__PURE__ */ _defineComponent116({
  name: "ForkSpoon",
  __name: "fork-spoon",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock116(), _createElementBlock116("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode116("path", {
      fill: "currentColor",
      d: "M256 410.3V96a32 32 0 0 1 64 0v314.3a96 96 0 0 0 64-90.6V96a32 32 0 0 1 64 0v223.7a160 160 0 0 1-128 156.8V928a32 32 0 1 1-64 0V476.5a160 160 0 0 1-128-156.8V96a32 32 0 0 1 64 0v223.7a96 96 0 0 0 64 90.6m416 162.2C581.2 552 512 446.8 512 320c0-141.4 86-256 192-256s192 114.6 192 256c0 126.8-69.2 232.1-160 252.5V928a32 32 0 1 1-64 0zm32-60.5c66 0 128-82.6 128-192s-62-192-128-192-128 82.6-128 192 62 192 128 192"
    })]));
  }
}), fork_spoon_default = _sfc_main116;

// src/components/fries.vue
import { defineComponent as _defineComponent117 } from "vue";
import { createElementVNode as _createElementVNode117, openBlock as _openBlock117, createElementBlock as _createElementBlock117 } from "vue";
var _sfc_main117 = /* @__PURE__ */ _defineComponent117({
  name: "Fries",
  __name: "fries",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock117(), _createElementBlock117("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode117("path", {
      fill: "currentColor",
      d: "M608 224v-64a32 32 0 0 0-64 0v336h26.9a64 64 0 0 0 37.1-11.9zm101.1 160a64 64 0 0 0-37.1 11.9V384h64V224a32 32 0 1 0-64 0v160zm74.9 0a93 93 0 0 1 91.3 110l-60.6 323.7a96 96 0 0 1-94.4 78.3H303.7a96 96 0 0 1-94.4-78.3L148.7 494A93 93 0 0 1 240 384h-16V224a96 96 0 0 1 188.6-25.3 96 96 0 0 1 67.4-1.3V160a96 96 0 0 1 188.6-25.3A96 96 0 0 1 800 224v160zM670.8 512a128 128 0 0 1-100 48H453.2a128 128 0 0 1-99.8-48H352v-1.5a128 128 0 0 1-10-15L315 448H240a29 29 0 0 0-28.5 34.3L241.1 640h541.8l29.6-157.7A29 29 0 0 0 784 448h-74.9L682 495.5a132 132 0 0 1-10 15v1.5zM480 288a32 32 0 0 0-64 0v196.1a64 64 0 0 0 37.1 11.9H480zm-128 96V224a32 32 0 0 0-64 0v160zh-37.1a64 64 0 0 1 37.1 11.9zm-98.9 320 19 101.9a32 32 0 0 0 31.6 26.1h416.6a32 32 0 0 0 31.5-26.1l19-101.9z"
    })]));
  }
}), fries_default = _sfc_main117;

// src/components/full-screen.vue
import { defineComponent as _defineComponent118 } from "vue";
import { createElementVNode as _createElementVNode118, openBlock as _openBlock118, createElementBlock as _createElementBlock118 } from "vue";
var _sfc_main118 = /* @__PURE__ */ _defineComponent118({
  name: "FullScreen",
  __name: "full-screen",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock118(), _createElementBlock118("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode118("path", {
      fill: "currentColor",
      d: "m160 96 192 .3a32 32 0 0 1 0 64l-192-.2V352a32 32 0 0 1-64 0V96zm0 832H96V672a32 32 0 1 1 64 0v192l192-.3a32 32 0 1 1 0 64zM864 96h64v256a32 32 0 1 1-64 0V160l-192 .3a32 32 0 1 1 0-64zm0 832-192-.3a32 32 0 0 1 0-64l192 .2V672a32 32 0 1 1 64 0v256z"
    })]));
  }
}), full_screen_default = _sfc_main118;

// src/components/goblet-full.vue
import { defineComponent as _defineComponent119 } from "vue";
import { createElementVNode as _createElementVNode119, openBlock as _openBlock119, createElementBlock as _createElementBlock119 } from "vue";
var _sfc_main119 = /* @__PURE__ */ _defineComponent119({
  name: "GobletFull",
  __name: "goblet-full",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock119(), _createElementBlock119("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode119("path", {
      fill: "currentColor",
      d: "M256 320h512c0-78.6-12.6-142.4-37-192H296.9A488 488 0 0 0 256 320m504 64H264a256.1 256.1 0 0 0 496 0M544 638.4V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.4A320 320 0 0 1 192 320q0-128.4 64-256h512q64 96.4 64 256a320 320 0 0 1-288 318.4"
    })]));
  }
}), goblet_full_default = _sfc_main119;

// src/components/goblet-square-full.vue
import { defineComponent as _defineComponent120 } from "vue";
import { createElementVNode as _createElementVNode120, openBlock as _openBlock120, createElementBlock as _createElementBlock120 } from "vue";
var _sfc_main120 = /* @__PURE__ */ _defineComponent120({
  name: "GobletSquareFull",
  __name: "goblet-square-full",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock120(), _createElementBlock120("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode120("path", {
      fill: "currentColor",
      d: "M256 271c10 6.6 22.5 14.8 29 18.5a220 220 0 0 0 114.7 30.8c30.6 0 49.5-9.5 91.1-41.2l.7-.4c52.9-40.4 82.3-55 132.2-54.7 55.6.4 99.6 20.8 142.8 57.4l1.5 1.3V128H256zm1 76.2c9.4 135 89.9 228.7 255 228.8 157.4 0 238-85 253.2-210a952 952 0 0 1-40.1-35.7c-32.7-27.8-63.4-42-102-42.2-31.5-.3-50.6 9.2-93 41.6l-.6.4c-52.1 39.6-81 54.2-129.8 54.2a283 283 0 0 1-142.8-37zm223 291.6c-229.4-15.4-288-196.3-288-319.1V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v224c0 122.8-58.6 303.7-288 319v257h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96z"
    })]));
  }
}), goblet_square_full_default = _sfc_main120;

// src/components/goblet-square.vue
import { defineComponent as _defineComponent121 } from "vue";
import { createElementVNode as _createElementVNode121, openBlock as _openBlock121, createElementBlock as _createElementBlock121 } from "vue";
var _sfc_main121 = /* @__PURE__ */ _defineComponent121({
  name: "GobletSquare",
  __name: "goblet-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock121(), _createElementBlock121("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode121("path", {
      fill: "currentColor",
      d: "M544 639v257h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.8c-229.4-15.4-288-196.3-288-319.1V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v224c0 122.8-58.6 303.7-288 319M256 319.6c0 149.5 80 256.2 256 256.2 176.1.1 256-106.3 256-255.9V128H256z"
    })]));
  }
}), goblet_square_default = _sfc_main121;

// src/components/goblet.vue
import { defineComponent as _defineComponent122 } from "vue";
import { createElementVNode as _createElementVNode122, openBlock as _openBlock122, createElementBlock as _createElementBlock122 } from "vue";
var _sfc_main122 = /* @__PURE__ */ _defineComponent122({
  name: "Goblet",
  __name: "goblet",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock122(), _createElementBlock122("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode122("path", {
      fill: "currentColor",
      d: "M544 638.4V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.4A320 320 0 0 1 192 320q0-128.4 64-256h512q64 96.4 64 256a320 320 0 0 1-288 318.4M256 320a256 256 0 1 0 512 0c0-78.6-12.6-142.4-37-192H296.9A488 488 0 0 0 256 320"
    })]));
  }
}), goblet_default = _sfc_main122;

// src/components/gold-medal.vue
import { defineComponent as _defineComponent123 } from "vue";
import { createElementVNode as _createElementVNode123, openBlock as _openBlock123, createElementBlock as _createElementBlock123 } from "vue";
var _sfc_main123 = /* @__PURE__ */ _defineComponent123({
  name: "GoldMedal",
  __name: "gold-medal",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock123(), _createElementBlock123("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode123("path", {
      fill: "currentColor",
      d: "M772.1 452.8 826 101q2-15-7.5-26C809 64 804.4 64 795 64H229q-14 0-23.6 11c-9.6 11-8.8 16-7.5 26l54 352q-57.6 79-59.9 187 3 136 93.5 226.5C376 957 421.3 958 512 960q136-3 226.5-93.5T832 640q-2.4-108-59.9-187.2M640.1 128h117l-39 254a666 666 0 0 0-60-27.3q-9-4.5-18.1-8.4V128zm-64.1 0v198.8a363 363 0 0 0-64-6.8q-15.7 0-31.6 2a360 360 0 0 0-32.4 4.8V128zm-192 0v218.3a306 306 0 0 0-18.3 8.6Q337 366.2 306 382l-39-254zm309 693q-72 72-181 75-109-3-181-75c-72-72-73-108.3-75-181q3-109 75-181a251 251 0 0 1 65.2-47.4q57.6-22.6 98.5-26.6 7.6-.6 15.4-1h3.9q7.6.3 15.1 1 41.1 4 99 26.7 35.5 18 64.9 47.3 72 72 75 181-3 109-75 181"
    }), _createElementVNode123("path", {
      fill: "currentColor",
      d: "M544 480H416v64h64v192h-64v64h192v-64h-64z"
    })]));
  }
}), gold_medal_default = _sfc_main123;

// src/components/goods-filled.vue
import { defineComponent as _defineComponent124 } from "vue";
import { createElementVNode as _createElementVNode124, openBlock as _openBlock124, createElementBlock as _createElementBlock124 } from "vue";
var _sfc_main124 = /* @__PURE__ */ _defineComponent124({
  name: "GoodsFilled",
  __name: "goods-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock124(), _createElementBlock124("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode124("path", {
      fill: "currentColor",
      d: "M192 352h640l64 544H128zm128 224h64V448h-64zm320 0h64V448h-64zM384 288h-64a192 192 0 1 1 384 0h-64a128 128 0 1 0-256 0"
    })]));
  }
}), goods_filled_default = _sfc_main124;

// src/components/goods.vue
import { defineComponent as _defineComponent125 } from "vue";
import { createElementVNode as _createElementVNode125, openBlock as _openBlock125, createElementBlock as _createElementBlock125 } from "vue";
var _sfc_main125 = /* @__PURE__ */ _defineComponent125({
  name: "Goods",
  __name: "goods",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock125(), _createElementBlock125("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode125("path", {
      fill: "currentColor",
      d: "M320 288v-22.3C320 154.7 405.5 64 512 64s192 90.7 192 201.7V288h131a32 32 0 0 1 31.9 28.8l57.6 576a32 32 0 0 1-31.8 35.2H131.3a32 32 0 0 1-31.8-35.2l57.6-576A32 32 0 0 1 189 288zm64 0h256v-22.3c0-76.5-57.7-137.7-128-137.7s-128 61.2-128 137.7zm-64 64H218l-51.3 512h690.6L806 352H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0z"
    })]));
  }
}), goods_default = _sfc_main125;

// src/components/grape.vue
import { defineComponent as _defineComponent126 } from "vue";
import { createElementVNode as _createElementVNode126, openBlock as _openBlock126, createElementBlock as _createElementBlock126 } from "vue";
var _sfc_main126 = /* @__PURE__ */ _defineComponent126({
  name: "Grape",
  __name: "grape",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock126(), _createElementBlock126("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode126("path", {
      fill: "currentColor",
      d: "M544 195.2a160 160 0 0 1 96 60.8 160 160 0 1 1 146.2 255 160 160 0 0 1-128 224 160 160 0 1 1-292.4 0 160 160 0 0 1-128-224A160 160 0 1 1 384 256a160 160 0 0 1 96-60.8V128h-64a32 32 0 0 1 0-64h192a32 32 0 0 1 0 64h-64zM512 448a96 96 0 1 0 0-192 96 96 0 0 0 0 192m-256 0a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128 224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128 224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128-224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128-224a96 96 0 1 0 0-192 96 96 0 0 0 0 192"
    })]));
  }
}), grape_default = _sfc_main126;

// src/components/grid.vue
import { defineComponent as _defineComponent127 } from "vue";
import { createElementVNode as _createElementVNode127, openBlock as _openBlock127, createElementBlock as _createElementBlock127 } from "vue";
var _sfc_main127 = /* @__PURE__ */ _defineComponent127({
  name: "Grid",
  __name: "grid",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock127(), _createElementBlock127("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode127("path", {
      fill: "currentColor",
      d: "M640 384v256H384V384zm64 0h192v256H704zm-64 512H384V704h256zm64 0V704h192v192zm-64-768v192H384V128zm64 0h192v192H704zM320 384v256H128V384zm0 512H128V704h192zm0-768v192H128V128z"
    })]));
  }
}), grid_default = _sfc_main127;

// src/components/guide.vue
import { defineComponent as _defineComponent128 } from "vue";
import { createElementVNode as _createElementVNode128, openBlock as _openBlock128, createElementBlock as _createElementBlock128 } from "vue";
var _sfc_main128 = /* @__PURE__ */ _defineComponent128({
  name: "Guide",
  __name: "guide",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock128(), _createElementBlock128("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode128("path", {
      fill: "currentColor",
      d: "M640 608h-64V416h64zm0 160v160a32 32 0 0 1-32 32H416a32 32 0 0 1-32-32V768h64v128h128V768zM384 608V416h64v192zm256-352h-64V128H448v128h-64V96a32 32 0 0 1 32-32h192a32 32 0 0 1 32 32z"
    }), _createElementVNode128("path", {
      fill: "currentColor",
      d: "m220.8 256-71.2 80 71.1 80H768V256zm-14.4-64H800a32 32 0 0 1 32 32v224a32 32 0 0 1-32 32H206.4a32 32 0 0 1-24-10.8L83 357.2a32 32 0 0 1 0-42.4l99.6-112a32 32 0 0 1 23.9-10.8m678.8 496L814 768H266.8V608H814zm-56.8-144H235a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h593.6a32 32 0 0 0 24-10.8l99.5-112a32 32 0 0 0 0-42.4l-99.6-112a32 32 0 0 0-24-10.8z"
    })]));
  }
}), guide_default = _sfc_main128;

// src/components/handbag.vue
import { defineComponent as _defineComponent129 } from "vue";
import { createElementVNode as _createElementVNode129, openBlock as _openBlock129, createElementBlock as _createElementBlock129 } from "vue";
var _sfc_main129 = /* @__PURE__ */ _defineComponent129({
  name: "Handbag",
  __name: "handbag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock129(), _createElementBlock129("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode129("path", {
      fill: "currentColor",
      d: "M887 265q-9-9-23-9H704q-2-82-56-136c-54-54-81.3-54.7-136-56q-82 2-136 56c-54 54-54.7 81.3-56 136H160q-14 0-23 9t-9 23v640q0 14 9 23c9 9 13.7 9 23 9h704q14 0 23-9c9-9 9-13.7 9-23V288q0-14-9-23m-465.5-99.5A126 126 0 0 1 512 128q54 1 90.5 37.5C639 202 639.3 220 640 256H384q1-54 37.5-90.5M832 896H192V320h128v128h64V320h256v128h64V320h128z"
    })]));
  }
}), handbag_default = _sfc_main129;

// src/components/headset.vue
import { defineComponent as _defineComponent130 } from "vue";
import { createElementVNode as _createElementVNode130, openBlock as _openBlock130, createElementBlock as _createElementBlock130 } from "vue";
var _sfc_main130 = /* @__PURE__ */ _defineComponent130({
  name: "Headset",
  __name: "headset",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock130(), _createElementBlock130("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode130("path", {
      fill: "currentColor",
      d: "M896 529.2V512a384 384 0 1 0-768 0v17.2A128 128 0 0 1 320 640v128a128 128 0 1 1-256 0V512a448 448 0 1 1 896 0v256a128 128 0 1 1-256 0V640a128 128 0 0 1 192-110.8m0 110.8a64 64 0 0 0-128 0v128a64 64 0 0 0 128 0zm-768 0v128a64 64 0 0 0 128 0V640a64 64 0 1 0-128 0"
    })]));
  }
}), headset_default = _sfc_main130;

// src/components/help-filled.vue
import { defineComponent as _defineComponent131 } from "vue";
import { createElementVNode as _createElementVNode131, openBlock as _openBlock131, createElementBlock as _createElementBlock131 } from "vue";
var _sfc_main131 = /* @__PURE__ */ _defineComponent131({
  name: "HelpFilled",
  __name: "help-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock131(), _createElementBlock131("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode131("path", {
      fill: "currentColor",
      d: "M926.8 480H701.3A192.5 192.5 0 0 0 544 322.7V97.2A416 416 0 0 1 926.8 480m0 64A416 416 0 0 1 544 926.8V701.3A192.5 192.5 0 0 0 701.3 544zm-829.5 0h225.5A192.5 192.5 0 0 0 480 701.3v225.5A416 416 0 0 1 97.2 544zm0-64A416 416 0 0 1 480 97.2v225.5A192.5 192.5 0 0 0 322.7 480z"
    })]));
  }
}), help_filled_default = _sfc_main131;

// src/components/help.vue
import { defineComponent as _defineComponent132 } from "vue";
import { createElementVNode as _createElementVNode132, openBlock as _openBlock132, createElementBlock as _createElementBlock132 } from "vue";
var _sfc_main132 = /* @__PURE__ */ _defineComponent132({
  name: "Help",
  __name: "help",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock132(), _createElementBlock132("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode132("path", {
      fill: "currentColor",
      d: "m760 805.2-91-91A255 255 0 0 1 512 768a255 255 0 0 1-157-53.8l-91 91A383 383 0 0 0 512 896c94.5 0 181.1-34.2 248-90.8m45.2-45.3A383 383 0 0 0 896 512c0-94.5-34.2-181.1-90.8-248l-91 91C748 398.4 768 453 768 512s-20.1 113.6-53.8 157zM760 218.8A383 383 0 0 0 512 128a383 383 0 0 0-248 90.8l91 91A255 255 0 0 1 512 256c59.1 0 113.6 20.1 157 53.8zM218.8 264A383 383 0 0 0 128 512c0 94.5 34.2 181.1 90.8 248l91-91A255 255 0 0 1 256 512c0-59.1 20.1-113.6 53.8-157zM636 658.6a195 195 0 0 0 22.6-22.6A191 191 0 0 0 704 512a191 191 0 0 0-68-146.6A191 191 0 0 0 512 320a191 191 0 0 0-146.6 68A191 191 0 0 0 320 512a191 191 0 0 0 68 146.6A191 191 0 0 0 512 704c47.3 0 90.6-17 124-45.4M512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
    })]));
  }
}), help_default = _sfc_main132;

// src/components/hide.vue
import { defineComponent as _defineComponent133 } from "vue";
import { createElementVNode as _createElementVNode133, openBlock as _openBlock133, createElementBlock as _createElementBlock133 } from "vue";
var _sfc_main133 = /* @__PURE__ */ _defineComponent133({
  name: "Hide",
  __name: "hide",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock133(), _createElementBlock133("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode133("path", {
      fill: "currentColor",
      d: "M876.8 156.8c0-9.6-3.2-16-9.6-22.4s-12.8-9.6-22.4-9.6-16 3.2-22.4 9.6L736 220.8c-64-32-137.6-51.2-224-60.8-160 16-288 73.6-377.6 176S0 496 0 512s48 73.6 134.4 176c22.4 25.6 44.8 48 73.6 67.2l-86.4 89.6c-6.4 6.4-9.6 12.8-9.6 22.4s3.2 16 9.6 22.4 12.8 9.6 22.4 9.6 16-3.2 22.4-9.6l704-710.4c3.2-6.4 6.4-12.8 6.4-22.4m-646.4 528Q115.2 579.2 76.8 512q43.2-72 153.6-172.8C304 272 400 230.4 512 224c64 3.2 124.8 19.2 176 44.8l-54.4 54.4A218 218 0 0 0 512 288c-64 0-115.2 22.4-160 64s-64 96-64 160c0 48 12.8 89.6 35.2 124.8L256 707.2c-9.6-6.4-19.2-16-25.6-22.4m140.8-96Q352 555.2 352 512c0-44.8 16-83.2 48-112s67.2-48 112-48c28.8 0 54.4 6.4 73.6 19.2zM889.6 336c-12.8-16-28.8-28.8-41.6-41.6l-48 48c73.6 67.2 124.8 124.8 150.4 169.6q-43.2 72-153.6 172.8C723.2 752 624 793.6 512 800a478 478 0 0 1-140.8-28.8l-48 48A680 680 0 0 0 512 864c160-16 288-73.6 377.6-176S1024 528 1024 512s-48-73.6-134.4-176"
    }), _createElementVNode133("path", {
      fill: "currentColor",
      d: "M512 672c-12.8 0-25.6-3.2-38.4-6.4l-51.2 51.2A215 215 0 0 0 512 736c64 0 115.2-22.4 160-64 41.6-41.6 64-96 64-160 0-32-6.4-64-19.2-89.6l-51.2 51.2c3.2 12.8 6.4 25.6 6.4 38.4 0 44.8-16 83.2-48 112s-67.2 48-112 48"
    })]));
  }
}), hide_default = _sfc_main133;

// src/components/histogram.vue
import { defineComponent as _defineComponent134 } from "vue";
import { createElementVNode as _createElementVNode134, openBlock as _openBlock134, createElementBlock as _createElementBlock134 } from "vue";
var _sfc_main134 = /* @__PURE__ */ _defineComponent134({
  name: "Histogram",
  __name: "histogram",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock134(), _createElementBlock134("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode134("path", {
      fill: "currentColor",
      d: "M416 896V128h192v768zm-288 0V448h192v448zm576 0V320h192v576z"
    })]));
  }
}), histogram_default = _sfc_main134;

// src/components/home-filled.vue
import { defineComponent as _defineComponent135 } from "vue";
import { createElementVNode as _createElementVNode135, openBlock as _openBlock135, createElementBlock as _createElementBlock135 } from "vue";
var _sfc_main135 = /* @__PURE__ */ _defineComponent135({
  name: "HomeFilled",
  __name: "home-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock135(), _createElementBlock135("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode135("path", {
      fill: "currentColor",
      d: "M512 128 128 448v448h256V640h256v256h256V448z"
    })]));
  }
}), home_filled_default = _sfc_main135;

// src/components/hot-water.vue
import { defineComponent as _defineComponent136 } from "vue";
import { createElementVNode as _createElementVNode136, openBlock as _openBlock136, createElementBlock as _createElementBlock136 } from "vue";
var _sfc_main136 = /* @__PURE__ */ _defineComponent136({
  name: "HotWater",
  __name: "hot-water",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock136(), _createElementBlock136("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode136("path", {
      fill: "currentColor",
      d: "M273 477.9h478v-68.3H273zm0 68.2v51.2a187.7 187.7 0 0 0 187.8 187.8h102.4a187.7 187.7 0 0 0 187.7-187.8v-51.2zm-34-204.8h546a34 34 0 0 1 34.2 34.2v221.8a256 256 0 0 1-256 256H460.8a256 256 0 0 1-256-256V375.5a34 34 0 0 1 34.1-34.2M512 34.1a34 34 0 0 1 34.1 34.2v170.6a34.1 34.1 0 0 1-68.2 0V68.3A34 34 0 0 1 512 34m-136.5 68.3a34 34 0 0 1 34.1 34.1V239a34.1 34.1 0 0 1-68.3 0V136.5a34 34 0 0 1 34.2-34.1m273 0a34 34 0 0 1 34.2 34.1V239a34.1 34.1 0 1 1-68.3 0V136.5a34 34 0 0 1 34.1-34.1M170.7 921.7h682.6a34.1 34.1 0 1 1 0 68.2H170.7a34.1 34.1 0 1 1 0-68.2"
    })]));
  }
}), hot_water_default = _sfc_main136;

// src/components/house.vue
import { defineComponent as _defineComponent137 } from "vue";
import { createElementVNode as _createElementVNode137, openBlock as _openBlock137, createElementBlock as _createElementBlock137 } from "vue";
var _sfc_main137 = /* @__PURE__ */ _defineComponent137({
  name: "House",
  __name: "house",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock137(), _createElementBlock137("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode137("path", {
      fill: "currentColor",
      d: "M192 414v482h640V414L512 147.3zm-52.5-39.6 352-293.3a32 32 0 0 1 41 0l352 293.3A32 32 0 0 1 896 399v529a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V399a32 32 0 0 1 11.5-24.6"
    })]));
  }
}), house_default = _sfc_main137;

// src/components/ice-cream-round.vue
import { defineComponent as _defineComponent138 } from "vue";
import { createElementVNode as _createElementVNode138, openBlock as _openBlock138, createElementBlock as _createElementBlock138 } from "vue";
var _sfc_main138 = /* @__PURE__ */ _defineComponent138({
  name: "IceCreamRound",
  __name: "ice-cream-round",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock138(), _createElementBlock138("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode138("path", {
      fill: "currentColor",
      d: "m308.4 489.3 226.3 226.3a32 32 0 0 0 45.2 0L783.6 512A192 192 0 1 0 512 240.4L308.4 444.2a32 32 0 0 0 0 45.2zM444 715.6 308.4 851.4a96 96 0 0 1-135.8-135.8L308.4 580 263 534.7a96 96 0 0 1 0-135.9l203.7-203.6a256 256 0 0 1 362 362L625.2 761a96 96 0 0 1-135.9 0l-45.2-45.3zm-45.3-45.2-45.2-45.2-135.7 135.7a32 32 0 0 0 45.2 45.2zm249-384.6a32 32 0 0 1 0 45.2L466.6 512a32 32 0 1 1-45.2-45.2l181-181.1a32 32 0 0 1 45.3 0zm90.5 90.5a32 32 0 0 1 0 45.2l-181 181a32 32 0 1 1-45.3-45.3l181-181a32 32 0 0 1 45.3 0"
    })]));
  }
}), ice_cream_round_default = _sfc_main138;

// src/components/ice-cream-square.vue
import { defineComponent as _defineComponent139 } from "vue";
import { createElementVNode as _createElementVNode139, openBlock as _openBlock139, createElementBlock as _createElementBlock139 } from "vue";
var _sfc_main139 = /* @__PURE__ */ _defineComponent139({
  name: "IceCreamSquare",
  __name: "ice-cream-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock139(), _createElementBlock139("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode139("path", {
      fill: "currentColor",
      d: "M416 640h256a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32H352a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32zm192 64v160a96 96 0 0 1-192 0V704h-64a96 96 0 0 1-96-96V160a96 96 0 0 1 96-96h320a96 96 0 0 1 96 96v448a96 96 0 0 1-96 96zm-64 0h-64v160a32 32 0 1 0 64 0z"
    })]));
  }
}), ice_cream_square_default = _sfc_main139;

// src/components/ice-cream.vue
import { defineComponent as _defineComponent140 } from "vue";
import { createElementVNode as _createElementVNode140, openBlock as _openBlock140, createElementBlock as _createElementBlock140 } from "vue";
var _sfc_main140 = /* @__PURE__ */ _defineComponent140({
  name: "IceCream",
  __name: "ice-cream",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock140(), _createElementBlock140("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode140("path", {
      fill: "currentColor",
      d: "M128.6 448a208 208 0 0 1 193.6-191.6A224 224 0 0 1 767.4 272 208 208 0 0 1 894.8 448h1.2L548.8 983.7a32 32 0 0 1-53.2.7L128 448zm64.3 0h286.2a144 144 0 0 0-286.2 0m351.4 0h286.2a144 144 0 0 0-286.2 0m-294.9 64 271.8 396.6 257-396.6zm262.3-159.4a208 208 0 0 1 189.2-96.2 160 160 0 0 0-314.8 5.7c52.6 13 97.3 46 125.6 90.5"
    })]));
  }
}), ice_cream_default = _sfc_main140;

// src/components/ice-drink.vue
import { defineComponent as _defineComponent141 } from "vue";
import { createElementVNode as _createElementVNode141, openBlock as _openBlock141, createElementBlock as _createElementBlock141 } from "vue";
var _sfc_main141 = /* @__PURE__ */ _defineComponent141({
  name: "IceDrink",
  __name: "ice-drink",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock141(), _createElementBlock141("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode141("path", {
      fill: "currentColor",
      d: "M512 448v128h239.7l16-128zm-64 0H256.3l16 128H448zm64-255.4V384h247.7A256 256 0 0 0 512 192.6m-64 8.1A257 257 0 0 0 264.3 384H448zm64-72A320 320 0 0 1 825.5 384H896a32 32 0 1 1 0 64h-64v2l-57 454a64 64 0 0 1-63.4 56H312.4a64 64 0 0 1-63.4-56l-57-454v-2h-64a32 32 0 0 1 0-64h70.5A320 320 0 0 1 448 135V96a96 96 0 0 1 96-96h128a32 32 0 1 1 0 64H544a32 32 0 0 0-32 32zM743.7 640H280.3l32.1 256h399.2z"
    })]));
  }
}), ice_drink_default = _sfc_main141;

// src/components/ice-tea.vue
import { defineComponent as _defineComponent142 } from "vue";
import { createElementVNode as _createElementVNode142, openBlock as _openBlock142, createElementBlock as _createElementBlock142 } from "vue";
var _sfc_main142 = /* @__PURE__ */ _defineComponent142({
  name: "IceTea",
  __name: "ice-tea",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock142(), _createElementBlock142("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode142("path", {
      fill: "currentColor",
      d: "M197.7 259.6a320.1 320.1 0 0 1 628.6 0A96 96 0 0 1 896 352v64a96 96 0 0 1-71.6 92.9l-49.4 395a64 64 0 0 1-63.5 56.1h-399a64 64 0 0 1-63.5-56l-49.4-395.1A96 96 0 0 1 128 416v-64a96 96 0 0 1 69.7-92.4m66.4-3.6h495.8a256.1 256.1 0 0 0-495.8 0m495.4 256h-495l48 384h399zM224 448h576a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32H224a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32m160 192h64v64h-64zm192 64h64v64h-64zm-128 64h64v64h-64zm64-192h64v64h-64z"
    })]));
  }
}), ice_tea_default = _sfc_main142;

// src/components/info-filled.vue
import { defineComponent as _defineComponent143 } from "vue";
import { createElementVNode as _createElementVNode143, openBlock as _openBlock143, createElementBlock as _createElementBlock143 } from "vue";
var _sfc_main143 = /* @__PURE__ */ _defineComponent143({
  name: "InfoFilled",
  __name: "info-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock143(), _createElementBlock143("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode143("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m67.2 275c33.3 0 60.3-23 60.3-57.3s-27-57.3-60.3-57.3-60.2 23-60.2 57.3 27 57.4 60.2 57.4m11.7 360.1c0-6.8 2.4-24.6 1-34.8L539.3 725c-10.9 11.4-24.5 19.4-30.9 17.3a13 13 0 0 1-8.2-14.7l87.6-277c7.2-35.2-12.5-67.2-54.3-71.3-44 0-109 44.7-148.5 101.5 0 6.8-1.3 23.6 0 33.8l52.6-60.6c11-11.4 23.6-19.4 30-17.2a13 13 0 0 1 7.8 16.1l-87 275.7c-10 32.2 9 63.8 55.1 71 67.9 0 108-43.6 147.5-100.4z"
    })]));
  }
}), info_filled_default = _sfc_main143;

// src/components/iphone.vue
import { defineComponent as _defineComponent144 } from "vue";
import { createElementVNode as _createElementVNode144, openBlock as _openBlock144, createElementBlock as _createElementBlock144 } from "vue";
var _sfc_main144 = /* @__PURE__ */ _defineComponent144({
  name: "Iphone",
  __name: "iphone",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock144(), _createElementBlock144("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode144("path", {
      fill: "currentColor",
      d: "M224 768v96a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64v-96zm0-64h576V160a64 64 0 0 0-64-64H288a64 64 0 0 0-64 64zm32 288a96 96 0 0 1-96-96V128a96 96 0 0 1 96-96h512a96 96 0 0 1 96 96v768a96 96 0 0 1-96 96zm304-144a48 48 0 1 1-96 0 48 48 0 0 1 96 0"
    })]));
  }
}), iphone_default = _sfc_main144;

// src/components/key.vue
import { defineComponent as _defineComponent145 } from "vue";
import { createElementVNode as _createElementVNode145, openBlock as _openBlock145, createElementBlock as _createElementBlock145 } from "vue";
var _sfc_main145 = /* @__PURE__ */ _defineComponent145({
  name: "Key",
  __name: "key",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock145(), _createElementBlock145("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode145("path", {
      fill: "currentColor",
      d: "M448 456V96a32 32 0 0 1 32-32h192a32 32 0 0 1 0 64H512v128h160a32 32 0 0 1 0 64H512v128a256 256 0 1 1-64 8m64 440a192 192 0 1 0 0-384 192 192 0 0 0 0 384"
    })]));
  }
}), key_default = _sfc_main145;

// src/components/knife-fork.vue
import { defineComponent as _defineComponent146 } from "vue";
import { createElementVNode as _createElementVNode146, openBlock as _openBlock146, createElementBlock as _createElementBlock146 } from "vue";
var _sfc_main146 = /* @__PURE__ */ _defineComponent146({
  name: "KnifeFork",
  __name: "knife-fork",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock146(), _createElementBlock146("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode146("path", {
      fill: "currentColor",
      d: "M256 410.6V96a32 32 0 0 1 64 0v314.6a96 96 0 0 0 64-90.6V96a32 32 0 0 1 64 0v224a160 160 0 0 1-128 156.8V928a32 32 0 1 1-64 0V476.8A160 160 0 0 1 128 320V96a32 32 0 0 1 64 0v224a96 96 0 0 0 64 90.6m384-250.3V544h126.7q-5-118.1-28.6-207.7-21.3-82-98.1-176zm0 447.7v320a32 32 0 1 1-64 0V64h64q128 134.2 160 256c32 121.8 32 177.2 32 288z"
    })]));
  }
}), knife_fork_default = _sfc_main146;

// src/components/lightning.vue
import { defineComponent as _defineComponent147 } from "vue";
import { createElementVNode as _createElementVNode147, openBlock as _openBlock147, createElementBlock as _createElementBlock147 } from "vue";
var _sfc_main147 = /* @__PURE__ */ _defineComponent147({
  name: "Lightning",
  __name: "lightning",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock147(), _createElementBlock147("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode147("path", {
      fill: "currentColor",
      d: "M288 671.4v64A240 240 0 0 1 63.7 496.3a240 240 0 0 1 199.5-236.8 256.1 256.1 0 0 1 487.9-31A256 256 0 0 1 736 734v-64.8a192 192 0 0 0 3.3-377.9l-35.2-6.6-12.8-33.4a192 192 0 0 0-366 23.3l-9.8 40.9-41.5 7a176 176 0 0 0-146.3 173.6c0 92 70.5 167.3 160.3 175.2z"
    }), _createElementVNode147("path", {
      fill: "currentColor",
      d: "M416 736a32 32 0 0 1-27.8-47.9l128-224a32 32 0 1 1 55.6 31.8L471.2 672H608a32 32 0 0 1 27.8 47.9l-128 224A32 32 0 1 1 452 912L553 736z"
    })]));
  }
}), lightning_default = _sfc_main147;

// src/components/link.vue
import { defineComponent as _defineComponent148 } from "vue";
import { createElementVNode as _createElementVNode148, openBlock as _openBlock148, createElementBlock as _createElementBlock148 } from "vue";
var _sfc_main148 = /* @__PURE__ */ _defineComponent148({
  name: "Link",
  __name: "link",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock148(), _createElementBlock148("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode148("path", {
      fill: "currentColor",
      d: "m715.6 625.2-45.2-45.3 90.5-90.6c75-74.9 85.1-186.3 22.7-248.9-62.6-62.4-174-52.3-249 22.7l-90.4 90.5-45.3-45.2 90.5-90.5c100-100 252-110.1 339.5-22.7 87.5 87.5 77.3 239.4-22.7 339.5l-90.5 90.5zm-90.4 90.4-90.5 90.5c-100 100-252 110.1-339.5 22.7-87.5-87.5-77.3-239.4 22.7-339.5l90.5-90.5 45.2 45.3-90.5 90.6c-75 74.9-85.1 186.3-22.7 248.9 62.6 62.4 174 52.3 249-22.7l90.5-90.5zm0-362 45.2 45.2-271.6 271.6-45.2-45.2z"
    })]));
  }
}), link_default = _sfc_main148;

// src/components/list.vue
import { defineComponent as _defineComponent149 } from "vue";
import { createElementVNode as _createElementVNode149, openBlock as _openBlock149, createElementBlock as _createElementBlock149 } from "vue";
var _sfc_main149 = /* @__PURE__ */ _defineComponent149({
  name: "List",
  __name: "list",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock149(), _createElementBlock149("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode149("path", {
      fill: "currentColor",
      d: "M704 192h160v736H160V192h160v64h384zM288 512h448v-64H288zm0 256h448v-64H288zm96-576V96h256v96z"
    })]));
  }
}), list_default = _sfc_main149;

// src/components/loading.vue
import { defineComponent as _defineComponent150 } from "vue";
import { createElementVNode as _createElementVNode150, openBlock as _openBlock150, createElementBlock as _createElementBlock150 } from "vue";
var _sfc_main150 = /* @__PURE__ */ _defineComponent150({
  name: "Loading",
  __name: "loading",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock150(), _createElementBlock150("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode150("path", {
      fill: "currentColor",
      d: "M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.2 0l136 135.8a32 32 0 0 1-45.3 45.3L195.2 240.4a32 32 0 0 1 0-45.2m452.5 452.5a32 32 0 0 1 45.3 0l135.8 135.9a32 32 0 0 1-45.2 45.2L647.7 693a32 32 0 0 1 0-45.3m181.1-452.4a32 32 0 0 1 0 45.1L693 376.4a32 32 0 0 1-45.3-45.3l135.9-135.8a32 32 0 0 1 45.2 0M376.3 647.7a32 32 0 0 1 0 45.3L240.4 828.8a32 32 0 0 1-45.2-45.2L331 647.7a32 32 0 0 1 45.3 0"
    })]));
  }
}), loading_default = _sfc_main150;

// src/components/location-filled.vue
import { defineComponent as _defineComponent151 } from "vue";
import { createElementVNode as _createElementVNode151, openBlock as _openBlock151, createElementBlock as _createElementBlock151 } from "vue";
var _sfc_main151 = /* @__PURE__ */ _defineComponent151({
  name: "LocationFilled",
  __name: "location-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock151(), _createElementBlock151("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode151("path", {
      fill: "currentColor",
      d: "M512 928c24 0 117.5-68.4 192-153.2 99.5-113 160-239 160-358.8 0-189.6-155.8-320-352-320S160 226.4 160 416c0 120.3 60.5 246.4 160 359.2C394.3 859.8 488 928 512 928m0-435.2a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 140.8a204.8 204.8 0 1 1 0-409.6 204.8 204.8 0 0 1 0 409.6"
    })]));
  }
}), location_filled_default = _sfc_main151;

// src/components/location-information.vue
import { defineComponent as _defineComponent152 } from "vue";
import { createElementVNode as _createElementVNode152, openBlock as _openBlock152, createElementBlock as _createElementBlock152 } from "vue";
var _sfc_main152 = /* @__PURE__ */ _defineComponent152({
  name: "LocationInformation",
  __name: "location-information",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock152(), _createElementBlock152("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode152("path", {
        fill: "currentColor",
        d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      _createElementVNode152("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.1 94.5 272.1 288 456.6C705.5 688 800 534 800 416M512 960Q160 640 160 416a352 352 0 0 1 704 0q0 224-352 544"
      }),
      _createElementVNode152("path", {
        fill: "currentColor",
        d: "M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192m0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320"
      })
    ]));
  }
}), location_information_default = _sfc_main152;

// src/components/location.vue
import { defineComponent as _defineComponent153 } from "vue";
import { createElementVNode as _createElementVNode153, openBlock as _openBlock153, createElementBlock as _createElementBlock153 } from "vue";
var _sfc_main153 = /* @__PURE__ */ _defineComponent153({
  name: "Location",
  __name: "location",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock153(), _createElementBlock153("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode153("path", {
      fill: "currentColor",
      d: "M800 416a288 288 0 1 0-576 0c0 118.1 94.5 272.1 288 456.6C705.5 688 800 534 800 416M512 960Q160 640 160 416a352 352 0 0 1 704 0q0 224-352 544"
    }), _createElementVNode153("path", {
      fill: "currentColor",
      d: "M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192m0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320"
    })]));
  }
}), location_default = _sfc_main153;

// src/components/lock.vue
import { defineComponent as _defineComponent154 } from "vue";
import { createElementVNode as _createElementVNode154, openBlock as _openBlock154, createElementBlock as _createElementBlock154 } from "vue";
var _sfc_main154 = /* @__PURE__ */ _defineComponent154({
  name: "Lock",
  __name: "lock",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock154(), _createElementBlock154("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode154("path", {
      fill: "currentColor",
      d: "M224 448a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V480a32 32 0 0 0-32-32zm0-64h576a96 96 0 0 1 96 96v384a96 96 0 0 1-96 96H224a96 96 0 0 1-96-96V480a96 96 0 0 1 96-96"
    }), _createElementVNode154("path", {
      fill: "currentColor",
      d: "M512 544a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V576a32 32 0 0 1 32-32m192-160v-64a192 192 0 1 0-384 0v64zM512 64a256 256 0 0 1 256 256v128H256V320A256 256 0 0 1 512 64"
    })]));
  }
}), lock_default = _sfc_main154;

// src/components/lollipop.vue
import { defineComponent as _defineComponent155 } from "vue";
import { createElementVNode as _createElementVNode155, openBlock as _openBlock155, createElementBlock as _createElementBlock155 } from "vue";
var _sfc_main155 = /* @__PURE__ */ _defineComponent155({
  name: "Lollipop",
  __name: "lollipop",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock155(), _createElementBlock155("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode155("path", {
      fill: "currentColor",
      d: "M513.3 448a64 64 0 1 1 76.5 49.7A96 96 0 0 0 768 448h64a160 160 0 0 1-320 0zm-127-29.7a256 256 0 1 0 43.5-180.5A256 256 0 0 1 832 448h-64a192 192 0 0 0-381.7-29.7M492 667.8 285.7 874A96 96 0 0 1 150 738.3L356.2 532A320 320 0 1 1 492 667.8m-54.5-36a322 322 0 0 1-45.2-45.3l-197.1 197a32 32 0 1 0 45.2 45.3l197.1-197.1z"
    })]));
  }
}), lollipop_default = _sfc_main155;

// src/components/magic-stick.vue
import { defineComponent as _defineComponent156 } from "vue";
import { createElementVNode as _createElementVNode156, openBlock as _openBlock156, createElementBlock as _createElementBlock156 } from "vue";
var _sfc_main156 = /* @__PURE__ */ _defineComponent156({
  name: "MagicStick",
  __name: "magic-stick",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock156(), _createElementBlock156("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode156("path", {
      fill: "currentColor",
      d: "M512 64h64v192h-64zm0 576h64v192h-64zM160 480v-64h192v64zm576 0v-64h192v64zM249.9 199 295 154l135.7 135.7-45.2 45.2-135.7-135.7zm407.3 407.4 45.2-45.2 135.7 135.7-45.2 45.2zM114 923.2 68.8 878l316.8-316.8 45.2 45.2zm588.4-588.4-45.2-45.2 135.7-135.7 45.2 45.2z"
    })]));
  }
}), magic_stick_default = _sfc_main156;

// src/components/magnet.vue
import { defineComponent as _defineComponent157 } from "vue";
import { createElementVNode as _createElementVNode157, openBlock as _openBlock157, createElementBlock as _createElementBlock157 } from "vue";
var _sfc_main157 = /* @__PURE__ */ _defineComponent157({
  name: "Magnet",
  __name: "magnet",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock157(), _createElementBlock157("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode157("path", {
      fill: "currentColor",
      d: "M832 320V192H704v320a192 192 0 1 1-384 0V192H192v128h128v64H192v128a320 320 0 0 0 640 0V384H704v-64zM640 512V128h256v384a384 384 0 1 1-768 0V128h256v384a128 128 0 1 0 256 0"
    })]));
  }
}), magnet_default = _sfc_main157;

// src/components/male.vue
import { defineComponent as _defineComponent158 } from "vue";
import { createElementVNode as _createElementVNode158, openBlock as _openBlock158, createElementBlock as _createElementBlock158 } from "vue";
var _sfc_main158 = /* @__PURE__ */ _defineComponent158({
  name: "Male",
  __name: "male",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock158(), _createElementBlock158("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode158("path", {
        fill: "currentColor",
        d: "M399.5 849.5a225 225 0 1 0 0-450 225 225 0 0 0 0 450m0 56.3a281.3 281.3 0 1 1 0-562.5 281.3 281.3 0 0 1 0 562.5m253.1-787.5h225q28.1 0 28.1 28t-28 28.2h-225q-28.2 0-28.2-28.1t28.1-28.2"
      }),
      _createElementVNode158("path", {
        fill: "currentColor",
        d: "M877.6 118.3q28.1 0 28.1 28v225q0 28.2-28 28.2t-28.2-28.1v-225q0-28.2 28.1-28.2"
      }),
      _createElementVNode158("path", {
        fill: "currentColor",
        d: "m604.8 458.9-39.7-39.8 292.6-292.6 39.8 39.8z"
      })
    ]));
  }
}), male_default = _sfc_main158;

// src/components/management.vue
import { defineComponent as _defineComponent159 } from "vue";
import { createElementVNode as _createElementVNode159, openBlock as _openBlock159, createElementBlock as _createElementBlock159 } from "vue";
var _sfc_main159 = /* @__PURE__ */ _defineComponent159({
  name: "Management",
  __name: "management",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock159(), _createElementBlock159("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode159("path", {
      fill: "currentColor",
      d: "M576 128v288l96-96 96 96V128h128v768H320V128zm-448 0h128v768H128z"
    })]));
  }
}), management_default = _sfc_main159;

// src/components/map-location.vue
import { defineComponent as _defineComponent160 } from "vue";
import { createElementVNode as _createElementVNode160, openBlock as _openBlock160, createElementBlock as _createElementBlock160 } from "vue";
var _sfc_main160 = /* @__PURE__ */ _defineComponent160({
  name: "MapLocation",
  __name: "map-location",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock160(), _createElementBlock160("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode160("path", {
      fill: "currentColor",
      d: "M800 416a288 288 0 1 0-576 0c0 118.1 94.5 272.1 288 456.6C705.5 688 800 534 800 416M512 960Q160 640 160 416a352 352 0 0 1 704 0q0 224-352 544"
    }), _createElementVNode160("path", {
      fill: "currentColor",
      d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256m345.6 192L960 960H672v-64H352v64H64l102.4-256zm-69 0H235.4l-76.8 192h707z"
    })]));
  }
}), map_location_default = _sfc_main160;

// src/components/medal.vue
import { defineComponent as _defineComponent161 } from "vue";
import { createElementVNode as _createElementVNode161, openBlock as _openBlock161, createElementBlock as _createElementBlock161 } from "vue";
var _sfc_main161 = /* @__PURE__ */ _defineComponent161({
  name: "Medal",
  __name: "medal",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock161(), _createElementBlock161("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode161("path", {
      fill: "currentColor",
      d: "M512 896a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
    }), _createElementVNode161("path", {
      fill: "currentColor",
      d: "M576 128H448v200a287 287 0 0 1 64-8 288 288 0 0 1 64 8zm64 0v219.6q36.6 13.7 78.4 34l39-253.6zm-256 0H266.6l39 253.6a897 897 0 0 1 78.4-34zM229.3 64h565.4a32 32 0 0 1 31.6 36.9L768 480q-170.7-96-256-96c-85.3 0-142.2 32-256 96l-58.3-379.1A32 32 0 0 1 229.3 64"
    })]));
  }
}), medal_default = _sfc_main161;

// src/components/memo.vue
import { defineComponent as _defineComponent162 } from "vue";
import { createElementVNode as _createElementVNode162, openBlock as _openBlock162, createElementBlock as _createElementBlock162 } from "vue";
var _sfc_main162 = /* @__PURE__ */ _defineComponent162({
  name: "Memo",
  __name: "memo",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock162(), _createElementBlock162("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode162("path", {
        fill: "currentColor",
        d: "M480 320h192q32 0 32-32c0-32-10.7-32-32-32H480q-32 0-32 32c0 32 10.7 32 32 32"
      }),
      _createElementVNode162("path", {
        fill: "currentColor",
        d: "M887 73q-9-9-23-9H160q-14 0-23 9t-9 23v832q0 14 9 23c9 9 13.7 9 23 9h704q14 0 23-9c9-9 9-13.7 9-23V96q0-14-9-23M192 896V128h96v768zm640 0H352V128h480z"
      }),
      _createElementVNode162("path", {
        fill: "currentColor",
        d: "M480 512h192q32 0 32-32c0-32-10.7-32-32-32H480q-32 0-32 32c0 32 10.7 32 32 32m0 192h192q32 0 32-32c0-32-10.7-32-32-32H480q-32 0-32 32c0 32 10.7 32 32 32"
      })
    ]));
  }
}), memo_default = _sfc_main162;

// src/components/menu.vue
import { defineComponent as _defineComponent163 } from "vue";
import { createElementVNode as _createElementVNode163, openBlock as _openBlock163, createElementBlock as _createElementBlock163 } from "vue";
var _sfc_main163 = /* @__PURE__ */ _defineComponent163({
  name: "Menu",
  __name: "menu",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock163(), _createElementBlock163("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode163("path", {
      fill: "currentColor",
      d: "M160 448a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zm448 0a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zM160 896a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zm448 0a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32z"
    })]));
  }
}), menu_default = _sfc_main163;

// src/components/message-box.vue
import { defineComponent as _defineComponent164 } from "vue";
import { createElementVNode as _createElementVNode164, openBlock as _openBlock164, createElementBlock as _createElementBlock164 } from "vue";
var _sfc_main164 = /* @__PURE__ */ _defineComponent164({
  name: "MessageBox",
  __name: "message-box",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock164(), _createElementBlock164("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode164("path", {
      fill: "currentColor",
      d: "M288 384h448v64H288zm96-128h256v64H384zM131.5 512H384v128h256V512h252.5L722 192H302zM896 576H704v128H320V576H128v256h768zM275.8 128h472.4a32 32 0 0 1 28.6 17.7l179.9 359.5a32 32 0 0 1 3.3 14.4V864a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V519.6a32 32 0 0 1 3.4-14.4l179.8-359.5a32 32 0 0 1 28.6-17.7"
    })]));
  }
}), message_box_default = _sfc_main164;

// src/components/message.vue
import { defineComponent as _defineComponent165 } from "vue";
import { createElementVNode as _createElementVNode165, openBlock as _openBlock165, createElementBlock as _createElementBlock165 } from "vue";
var _sfc_main165 = /* @__PURE__ */ _defineComponent165({
  name: "Message",
  __name: "message",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock165(), _createElementBlock165("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode165("path", {
      fill: "currentColor",
      d: "M128 224v512a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V224zm0-64h768a64 64 0 0 1 64 64v512a128 128 0 0 1-128 128H192A128 128 0 0 1 64 736V224a64 64 0 0 1 64-64"
    }), _createElementVNode165("path", {
      fill: "currentColor",
      d: "M904 224 656.5 506.9a192 192 0 0 1-289 0L120 224zm-699 0 210.6 240.7a128 128 0 0 0 192.7 0L819 224z"
    })]));
  }
}), message_default = _sfc_main165;

// src/components/mic.vue
import { defineComponent as _defineComponent166 } from "vue";
import { createElementVNode as _createElementVNode166, openBlock as _openBlock166, createElementBlock as _createElementBlock166 } from "vue";
var _sfc_main166 = /* @__PURE__ */ _defineComponent166({
  name: "Mic",
  __name: "mic",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock166(), _createElementBlock166("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode166("path", {
      fill: "currentColor",
      d: "M480 704h160a64 64 0 0 0 64-64v-32h-96a32 32 0 0 1 0-64h96v-96h-96a32 32 0 0 1 0-64h96v-96h-96a32 32 0 0 1 0-64h96v-32a64 64 0 0 0-64-64H384a64 64 0 0 0-64 64v32h96a32 32 0 0 1 0 64h-96v96h96a32 32 0 0 1 0 64h-96v96h96a32 32 0 0 1 0 64h-96v32a64 64 0 0 0 64 64zm64 64v128h192a32 32 0 1 1 0 64H288a32 32 0 1 1 0-64h192V768h-96a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64h256a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128z"
    })]));
  }
}), mic_default = _sfc_main166;

// src/components/microphone.vue
import { defineComponent as _defineComponent167 } from "vue";
import { createElementVNode as _createElementVNode167, openBlock as _openBlock167, createElementBlock as _createElementBlock167 } from "vue";
var _sfc_main167 = /* @__PURE__ */ _defineComponent167({
  name: "Microphone",
  __name: "microphone",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock167(), _createElementBlock167("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode167("path", {
      fill: "currentColor",
      d: "M512 128a128 128 0 0 0-128 128v256a128 128 0 1 0 256 0V256a128 128 0 0 0-128-128m0-64a192 192 0 0 1 192 192v256a192 192 0 1 1-384 0V256A192 192 0 0 1 512 64m-32 832v-64a288 288 0 0 1-288-288v-32a32 32 0 0 1 64 0v32a224 224 0 0 0 224 224h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64z"
    })]));
  }
}), microphone_default = _sfc_main167;

// src/components/milk-tea.vue
import { defineComponent as _defineComponent168 } from "vue";
import { createElementVNode as _createElementVNode168, openBlock as _openBlock168, createElementBlock as _createElementBlock168 } from "vue";
var _sfc_main168 = /* @__PURE__ */ _defineComponent168({
  name: "MilkTea",
  __name: "milk-tea",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock168(), _createElementBlock168("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode168("path", {
      fill: "currentColor",
      d: "M416 128V96a96 96 0 0 1 96-96h128a32 32 0 1 1 0 64H512a32 32 0 0 0-32 32v32h320a96 96 0 0 1 11.7 191.3l-39.7 581a64 64 0 0 1-63.8 59.7H315.8a64 64 0 0 1-63.9-59.6l-39.6-581.1A96 96 0 0 1 224 128zM276.5 320l39.3 576h392.4l4.8-70.8a224 224 0 0 1 30-439.8l4.5-65.4zM224 256h576a32 32 0 1 0 0-64H224a32 32 0 0 0 0 64m493.4 503.9 21.2-309.1a160 160 0 0 0-21.2 309"
    })]));
  }
}), milk_tea_default = _sfc_main168;

// src/components/minus.vue
import { defineComponent as _defineComponent169 } from "vue";
import { createElementVNode as _createElementVNode169, openBlock as _openBlock169, createElementBlock as _createElementBlock169 } from "vue";
var _sfc_main169 = /* @__PURE__ */ _defineComponent169({
  name: "Minus",
  __name: "minus",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock169(), _createElementBlock169("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode169("path", {
      fill: "currentColor",
      d: "M128 544h768a32 32 0 1 0 0-64H128a32 32 0 0 0 0 64"
    })]));
  }
}), minus_default = _sfc_main169;

// src/components/money.vue
import { defineComponent as _defineComponent170 } from "vue";
import { createElementVNode as _createElementVNode170, openBlock as _openBlock170, createElementBlock as _createElementBlock170 } from "vue";
var _sfc_main170 = /* @__PURE__ */ _defineComponent170({
  name: "Money",
  __name: "money",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock170(), _createElementBlock170("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode170("path", {
        fill: "currentColor",
        d: "M256 640v192h640V384H768v-64h151c14.2 0 19.4 1.5 24.6 4.3a29 29 0 0 1 12.2 12c2.7 5.3 4.2 10.5 4.2 24.7v494c0 14.2-1.5 19.4-4.3 24.6a29 29 0 0 1-12 12.2c-5.3 2.7-10.5 4.2-24.7 4.2H233c-14.2 0-19.4-1.5-24.6-4.3a29 29 0 0 1-12.2-12c-2.7-5.3-4.2-10.5-4.2-24.7V640z"
      }),
      _createElementVNode170("path", {
        fill: "currentColor",
        d: "M768 192H128v448h640zm64-23v494c0 14.2-1.5 19.4-4.3 24.6a29 29 0 0 1-12 12.2c-5.3 2.7-10.5 4.2-24.7 4.2H105c-14.2 0-19.4-1.5-24.6-4.3a29 29 0 0 1-12.2-12c-2.7-5.3-4.2-10.5-4.2-24.7V169c0-14.2 1.5-19.4 4.3-24.6a29 29 0 0 1 12-12.2c5.3-2.7 10.5-4.2 24.7-4.2h686c14.2 0 19.4 1.5 24.6 4.3a29 29 0 0 1 12.1 12c2.8 5.3 4.2 10.5 4.2 24.7z"
      }),
      _createElementVNode170("path", {
        fill: "currentColor",
        d: "M448 576a160 160 0 1 1 0-320 160 160 0 0 1 0 320m0-64a96 96 0 1 0 0-192 96 96 0 0 0 0 192"
      })
    ]));
  }
}), money_default = _sfc_main170;

// src/components/monitor.vue
import { defineComponent as _defineComponent171 } from "vue";
import { createElementVNode as _createElementVNode171, openBlock as _openBlock171, createElementBlock as _createElementBlock171 } from "vue";
var _sfc_main171 = /* @__PURE__ */ _defineComponent171({
  name: "Monitor",
  __name: "monitor",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock171(), _createElementBlock171("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode171("path", {
      fill: "currentColor",
      d: "M544 768v128h192a32 32 0 1 1 0 64H288a32 32 0 1 1 0-64h192V768H192A128 128 0 0 1 64 640V256a128 128 0 0 1 128-128h640a128 128 0 0 1 128 128v384a128 128 0 0 1-128 128zM192 192a64 64 0 0 0-64 64v384a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64z"
    })]));
  }
}), monitor_default = _sfc_main171;

// src/components/moon-night.vue
import { defineComponent as _defineComponent172 } from "vue";
import { createElementVNode as _createElementVNode172, openBlock as _openBlock172, createElementBlock as _createElementBlock172 } from "vue";
var _sfc_main172 = /* @__PURE__ */ _defineComponent172({
  name: "MoonNight",
  __name: "moon-night",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock172(), _createElementBlock172("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode172("path", {
      fill: "currentColor",
      d: "M384 512a448 448 0 0 1 215.9-383.3A384 384 0 0 0 213.8 640h188.8A448 448 0 0 1 384 512M171.1 704a448 448 0 0 1 637-575.3A384 384 0 0 0 499.3 704z"
    }), _createElementVNode172("path", {
      fill: "currentColor",
      d: "M32 640h960q32 0 32 32t-32 32H32q-32 0-32-32t32-32m128 128h384a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m160 127.7 224 .2a32 32 0 0 1 32 32v.1a32 32 0 0 1-32 32l-224-.4a32 32 0 0 1-32-32 32 32 0 0 1 32-32z"
    })]));
  }
}), moon_night_default = _sfc_main172;

// src/components/moon.vue
import { defineComponent as _defineComponent173 } from "vue";
import { createElementVNode as _createElementVNode173, openBlock as _openBlock173, createElementBlock as _createElementBlock173 } from "vue";
var _sfc_main173 = /* @__PURE__ */ _defineComponent173({
  name: "Moon",
  __name: "moon",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock173(), _createElementBlock173("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode173("path", {
      fill: "currentColor",
      d: "M240.4 240.4A384 384 0 1 0 800 766.1a448 448 0 0 1-542-542 391 391 0 0 0-17.5 16.3m181.1 362.1a384 384 0 0 0 525.6 16.4 448 448 0 1 1-542-542.1 384 384 0 0 0 16.4 525.7"
    })]));
  }
}), moon_default = _sfc_main173;

// src/components/more-filled.vue
import { defineComponent as _defineComponent174 } from "vue";
import { createElementVNode as _createElementVNode174, openBlock as _openBlock174, createElementBlock as _createElementBlock174 } from "vue";
var _sfc_main174 = /* @__PURE__ */ _defineComponent174({
  name: "MoreFilled",
  __name: "more-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock174(), _createElementBlock174("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode174("path", {
      fill: "currentColor",
      d: "M176 416a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224"
    })]));
  }
}), more_filled_default = _sfc_main174;

// src/components/more.vue
import { defineComponent as _defineComponent175 } from "vue";
import { createElementVNode as _createElementVNode175, openBlock as _openBlock175, createElementBlock as _createElementBlock175 } from "vue";
var _sfc_main175 = /* @__PURE__ */ _defineComponent175({
  name: "More",
  __name: "more",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock175(), _createElementBlock175("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode175("path", {
      fill: "currentColor",
      d: "M176 416a112 112 0 1 0 0 224 112 112 0 0 0 0-224m0 64a48 48 0 1 1 0 96 48 48 0 0 1 0-96m336-64a112 112 0 1 1 0 224 112 112 0 0 1 0-224m0 64a48 48 0 1 0 0 96 48 48 0 0 0 0-96m336-64a112 112 0 1 1 0 224 112 112 0 0 1 0-224m0 64a48 48 0 1 0 0 96 48 48 0 0 0 0-96"
    })]));
  }
}), more_default = _sfc_main175;

// src/components/mostly-cloudy.vue
import { defineComponent as _defineComponent176 } from "vue";
import { createElementVNode as _createElementVNode176, openBlock as _openBlock176, createElementBlock as _createElementBlock176 } from "vue";
var _sfc_main176 = /* @__PURE__ */ _defineComponent176({
  name: "MostlyCloudy",
  __name: "mostly-cloudy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock176(), _createElementBlock176("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode176("path", {
      fill: "currentColor",
      d: "m737.2 358-33.2-8.2-11.8-32a192 192 0 0 0-367.4 23l-9 39.1-39 9A192 192 0 0 0 320 768h368a208 208 0 0 0 207.8-208 208 208 0 0 0-158.6-202m15.2-62.3A272 272 0 0 1 959.7 560a272 272 0 0 1-271.5 272H320a256 256 0 0 1-57.5-505.5 256.1 256.1 0 0 1 489.9-30.8"
    })]));
  }
}), mostly_cloudy_default = _sfc_main176;

// src/components/mouse.vue
import { defineComponent as _defineComponent177 } from "vue";
import { createElementVNode as _createElementVNode177, openBlock as _openBlock177, createElementBlock as _createElementBlock177 } from "vue";
var _sfc_main177 = /* @__PURE__ */ _defineComponent177({
  name: "Mouse",
  __name: "mouse",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock177(), _createElementBlock177("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode177("path", {
      fill: "currentColor",
      d: "M438.1 256c-68.3 0-92.7 4.7-117.7 18.1q-30.2 16.1-46.3 46.3c-13.4 25-18.1 49.4-18.1 117.7V714c0 68.3 4.7 92.7 18.1 117.7q16.1 30.2 46.3 46.3c25 13.4 49.4 18.1 117.7 18.1H586c68.3 0 92.7-4.7 117.7-18.1q30.2-16.1 46.3-46.3c13.4-25 18.1-49.4 18.1-117.7V438c0-68.3-4.7-92.7-18.1-117.7a111 111 0 0 0-46.3-46.3c-25-13.4-49.4-18.1-117.7-18.1zm0-64H586c85.5 0 116.6 9 147.9 25.6a174 174 0 0 1 72.5 72.6c16.8 31.3 25.7 62.4 25.7 147.9v275.8c0 85.5-9 116.6-25.6 147.9a175 175 0 0 1-72.6 72.5c-31.3 16.8-62.4 25.7-147.9 25.7H438.1c-85.5 0-116.6-9-147.9-25.6a175 175 0 0 1-72.6-72.7c-16.8-31.3-25.7-62.3-25.7-147.8V438c0-85.5 9-116.5 25.6-147.8a175 175 0 0 1 72.8-72.6c31.2-16.7 62.3-25.6 147.8-25.6z"
    }), _createElementVNode177("path", {
      fill: "currentColor",
      d: "M512 320q32 0 32 32v128q0 32-32 32t-32-32V352q0-32 32-32m32-96a32 32 0 0 1-64 0v-64a32 32 0 0 0-32-32h-96a32 32 0 0 1 0-64h96a96 96 0 0 1 96 96z"
    })]));
  }
}), mouse_default = _sfc_main177;

// src/components/mug.vue
import { defineComponent as _defineComponent178 } from "vue";
import { createElementVNode as _createElementVNode178, openBlock as _openBlock178, createElementBlock as _createElementBlock178 } from "vue";
var _sfc_main178 = /* @__PURE__ */ _defineComponent178({
  name: "Mug",
  __name: "mug",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock178(), _createElementBlock178("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode178("path", {
      fill: "currentColor",
      d: "M736 800V160H160v640a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64m64-544h63.6a96 96 0 0 1 96 96v224a96 96 0 0 1-96 96H800v128a128 128 0 0 1-128 128H224A128 128 0 0 1 96 800V128a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 64v288h63.6a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32z"
    })]));
  }
}), mug_default = _sfc_main178;

// src/components/mute-notification.vue
import { defineComponent as _defineComponent179 } from "vue";
import { createElementVNode as _createElementVNode179, openBlock as _openBlock179, createElementBlock as _createElementBlock179 } from "vue";
var _sfc_main179 = /* @__PURE__ */ _defineComponent179({
  name: "MuteNotification",
  __name: "mute-notification",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock179(), _createElementBlock179("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode179("path", {
      fill: "currentColor",
      d: "m241.2 832 63.6-64H768V448c0-42.4-10.2-82.3-28.5-117.5l47-47.2A319 319 0 0 1 832 448v320h96a32 32 0 1 1 0 64zm-90.2 0H96a32 32 0 1 1 0-64h96V448a320 320 0 0 1 256-313.6V128a64 64 0 1 1 128 0v6.4a320 320 0 0 1 171.6 97L702.5 277A256 256 0 0 0 256 448v278.3zm297 64h128a64 64 0 0 1-128 0"
    }), _createElementVNode179("path", {
      fill: "currentColor",
      d: "M150.7 859a32 32 0 0 1-45.4-45l704-708.5a32 32 0 0 1 45.4 45z"
    })]));
  }
}), mute_notification_default = _sfc_main179;

// src/components/mute.vue
import { defineComponent as _defineComponent180 } from "vue";
import { createElementVNode as _createElementVNode180, openBlock as _openBlock180, createElementBlock as _createElementBlock180 } from "vue";
var _sfc_main180 = /* @__PURE__ */ _defineComponent180({
  name: "Mute",
  __name: "mute",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock180(), _createElementBlock180("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode180("path", {
      fill: "currentColor",
      d: "m412.2 592.1-45.5 45.5A191 191 0 0 1 320 512V256a192 192 0 1 1 384 0v44.4l-64 64V256a128 128 0 1 0-256 0v256c0 30.3 10.6 58.2 28.2 80.1m52 38.6A128 128 0 0 0 640 512v-57.2l64-64V512a192 192 0 0 1-287.7 166.5zM314.8 780l46.1-46.1A223 223 0 0 0 480 768h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64h64v-64a286 286 0 0 1-165.1-52m-48.1-42.4A287 287 0 0 1 192 544v-32a32 32 0 0 1 64 0v32c0 56.8 21.2 108.8 56 148.3z"
    }), _createElementVNode180("path", {
      fill: "currentColor",
      d: "M150.7 859a32 32 0 0 1-45.4-45l704-708.5a32 32 0 0 1 45.4 45z"
    })]));
  }
}), mute_default = _sfc_main180;

// src/components/no-smoking.vue
import { defineComponent as _defineComponent181 } from "vue";
import { createElementVNode as _createElementVNode181, openBlock as _openBlock181, createElementBlock as _createElementBlock181 } from "vue";
var _sfc_main181 = /* @__PURE__ */ _defineComponent181({
  name: "NoSmoking",
  __name: "no-smoking",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock181(), _createElementBlock181("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode181("path", {
      fill: "currentColor",
      d: "M440.3 576H256v128h56.3l-64 64H224a32 32 0 0 1-32-32V544a32 32 0 0 1 32-32h280.3zm143.4 128H704V583.7l71.7-71.7H928a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H519.7zM768 576v128h128V576zm-29.7-207.6 45.3 45.3-497.9 497.9-45.3-45.3zM256 64h64v320h-64zM128 192h64v192h-64zM64 512h64v256H64z"
    })]));
  }
}), no_smoking_default = _sfc_main181;

// src/components/notebook.vue
import { defineComponent as _defineComponent182 } from "vue";
import { createElementVNode as _createElementVNode182, openBlock as _openBlock182, createElementBlock as _createElementBlock182 } from "vue";
var _sfc_main182 = /* @__PURE__ */ _defineComponent182({
  name: "Notebook",
  __name: "notebook",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock182(), _createElementBlock182("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode182("path", {
      fill: "currentColor",
      d: "M192 128v768h640V128zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
    }), _createElementVNode182("path", {
      fill: "currentColor",
      d: "M672 128h64v768h-64zM96 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32"
    })]));
  }
}), notebook_default = _sfc_main182;

// src/components/notification.vue
import { defineComponent as _defineComponent183 } from "vue";
import { createElementVNode as _createElementVNode183, openBlock as _openBlock183, createElementBlock as _createElementBlock183 } from "vue";
var _sfc_main183 = /* @__PURE__ */ _defineComponent183({
  name: "Notification",
  __name: "notification",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock183(), _createElementBlock183("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode183("path", {
      fill: "currentColor",
      d: "M512 128v64H256a64 64 0 0 0-64 64v512a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V512h64v256a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V256a128 128 0 0 1 128-128z"
    }), _createElementVNode183("path", {
      fill: "currentColor",
      d: "M768 384a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
    })]));
  }
}), notification_default = _sfc_main183;

// src/components/odometer.vue
import { defineComponent as _defineComponent184 } from "vue";
import { createElementVNode as _createElementVNode184, openBlock as _openBlock184, createElementBlock as _createElementBlock184 } from "vue";
var _sfc_main184 = /* @__PURE__ */ _defineComponent184({
  name: "Odometer",
  __name: "odometer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock184(), _createElementBlock184("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode184("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      _createElementVNode184("path", {
        fill: "currentColor",
        d: "M192 512a320 320 0 1 1 640 0 32 32 0 1 1-64 0 256 256 0 1 0-512 0 32 32 0 0 1-64 0"
      }),
      _createElementVNode184("path", {
        fill: "currentColor",
        d: "M570.4 627.8a96 96 0 1 1-60.8-19.8l61-187.8a32 32 0 1 1 60.8 19.8zm-68.3 106.7a32 32 0 1 0 19.8-61 32 32 0 0 0-19.8 61"
      })
    ]));
  }
}), odometer_default = _sfc_main184;

// src/components/office-building.vue
import { defineComponent as _defineComponent185 } from "vue";
import { createElementVNode as _createElementVNode185, openBlock as _openBlock185, createElementBlock as _createElementBlock185 } from "vue";
var _sfc_main185 = /* @__PURE__ */ _defineComponent185({
  name: "OfficeBuilding",
  __name: "office-building",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock185(), _createElementBlock185("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode185("path", {
        fill: "currentColor",
        d: "M192 128v704h384V128zm-32-64h448a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      }),
      _createElementVNode185("path", {
        fill: "currentColor",
        d: "M256 256h256v64H256zm0 192h256v64H256zm0 192h256v64H256zm384-128h128v64H640zm0 128h128v64H640zM64 832h896v64H64z"
      }),
      _createElementVNode185("path", {
        fill: "currentColor",
        d: "M640 384v448h192V384zm-32-64h256a32 32 0 0 1 32 32v512a32 32 0 0 1-32 32H608a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32"
      })
    ]));
  }
}), office_building_default = _sfc_main185;

// src/components/open.vue
import { defineComponent as _defineComponent186 } from "vue";
import { createElementVNode as _createElementVNode186, openBlock as _openBlock186, createElementBlock as _createElementBlock186 } from "vue";
var _sfc_main186 = /* @__PURE__ */ _defineComponent186({
  name: "Open",
  __name: "open",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock186(), _createElementBlock186("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode186("path", {
      fill: "currentColor",
      d: "M330 257.1a254.9 254.9 0 0 0 0 509.8h364a254.9 254.9 0 0 0 0-509.8zm0-72.8h364a327.7 327.7 0 1 1 0 655.4H330a327.7 327.7 0 1 1 0-655.4"
    }), _createElementVNode186("path", {
      fill: "currentColor",
      d: "M694 621.2a109.2 109.2 0 1 0 0-218.4 109.2 109.2 0 0 0 0 218.4m0 72.8a182 182 0 1 1 0-364 182 182 0 0 1 0 364"
    })]));
  }
}), open_default = _sfc_main186;

// src/components/operation.vue
import { defineComponent as _defineComponent187 } from "vue";
import { createElementVNode as _createElementVNode187, openBlock as _openBlock187, createElementBlock as _createElementBlock187 } from "vue";
var _sfc_main187 = /* @__PURE__ */ _defineComponent187({
  name: "Operation",
  __name: "operation",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock187(), _createElementBlock187("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode187("path", {
      fill: "currentColor",
      d: "M389.4 768a96 96 0 0 1 181.2 0H896v64H570.6a96 96 0 0 1-181.2 0H128v-64zm192-288a96 96 0 0 1 181.2 0H896v64H762.6a96 96 0 0 1-181.2 0H128v-64zm-320-288a96 96 0 0 1 181.2 0H896v64H442.6a96 96 0 0 1-181.2 0H128v-64z"
    })]));
  }
}), operation_default = _sfc_main187;

// src/components/opportunity.vue
import { defineComponent as _defineComponent188 } from "vue";
import { createElementVNode as _createElementVNode188, openBlock as _openBlock188, createElementBlock as _createElementBlock188 } from "vue";
var _sfc_main188 = /* @__PURE__ */ _defineComponent188({
  name: "Opportunity",
  __name: "opportunity",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock188(), _createElementBlock188("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode188("path", {
      fill: "currentColor",
      d: "M384 960v-64h192v64zm448-544a351 351 0 0 1-128.3 271.4C665.3 719 640 763.8 640 813.5V832H320v-14.3c0-48-19.4-95.4-57.2-125a352 352 0 0 1-128.5-344.3A351 351 0 0 1 404.1 72 352.4 352.4 0 0 1 832 416m-544 32c0-132.3 75.9-224 192-224v-64c-154.4 0-256 122.8-256 288z"
    })]));
  }
}), opportunity_default = _sfc_main188;

// src/components/orange.vue
import { defineComponent as _defineComponent189 } from "vue";
import { createElementVNode as _createElementVNode189, openBlock as _openBlock189, createElementBlock as _createElementBlock189 } from "vue";
var _sfc_main189 = /* @__PURE__ */ _defineComponent189({
  name: "Orange",
  __name: "orange",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock189(), _createElementBlock189("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode189("path", {
      fill: "currentColor",
      d: "M544 894.7a382 382 0 0 0 216-89.5l-183-183q-15.3 9.1-33 13.8zM805.2 760A382 382 0 0 0 894.7 544H636q-4.6 17.7-13.7 33zM894.7 480a382 382 0 0 0-89.5-216l-183 183q9.1 15.3 13.8 33zM759.9 218.8A382 382 0 0 0 544 129.3V388q17.7 4.6 33 13.7zM480 129.3a382 382 0 0 0-216 89.5l183 183q15.3-9.2 33-13.8zM218.8 264.1A382 382 0 0 0 129.3 480H388q4.6-17.7 13.7-33zM129.3 544a382 382 0 0 0 89.5 216l183-183a127 127 0 0 1-13.8-33zm134.8 261.2A382 382 0 0 0 480 894.7V636a127 127 0 0 1-33-13.7zM512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896m0-384a64 64 0 1 0 0-128 64 64 0 0 0 0 128"
    })]));
  }
}), orange_default = _sfc_main189;

// src/components/paperclip.vue
import { defineComponent as _defineComponent190 } from "vue";
import { createElementVNode as _createElementVNode190, openBlock as _openBlock190, createElementBlock as _createElementBlock190 } from "vue";
var _sfc_main190 = /* @__PURE__ */ _defineComponent190({
  name: "Paperclip",
  __name: "paperclip",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock190(), _createElementBlock190("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode190("path", {
      fill: "currentColor",
      d: "M602.5 240.4A192 192 0 1 1 874 512L557.2 828.8a256 256 0 0 1-362-362L602.5 59.5l45.2 45.2L240.4 512A192 192 0 0 0 512 783.6l316.8-316.8a128 128 0 1 0-181-181.1L353.5 579.9a32 32 0 1 0 45.2 45.3L693 331l45.3 45.3-294.2 294.1a96 96 0 1 1-135.7-135.7z"
    })]));
  }
}), paperclip_default = _sfc_main190;

// src/components/partly-cloudy.vue
import { defineComponent as _defineComponent191 } from "vue";
import { createElementVNode as _createElementVNode191, openBlock as _openBlock191, createElementBlock as _createElementBlock191 } from "vue";
var _sfc_main191 = /* @__PURE__ */ _defineComponent191({
  name: "PartlyCloudy",
  __name: "partly-cloudy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock191(), _createElementBlock191("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode191("path", {
      fill: "currentColor",
      d: "M598.4 895.9H328.2a256 256 0 0 1-34.5-510.6A352 352 0 1 1 598.4 896m-271.4-64h272.3a288 288 0 1 0-248.5-417.7L335 445.4l-34.8 3.6A192 192 0 0 0 327.1 832z"
    }), _createElementVNode191("path", {
      fill: "currentColor",
      d: "M139.8 501.9a256 256 0 1 1 417.9-277.1 222 222 0 0 0-61.5 18.8 192 192 0 1 0-307 216.9z"
    })]));
  }
}), partly_cloudy_default = _sfc_main191;

// src/components/pear.vue
import { defineComponent as _defineComponent192 } from "vue";
import { createElementVNode as _createElementVNode192, openBlock as _openBlock192, createElementBlock as _createElementBlock192 } from "vue";
var _sfc_main192 = /* @__PURE__ */ _defineComponent192({
  name: "Pear",
  __name: "pear",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock192(), _createElementBlock192("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode192("path", {
      fill: "currentColor",
      d: "M542.3 258.8a443 443 0 0 0-9 25.1 32 32 0 1 1-60.8-20l1.1-3.4a163 163 0 0 0-122 131.4l-17.1 102.8-20.8 15.3C256.2 552.7 224 611 224 672c0 120.6 126.4 224 288 224s288-103.4 288-224c0-61.1-32.2-119.3-89.7-162l-20.8-15.3-17-102.8a163 163 0 0 0-130.2-133m-40-66.6Q514 169 528 148.5q34.9-51 78.6-77.1a32 32 0 1 1 32.7 55q-30.9 18.3-58.5 58.3a317 317 0 0 0-9.8 15.1 227 227 0 0 1 164.5 181.6l12.8 77.2C819.4 511.4 864 587.4 864 672c0 159-157.6 288-352 288S160 831 160 672c0-84.6 44.6-160.6 115.6-213.4l12.8-77.2A226.6 226.6 0 0 1 502 192.2z"
    })]));
  }
}), pear_default = _sfc_main192;

// src/components/phone-filled.vue
import { defineComponent as _defineComponent193 } from "vue";
import { createElementVNode as _createElementVNode193, openBlock as _openBlock193, createElementBlock as _createElementBlock193 } from "vue";
var _sfc_main193 = /* @__PURE__ */ _defineComponent193({
  name: "PhoneFilled",
  __name: "phone-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock193(), _createElementBlock193("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode193("path", {
      fill: "currentColor",
      d: "M199.2 125.6 90.6 379a32 32 0 0 0 6.8 35.2l512.4 512.4a32 32 0 0 0 35.2 6.8l253.4-108.6a32 32 0 0 0 10-52L769.7 633.8a32 32 0 0 0-37-6l-130.1 65.2L331 421.5l65-130.2a32 32 0 0 0-6-36.9L251.3 115.5a32 32 0 0 0-52 10"
    })]));
  }
}), phone_filled_default = _sfc_main193;

// src/components/phone.vue
import { defineComponent as _defineComponent194 } from "vue";
import { createElementVNode as _createElementVNode194, openBlock as _openBlock194, createElementBlock as _createElementBlock194 } from "vue";
var _sfc_main194 = /* @__PURE__ */ _defineComponent194({
  name: "Phone",
  __name: "phone",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock194(), _createElementBlock194("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode194("path", {
      fill: "currentColor",
      d: "m79.4 432.3 512.3 512.3a32 32 0 0 0 35.2 6.8L880.4 843a32 32 0 0 0 10-52l-153.9-154a32 32 0 0 0-37-6l-69.8 35-271.6-271.7 35-69.8a32 32 0 0 0-6-37l-154-153.8a32 32 0 0 0-52 10L72.5 397.1a32 32 0 0 0 6.8 35.2zm60.4-30 81.6-190 104.2 104.2-24.7 49.2-20.6 41.2 32.6 32.7L584.4 711l32.7 32.6 41.2-20.6 49.3-24.6 104.2 104.1-190.1 81.5zM512 320v-64a256 256 0 0 1 256 256h-64a192 192 0 0 0-192-192m0-192V64a448 448 0 0 1 448 448h-64a384 384 0 0 0-384-384"
    })]));
  }
}), phone_default = _sfc_main194;

// src/components/picture-filled.vue
import { defineComponent as _defineComponent195 } from "vue";
import { createElementVNode as _createElementVNode195, openBlock as _openBlock195, createElementBlock as _createElementBlock195 } from "vue";
var _sfc_main195 = /* @__PURE__ */ _defineComponent195({
  name: "PictureFilled",
  __name: "picture-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock195(), _createElementBlock195("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode195("path", {
      fill: "currentColor",
      d: "M96 896a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h832a32 32 0 0 1 32 32v704a32 32 0 0 1-32 32zm315.5-228.5-69-69a32 32 0 0 0-45.2 0L128 768.2h778.7L664.6 477.5a32 32 0 0 0-49.2 0l-156.6 188a32 32 0 0 1-47.3 2M256 384a96 96 0 1 0 192 0 96 96 0 0 0-192 0"
    })]));
  }
}), picture_filled_default = _sfc_main195;

// src/components/picture-rounded.vue
import { defineComponent as _defineComponent196 } from "vue";
import { createElementVNode as _createElementVNode196, openBlock as _openBlock196, createElementBlock as _createElementBlock196 } from "vue";
var _sfc_main196 = /* @__PURE__ */ _defineComponent196({
  name: "PictureRounded",
  __name: "picture-rounded",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock196(), _createElementBlock196("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode196("path", {
      fill: "currentColor",
      d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768m0-64a448 448 0 1 1 0 896 448 448 0 0 1 0-896"
    }), _createElementVNode196("path", {
      fill: "currentColor",
      d: "M640 288q64 0 64 64t-64 64-64-64 64-64M214.7 790.7l-45.4-45.4L355 559.7a96 96 0 0 1 123.7-10.2L617 648.2a32 32 0 0 0 39.8-2.2l249.9-223.6 42.6 47.7-249.8 223.6a96 96 0 0 1-119.8 6.6l-138.2-98.8a32 32 0 0 0-41.2 3.5L214.7 790.6z"
    })]));
  }
}), picture_rounded_default = _sfc_main196;

// src/components/picture.vue
import { defineComponent as _defineComponent197 } from "vue";
import { createElementVNode as _createElementVNode197, openBlock as _openBlock197, createElementBlock as _createElementBlock197 } from "vue";
var _sfc_main197 = /* @__PURE__ */ _defineComponent197({
  name: "Picture",
  __name: "picture",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock197(), _createElementBlock197("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode197("path", {
      fill: "currentColor",
      d: "M160 160v704h704V160zm-32-64h768a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32"
    }), _createElementVNode197("path", {
      fill: "currentColor",
      d: "M384 288q64 0 64 64t-64 64-64-64 64-64M185.4 877l-50.8-39 216.1-282a96 96 0 0 1 134.6-17.8l1.9 1.4L610 638.8a32 32 0 0 0 45-4.9L871 364l50 40-215.8 269.8-.3.3a96 96 0 0 1-135 14.5l-123-99.1-.6-.5a32 32 0 0 0-44.8 6z"
    })]));
  }
}), picture_default = _sfc_main197;

// src/components/pie-chart.vue
import { defineComponent as _defineComponent198 } from "vue";
import { createElementVNode as _createElementVNode198, openBlock as _openBlock198, createElementBlock as _createElementBlock198 } from "vue";
var _sfc_main198 = /* @__PURE__ */ _defineComponent198({
  name: "PieChart",
  __name: "pie-chart",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock198(), _createElementBlock198("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode198("path", {
      fill: "currentColor",
      d: "M448 68.5v64.8A384.1 384.1 0 0 0 512 896a384 384 0 0 0 378.7-320h64.8A448.1 448.1 0 0 1 64 512 448 448 0 0 1 448 68.5"
    }), _createElementVNode198("path", {
      fill: "currentColor",
      d: "M576 97.3V448h350.7A384 384 0 0 0 576 97.3M512 64V33.2A448 448 0 0 1 990.8 512H512z"
    })]));
  }
}), pie_chart_default = _sfc_main198;

// src/components/place.vue
import { defineComponent as _defineComponent199 } from "vue";
import { createElementVNode as _createElementVNode199, openBlock as _openBlock199, createElementBlock as _createElementBlock199 } from "vue";
var _sfc_main199 = /* @__PURE__ */ _defineComponent199({
  name: "Place",
  __name: "place",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock199(), _createElementBlock199("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode199("path", {
        fill: "currentColor",
        d: "M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
      }),
      _createElementVNode199("path", {
        fill: "currentColor",
        d: "M512 512a32 32 0 0 1 32 32v256a32 32 0 1 1-64 0V544a32 32 0 0 1 32-32"
      }),
      _createElementVNode199("path", {
        fill: "currentColor",
        d: "M384 649v65c-114.2 18.4-192 57.9-192 86 0 37.7 139.9 96 320 96s320-58.3 320-96c0-28.2-77.8-67.6-192-86v-65c149.1 22 256 81.4 256 151 0 88.3-171.9 160-384 160s-384-71.7-384-160c0-69.7 106.9-129 256-151"
      })
    ]));
  }
}), place_default = _sfc_main199;

// src/components/platform.vue
import { defineComponent as _defineComponent200 } from "vue";
import { createElementVNode as _createElementVNode200, openBlock as _openBlock200, createElementBlock as _createElementBlock200 } from "vue";
var _sfc_main200 = /* @__PURE__ */ _defineComponent200({
  name: "Platform",
  __name: "platform",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock200(), _createElementBlock200("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode200("path", {
      fill: "currentColor",
      d: "M448 832v-64h128v64h192v64H256v-64zM128 704V128h768v576z"
    })]));
  }
}), platform_default = _sfc_main200;

// src/components/plus.vue
import { defineComponent as _defineComponent201 } from "vue";
import { createElementVNode as _createElementVNode201, openBlock as _openBlock201, createElementBlock as _createElementBlock201 } from "vue";
var _sfc_main201 = /* @__PURE__ */ _defineComponent201({
  name: "Plus",
  __name: "plus",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock201(), _createElementBlock201("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode201("path", {
      fill: "currentColor",
      d: "M480 480V128a32 32 0 0 1 64 0v352h352a32 32 0 1 1 0 64H544v352a32 32 0 1 1-64 0V544H128a32 32 0 0 1 0-64z"
    })]));
  }
}), plus_default = _sfc_main201;

// src/components/pointer.vue
import { defineComponent as _defineComponent202 } from "vue";
import { createElementVNode as _createElementVNode202, openBlock as _openBlock202, createElementBlock as _createElementBlock202 } from "vue";
var _sfc_main202 = /* @__PURE__ */ _defineComponent202({
  name: "Pointer",
  __name: "pointer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock202(), _createElementBlock202("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode202("path", {
      fill: "currentColor",
      d: "M511.6 128a64.4 64.4 0 0 0-64.4 64.4V709L274 571a94 94 0 0 0-112.8-3.5 44.4 44.4 0 0 0-9 62.2l180.6 240.8A64 64 0 0 0 384 896h512V575.2a64 64 0 0 0-45.6-61.3l-206-61.7a96 96 0 0 1-68.4-92V192.4a64.4 64.4 0 0 0-64.4-64.4M359 556.8l24.2 19.2V192.4a128.4 128.4 0 1 1 256.8 0v167.8a32 32 0 0 0 22.8 30.6l206 61.8A128 128 0 0 1 960 575.2V896a64 64 0 0 1-64 64H384a128 128 0 0 1-102.4-51.2L101.1 668A108.4 108.4 0 0 1 128 512.5a158 158 0 0 1 186 8.3z"
    })]));
  }
}), pointer_default = _sfc_main202;

// src/components/position.vue
import { defineComponent as _defineComponent203 } from "vue";
import { createElementVNode as _createElementVNode203, openBlock as _openBlock203, createElementBlock as _createElementBlock203 } from "vue";
var _sfc_main203 = /* @__PURE__ */ _defineComponent203({
  name: "Position",
  __name: "position",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock203(), _createElementBlock203("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode203("path", {
      fill: "currentColor",
      d: "m249.6 417 319.7 43.2 39.2 310.2L845.1 179zm-129 47.3a32 32 0 0 1-7.7-61.5l777.8-311a32 32 0 0 1 41.6 41.6L622 909a32 32 0 0 1-61.5-7.9L512 517z"
    })]));
  }
}), position_default = _sfc_main203;

// src/components/postcard.vue
import { defineComponent as _defineComponent204 } from "vue";
import { createElementVNode as _createElementVNode204, openBlock as _openBlock204, createElementBlock as _createElementBlock204 } from "vue";
var _sfc_main204 = /* @__PURE__ */ _defineComponent204({
  name: "Postcard",
  __name: "postcard",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock204(), _createElementBlock204("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode204("path", {
      fill: "currentColor",
      d: "M160 224a32 32 0 0 0-32 32v512a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V256a32 32 0 0 0-32-32zm0-64h704a96 96 0 0 1 96 96v512a96 96 0 0 1-96 96H160a96 96 0 0 1-96-96V256a96 96 0 0 1 96-96"
    }), _createElementVNode204("path", {
      fill: "currentColor",
      d: "M704 320a64 64 0 1 1 0 128 64 64 0 0 1 0-128M288 448h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32m0 128h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
    })]));
  }
}), postcard_default = _sfc_main204;

// src/components/pouring.vue
import { defineComponent as _defineComponent205 } from "vue";
import { createElementVNode as _createElementVNode205, openBlock as _openBlock205, createElementBlock as _createElementBlock205 } from "vue";
var _sfc_main205 = /* @__PURE__ */ _defineComponent205({
  name: "Pouring",
  __name: "pouring",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock205(), _createElementBlock205("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode205("path", {
      fill: "currentColor",
      d: "m739.3 291.3-35.2-6.6-12.8-33.4a192 192 0 0 0-366 23.3l-9.8 40.9-41.5 7a176 176 0 0 0-146.3 173.6c0 97.2 78.8 175.9 175.9 175.9h400a192 192 0 0 0 35.7-380.7M959.6 480a256 256 0 0 1-256 256h-400A240 240 0 0 1 63.7 496.2a240 240 0 0 1 199.5-236.8 256.1 256.1 0 0 1 487.9-31A256 256 0 0 1 959.6 480M224 800a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32"
    })]));
  }
}), pouring_default = _sfc_main205;

// src/components/present.vue
import { defineComponent as _defineComponent206 } from "vue";
import { createElementVNode as _createElementVNode206, openBlock as _openBlock206, createElementBlock as _createElementBlock206 } from "vue";
var _sfc_main206 = /* @__PURE__ */ _defineComponent206({
  name: "Present",
  __name: "present",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock206(), _createElementBlock206("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode206("path", {
        fill: "currentColor",
        d: "M480 896V640H192v-64h288V320H192v576zm64 0h288V320H544v256h288v64H544zM128 256h768v672a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32z"
      }),
      _createElementVNode206("path", {
        fill: "currentColor",
        d: "M96 256h832q32 0 32 32t-32 32H96q-32 0-32-32t32-32"
      }),
      _createElementVNode206("path", {
        fill: "currentColor",
        d: "M416 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      }),
      _createElementVNode206("path", {
        fill: "currentColor",
        d: "M608 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      })
    ]));
  }
}), present_default = _sfc_main206;

// src/components/price-tag.vue
import { defineComponent as _defineComponent207 } from "vue";
import { createElementVNode as _createElementVNode207, openBlock as _openBlock207, createElementBlock as _createElementBlock207 } from "vue";
var _sfc_main207 = /* @__PURE__ */ _defineComponent207({
  name: "PriceTag",
  __name: "price-tag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock207(), _createElementBlock207("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode207("path", {
      fill: "currentColor",
      d: "M224 318.3V896h576V318.3L552.5 115.8a64 64 0 0 0-81 0zm369-252 259.2 212.1a32 32 0 0 1 11.8 24.8V928a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V303.2a32 32 0 0 1 11.7-24.8L431 66.3a128 128 0 0 1 162.1 0"
    }), _createElementVNode207("path", {
      fill: "currentColor",
      d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
    })]));
  }
}), price_tag_default = _sfc_main207;

// src/components/printer.vue
import { defineComponent as _defineComponent208 } from "vue";
import { createElementVNode as _createElementVNode208, openBlock as _openBlock208, createElementBlock as _createElementBlock208 } from "vue";
var _sfc_main208 = /* @__PURE__ */ _defineComponent208({
  name: "Printer",
  __name: "printer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock208(), _createElementBlock208("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode208("path", {
      fill: "currentColor",
      d: "M256 768H105c-14.2 0-19.4-1.5-24.6-4.3a29 29 0 0 1-12.2-12c-2.7-5.3-4.2-10.5-4.2-24.7V379c0-42.7 4.5-58.2 12.8-74a88 88 0 0 1 36.3-36.2c15.7-8.3 31.2-12.8 74-12.8H256V64h512v192h69c42.7 0 58.2 4.5 74 12.8a88 88 0 0 1 36.2 36.3c8.3 15.7 12.8 31.2 12.8 74V727c0 14.2-1.5 19.4-4.3 24.6a29 29 0 0 1-12 12.2c-5.3 2.7-10.5 4.2-24.7 4.2H768v192H256zm64-192v320h384V576zm-64 128V512h512v192h128V379c0-29.3-1.4-36.4-5.2-43.7a23 23 0 0 0-10.1-10c-7.2-3.9-14.4-5.3-43.8-5.3H187.1c-29.4 0-36.5 1.4-43.8 5.2a23 23 0 0 0-10 10.1c-3.9 7.2-5.3 14.4-5.3 43.8V704zm64-448h384V128H320zm-64 128h64v64h-64zm128 0h64v64h-64z"
    })]));
  }
}), printer_default = _sfc_main208;

// src/components/promotion.vue
import { defineComponent as _defineComponent209 } from "vue";
import { createElementVNode as _createElementVNode209, openBlock as _openBlock209, createElementBlock as _createElementBlock209 } from "vue";
var _sfc_main209 = /* @__PURE__ */ _defineComponent209({
  name: "Promotion",
  __name: "promotion",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock209(), _createElementBlock209("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode209("path", {
      fill: "currentColor",
      d: "m64 448 832-320-128 704-446-243.3L832 192 242.8 545.5zm256 512V657l192 111z"
    })]));
  }
}), promotion_default = _sfc_main209;

// src/components/quartz-watch.vue
import { defineComponent as _defineComponent210 } from "vue";
import { createElementVNode as _createElementVNode210, openBlock as _openBlock210, createElementBlock as _createElementBlock210 } from "vue";
var _sfc_main210 = /* @__PURE__ */ _defineComponent210({
  name: "QuartzWatch",
  __name: "quartz-watch",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock210(), _createElementBlock210("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode210("path", {
        fill: "currentColor",
        d: "M422 602q-10-9-23-8.5t-22.5 10-9.5 22c0 12.4 3 15.8 9 22.5q13 13 31 8c18-5 19.5-10.8 22.5-22.5s.5-22.1-7.5-31.5m-38-90q0-14-9-23t-23-9c-14 0-17 3-23 9q-9 9-9 23c0 14 3 17 9 23q9 9 23 9c14 0 17-3 23-9q9-9 9-23m6.5-82.5Q408 434 422 422q9-10 8.6-23c-.4-13-3.7-16.2-10-22.5q-9.6-9.5-22-9.5c-12.5 0-15.9 3-22.6 9a30 30 0 0 0-8 31q5 18 22.5 22.5m243 0q17.5-4.5 22-22T648 376q-10-9-22.5-9c-12.5 0-15.7 3.2-22 9.5q-9.5 9.5-10 22.5a32 32 0 0 0 8.5 23 33 33 0 0 0 31.5 7.5M512 640q-14 0-23 9t-9 23c0 14 3 17 9 23q9 9 23 9t23-9 9-23c0-14-3-17-9-23q-9-9-23-9m183-151q-9-9-23-9c-14 0-17 3-23 9q-9 9-9 23c0 14 3 17 9 23q9 9 23 9c14 0 17-3 23-9q9-9 9-23t-9-23"
      }),
      _createElementVNode210("path", {
        fill: "currentColor",
        d: "M832 512q-3-136-93.5-226.5a318 318 0 0 0-66.5-51.2V64H352v170.3a318 318 0 0 0-66.5 51.2Q195 376 192 512q3 136 93.5 226.5a318 318 0 0 0 66.5 51.2V960h320V789.7a318 318 0 0 0 66.5-51.2Q829 648.1 832 512M416 128h192v78.7Q563.3 193 512 192q-51.2 1.2-96 14.7zm192 768H416v-78.7q44.8 13.6 96 14.7 51.3-1.2 96-14.7zm-96-128q-109-3-181-75c-72-72-73-108.3-75-181q3-109 75-181c72-72 108.3-73 181-75q109 3 181 75c72 72 73 108.3 75 181q-3 109-75 181c-72 72-108.3 73-181 75"
      }),
      _createElementVNode210("path", {
        fill: "currentColor",
        d: "M512 320q-14 0-23 9t-9 23c0 14 3 17 9 23q9 9 23 9t23-9 9-23c0-14-3-17-9-23q-9-9-23-9m113 273.5a32 32 0 0 0-23 8.5q-12 14-7.5 31.5C599 651 605 652.7 617 656s22.3.7 31-8q9-9.9 9-22.5c0-12.6-3.2-15.6-9.5-22s-13.8-9.7-22.5-10"
      })
    ]));
  }
}), quartz_watch_default = _sfc_main210;

// src/components/question-filled.vue
import { defineComponent as _defineComponent211 } from "vue";
import { createElementVNode as _createElementVNode211, openBlock as _openBlock211, createElementBlock as _createElementBlock211 } from "vue";
var _sfc_main211 = /* @__PURE__ */ _defineComponent211({
  name: "QuestionFilled",
  __name: "question-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock211(), _createElementBlock211("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode211("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m23.7 191.5q-77.9 0-123.2 44.3c-31 29.6-45.7 70.4-45.7 122.5H447c0-29.5 5.7-52.8 17.6-69 13.4-19.7 35.2-28.8 66.2-28.8q36.2-.2 56.3 19.7a77 77 0 0 1 19.7 54.9 78 78 0 0 1-19 50l-8.4 9.8c-45.8 40.9-73.2 70.4-82.4 89.5-9.8 19-14 42.2-14 69v9.8h80.9v-9.9c0-16.9 3.5-31.6 10.6-45.7a109 109 0 0 1 28.1-35.2c33.8-29.6 54.2-48.6 60.6-55.6 16.9-22.6 26-51.4 26-86.6q0-64.4-42.2-101.4c-28.2-25.3-65.5-37.3-111.3-37.3m-12.6 406.2a54 54 0 0 0-38.7 14.8 49 49 0 0 0-15.5 38c0 15.5 4.9 28.2 15.5 38A55 55 0 0 0 523 768c15.5 0 28.1-5 38.7-14.8a52 52 0 0 0 16.2-38.7 52 52 0 0 0-15.5-38 56 56 0 0 0-39.4-14.8"
    })]));
  }
}), question_filled_default = _sfc_main211;

// src/components/rank.vue
import { defineComponent as _defineComponent212 } from "vue";
import { createElementVNode as _createElementVNode212, openBlock as _openBlock212, createElementBlock as _createElementBlock212 } from "vue";
var _sfc_main212 = /* @__PURE__ */ _defineComponent212({
  name: "Rank",
  __name: "rank",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock212(), _createElementBlock212("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode212("path", {
      fill: "currentColor",
      d: "m186.5 544 41.4 41.3a32 32 0 1 1-45.2 45.4l-96-96a32 32 0 0 1 0-45.4l96-96a32 32 0 1 1 45.2 45.4L186.5 480h290.8V186.4L435.8 228a32 32 0 1 1-45.2-45.2l96-96.1a32 32 0 0 1 45.3 0l96 96a32 32 0 0 1-45.2 45.2l-41.4-41.2V480H832l-41.3-41.3a32 32 0 0 1 45.2-45.4l96 96a32 32 0 0 1 0 45.4l-96 96a32 32 0 0 1-45.2-45.4L832 544H541.3v293.4l41.4-41.2a32 32 0 1 1 45.2 45.2l-96 96a32 32 0 0 1-45.3 0l-96-96a32 32 0 1 1 45.3-45.2l41.4 41.4V544z"
    })]));
  }
}), rank_default = _sfc_main212;

// src/components/reading-lamp.vue
import { defineComponent as _defineComponent213 } from "vue";
import { createElementVNode as _createElementVNode213, openBlock as _openBlock213, createElementBlock as _createElementBlock213 } from "vue";
var _sfc_main213 = /* @__PURE__ */ _defineComponent213({
  name: "ReadingLamp",
  __name: "reading-lamp",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock213(), _createElementBlock213("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode213("path", {
      fill: "currentColor",
      d: "M352 896h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m-44.7-768-99.5 448h608.4l-99.5-448zm-25.6-64h460.6a32 32 0 0 1 31.3 25l113.8 512a32 32 0 0 1-31.3 39H168a32 32 0 0 1-31.3-39L250.4 89a32 32 0 0 1 31.3-25z"
    }), _createElementVNode213("path", {
      fill: "currentColor",
      d: "M672 576q32 0 32 32v128q0 32-32 32t-32-32V608q0-32 32-32m-192 0h64v384h-64z"
    })]));
  }
}), reading_lamp_default = _sfc_main213;

// src/components/reading.vue
import { defineComponent as _defineComponent214 } from "vue";
import { createElementVNode as _createElementVNode214, openBlock as _openBlock214, createElementBlock as _createElementBlock214 } from "vue";
var _sfc_main214 = /* @__PURE__ */ _defineComponent214({
  name: "Reading",
  __name: "reading",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock214(), _createElementBlock214("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode214("path", {
      fill: "currentColor",
      d: "m512 863.4 384-54.9V169.8l-370.4 53a96 96 0 0 1-27.2 0l-370.4-53v638.7zm-375-757 370.5 53a32 32 0 0 0 9 0l370.5-53a64 64 0 0 1 73 63.4v638.7a64 64 0 0 1-55 63.4l-388.5 55.5a32 32 0 0 1-9 0L119 871.9a64 64 0 0 1-55-63.4V169.8a64 64 0 0 1 73-63.4"
    }), _createElementVNode214("path", {
      fill: "currentColor",
      d: "M480 192h64v704h-64z"
    })]));
  }
}), reading_default = _sfc_main214;

// src/components/refresh-left.vue
import { defineComponent as _defineComponent215 } from "vue";
import { createElementVNode as _createElementVNode215, openBlock as _openBlock215, createElementBlock as _createElementBlock215 } from "vue";
var _sfc_main215 = /* @__PURE__ */ _defineComponent215({
  name: "RefreshLeft",
  __name: "refresh-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock215(), _createElementBlock215("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode215("path", {
      fill: "currentColor",
      d: "M289 296.7h93a32 32 0 0 1 0 64H233a32 32 0 0 1-32-32v-149a32 32 0 0 1 64 0v50.6a384 384 0 0 1 643.8 282.9 384 384 0 0 1-384 384 384 384 0 0 1-384-384h64a320 320 0 1 0 640 0 320 320 0 0 0-555.6-216.5z"
    })]));
  }
}), refresh_left_default = _sfc_main215;

// src/components/refresh-right.vue
import { defineComponent as _defineComponent216 } from "vue";
import { createElementVNode as _createElementVNode216, openBlock as _openBlock216, createElementBlock as _createElementBlock216 } from "vue";
var _sfc_main216 = /* @__PURE__ */ _defineComponent216({
  name: "RefreshRight",
  __name: "refresh-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock216(), _createElementBlock216("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode216("path", {
      fill: "currentColor",
      d: "M784.5 230.3v-50.6a32 32 0 1 1 64 0v149a32 32 0 0 1-32 32h-149a32 32 0 1 1 0-64h93a320 320 0 1 0-235.7 536.5 320 320 0 0 0 320-320h64a384 384 0 0 1-384 384 384 384 0 0 1-384-384 384 384 0 0 1 643.7-283"
    })]));
  }
}), refresh_right_default = _sfc_main216;

// src/components/refresh.vue
import { defineComponent as _defineComponent217 } from "vue";
import { createElementVNode as _createElementVNode217, openBlock as _openBlock217, createElementBlock as _createElementBlock217 } from "vue";
var _sfc_main217 = /* @__PURE__ */ _defineComponent217({
  name: "Refresh",
  __name: "refresh",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock217(), _createElementBlock217("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode217("path", {
      fill: "currentColor",
      d: "M771.8 794.9A384 384 0 0 1 128 512h64a320 320 0 0 0 555.7 216.4h-93a32 32 0 1 1 0-64h149a32 32 0 0 1 32 32v149a32 32 0 1 1-64 0zM276.3 295.6h93a32 32 0 0 1 0 64H220.2a32 32 0 0 1-32-32v-149a32 32 0 0 1 64 0V229a384 384 0 0 1 644 282.9h-64a320 320 0 0 0-555.8-216.4z"
    })]));
  }
}), refresh_default = _sfc_main217;

// src/components/refrigerator.vue
import { defineComponent as _defineComponent218 } from "vue";
import { createElementVNode as _createElementVNode218, openBlock as _openBlock218, createElementBlock as _createElementBlock218 } from "vue";
var _sfc_main218 = /* @__PURE__ */ _defineComponent218({
  name: "Refrigerator",
  __name: "refrigerator",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock218(), _createElementBlock218("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode218("path", {
      fill: "currentColor",
      d: "M256 448h512V160a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32zm0 64v352a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V512zm32-448h448a96 96 0 0 1 96 96v704a96 96 0 0 1-96 96H288a96 96 0 0 1-96-96V160a96 96 0 0 1 96-96m32 224h64v96h-64zm0 288h64v96h-64z"
    })]));
  }
}), refrigerator_default = _sfc_main218;

// src/components/remove-filled.vue
import { defineComponent as _defineComponent219 } from "vue";
import { createElementVNode as _createElementVNode219, openBlock as _openBlock219, createElementBlock as _createElementBlock219 } from "vue";
var _sfc_main219 = /* @__PURE__ */ _defineComponent219({
  name: "RemoveFilled",
  __name: "remove-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock219(), _createElementBlock219("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode219("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896M288 512a38.4 38.4 0 0 0 38.4 38.4h371.2a38.4 38.4 0 0 0 0-76.8H326.4A38.4 38.4 0 0 0 288 512"
    })]));
  }
}), remove_filled_default = _sfc_main219;

// src/components/remove.vue
import { defineComponent as _defineComponent220 } from "vue";
import { createElementVNode as _createElementVNode220, openBlock as _openBlock220, createElementBlock as _createElementBlock220 } from "vue";
var _sfc_main220 = /* @__PURE__ */ _defineComponent220({
  name: "Remove",
  __name: "remove",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock220(), _createElementBlock220("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode220("path", {
      fill: "currentColor",
      d: "M352 480h320a32 32 0 1 1 0 64H352a32 32 0 0 1 0-64"
    }), _createElementVNode220("path", {
      fill: "currentColor",
      d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
    })]));
  }
}), remove_default = _sfc_main220;

// src/components/right.vue
import { defineComponent as _defineComponent221 } from "vue";
import { createElementVNode as _createElementVNode221, openBlock as _openBlock221, createElementBlock as _createElementBlock221 } from "vue";
var _sfc_main221 = /* @__PURE__ */ _defineComponent221({
  name: "Right",
  __name: "right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock221(), _createElementBlock221("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode221("path", {
      fill: "currentColor",
      d: "M754.8 480H160a32 32 0 1 0 0 64h594.8L521.3 777.3a32 32 0 0 0 45.4 45.4l288-288a32 32 0 0 0 0-45.4l-288-288a32 32 0 1 0-45.4 45.4z"
    })]));
  }
}), right_default = _sfc_main221;

// src/components/robot.vue
import { defineComponent as _defineComponent222 } from "vue";
import { createElementVNode as _createElementVNode222, openBlock as _openBlock222, createElementBlock as _createElementBlock222 } from "vue";
var _sfc_main222 = /* @__PURE__ */ _defineComponent222({
  name: "Robot",
  __name: "robot",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock222(), _createElementBlock222("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode222("path", {
      fill: "currentColor",
      d: "M800 192H544V64a32 32 0 0 0-64 0v128H224A128 128 0 0 0 96 320v448a128 128 0 0 0 128 128h576a128 128 0 0 0 128-128V320a128 128 0 0 0-128-128m64 576a64 64 0 0 1-64 64H224a64 64 0 0 1-64-64V320a64 64 0 0 1 64-64h576a64 64 0 0 1 64 64zM656 544H368a112 112 0 0 0 0 224h288a112 112 0 0 0 0-224m-96 64v96h-96v-96zm-240 48a48 48 0 0 1 48-48h32v96h-32a48 48 0 0 1-48-48m336 48h-32v-96h32a48 48 0 0 1 0 96M288 432a48 48 0 1 1 48 48 48 48 0 0 1-48-48m352 0a48 48 0 1 1 48 48 48 48 0 0 1-48-48"
    })]));
  }
}), robot_default = _sfc_main222;

// src/components/scale-to-original.vue
import { defineComponent as _defineComponent223 } from "vue";
import { createElementVNode as _createElementVNode223, openBlock as _openBlock223, createElementBlock as _createElementBlock223 } from "vue";
var _sfc_main223 = /* @__PURE__ */ _defineComponent223({
  name: "ScaleToOriginal",
  __name: "scale-to-original",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock223(), _createElementBlock223("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode223("path", {
      fill: "currentColor",
      d: "M813.2 180.7a60 60 0 0 1 60.2 60.2v482a60 60 0 0 1-60.2 60.2H210.8a60 60 0 0 1-60.2-60.3V241a60 60 0 0 1 60.2-60.2zm0-60.2H210.8A120.5 120.5 0 0 0 90.4 240.9v482a120.5 120.5 0 0 0 120.4 120.4h602.4a120.5 120.5 0 0 0 120.4-120.5V241a120.5 120.5 0 0 0-120.4-120.4M692.7 301.2a30 30 0 0 0-30.1 30v301.3a30.1 30.1 0 0 0 60.2 0V331.3a30 30 0 0 0-30-30.1m-361.5 0a30 30 0 0 0-30.1 30v301.3a30.1 30.1 0 1 0 60.2 0V331.3a30 30 0 0 0-30.1-30.1M512 361.4a30 30 0 0 0-30.1 30.1v30.1a30.1 30.1 0 0 0 60.2 0v-30a30 30 0 0 0-30.1-30.2m0 150.6a30 30 0 0 0-30.1 30.1v30.1a30.1 30.1 0 0 0 60.2 0v-30A30 30 0 0 0 512 512"
    })]));
  }
}), scale_to_original_default = _sfc_main223;

// src/components/school.vue
import { defineComponent as _defineComponent224 } from "vue";
import { createElementVNode as _createElementVNode224, openBlock as _openBlock224, createElementBlock as _createElementBlock224 } from "vue";
var _sfc_main224 = /* @__PURE__ */ _defineComponent224({
  name: "School",
  __name: "school",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock224(), _createElementBlock224("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode224("path", {
        fill: "currentColor",
        d: "M224 128v704h576V128zm-32-64h640a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      }),
      _createElementVNode224("path", {
        fill: "currentColor",
        d: "M64 832h896v64H64zm256-640h128v96H320z"
      }),
      _createElementVNode224("path", {
        fill: "currentColor",
        d: "M384 832h256v-64a128 128 0 1 0-256 0zm128-256a192 192 0 0 1 192 192v128H320V768a192 192 0 0 1 192-192M320 384h128v96H320zm256-192h128v96H576zm0 192h128v96H576z"
      })
    ]));
  }
}), school_default = _sfc_main224;

// src/components/scissor.vue
import { defineComponent as _defineComponent225 } from "vue";
import { createElementVNode as _createElementVNode225, openBlock as _openBlock225, createElementBlock as _createElementBlock225 } from "vue";
var _sfc_main225 = /* @__PURE__ */ _defineComponent225({
  name: "Scissor",
  __name: "scissor",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock225(), _createElementBlock225("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode225("path", {
      fill: "currentColor",
      d: "M512 578.4 405.3 731a160 160 0 1 1-23.4-78.2L473 522.6 196.9 128.3a32 32 0 1 1 52.4-36.8l393 561.4A160 160 0 1 1 619 731L512.1 578.4zM566.6 389 774.8 91.5a32 32 0 0 1 52.5 36.8L605.6 444.9zM190 815a96 96 0 1 0 110.2-157.3 96 96 0 0 0-110 157.3zm643.9 0a96 96 0 1 0-110.1-157.3 96 96 0 0 0 110 157.3"
    })]));
  }
}), scissor_default = _sfc_main225;

// src/components/search.vue
import { defineComponent as _defineComponent226 } from "vue";
import { createElementVNode as _createElementVNode226, openBlock as _openBlock226, createElementBlock as _createElementBlock226 } from "vue";
var _sfc_main226 = /* @__PURE__ */ _defineComponent226({
  name: "Search",
  __name: "search",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock226(), _createElementBlock226("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode226("path", {
      fill: "currentColor",
      d: "m795.9 750.7 125 125a32 32 0 0 1-45.3 45.2l-125-125a416 416 0 1 1 45.3-45.2zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704"
    })]));
  }
}), search_default = _sfc_main226;

// src/components/select.vue
import { defineComponent as _defineComponent227 } from "vue";
import { createElementVNode as _createElementVNode227, openBlock as _openBlock227, createElementBlock as _createElementBlock227 } from "vue";
var _sfc_main227 = /* @__PURE__ */ _defineComponent227({
  name: "Select",
  __name: "select",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock227(), _createElementBlock227("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode227("path", {
      fill: "currentColor",
      d: "M77.2 415a64 64 0 0 1 90.5 0L394 641.3l452.5-452.5a64 64 0 1 1 90.6 90.5l-543 543L77.1 505.5a64 64 0 0 1 0-90.5"
    })]));
  }
}), select_default = _sfc_main227;

// src/components/sell.vue
import { defineComponent as _defineComponent228 } from "vue";
import { createElementVNode as _createElementVNode228, openBlock as _openBlock228, createElementBlock as _createElementBlock228 } from "vue";
var _sfc_main228 = /* @__PURE__ */ _defineComponent228({
  name: "Sell",
  __name: "sell",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock228(), _createElementBlock228("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode228("path", {
      fill: "currentColor",
      d: "M704 288h131a32 32 0 0 1 31.9 28.8L886.4 512H822l-16-160H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0v-96H218l-51.3 512H512v64H131.3a32 32 0 0 1-31.8-35.2l57.6-576A32 32 0 0 1 189 288H320v-22.3C320 154.7 405.5 64 512 64s192 90.7 192 201.7zm-64 0v-22.3c0-76.5-57.7-137.7-128-137.7s-128 61.2-128 137.7V288zm201.4 483.8L768 698.5V928a32 32 0 1 1-64 0V698.5l-73.3 73.3a32 32 0 1 1-45.3-45.2l128-128a32 32 0 0 1 45.3 0l128 128a32 32 0 1 1-45.3 45.2"
    })]));
  }
}), sell_default = _sfc_main228;

// src/components/semi-select.vue
import { defineComponent as _defineComponent229 } from "vue";
import { createElementVNode as _createElementVNode229, openBlock as _openBlock229, createElementBlock as _createElementBlock229 } from "vue";
var _sfc_main229 = /* @__PURE__ */ _defineComponent229({
  name: "SemiSelect",
  __name: "semi-select",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock229(), _createElementBlock229("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode229("path", {
      fill: "currentColor",
      d: "M128 448h768q64 0 64 64t-64 64H128q-64 0-64-64t64-64"
    })]));
  }
}), semi_select_default = _sfc_main229;

// src/components/service.vue
import { defineComponent as _defineComponent230 } from "vue";
import { createElementVNode as _createElementVNode230, openBlock as _openBlock230, createElementBlock as _createElementBlock230 } from "vue";
var _sfc_main230 = /* @__PURE__ */ _defineComponent230({
  name: "Service",
  __name: "service",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock230(), _createElementBlock230("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode230("path", {
      fill: "currentColor",
      d: "M864 409.6A192 192 0 0 1 826.1 759 256 256 0 0 1 576 960h-96a32 32 0 1 1 0-64h96a192 192 0 0 0 181.1-128H736a32 32 0 0 1-32-32V416a32 32 0 0 1 32-32h32q15.5 0 30.5 2.4a288 288 0 0 0-573 0A193 193 0 0 1 256 384h32a32 32 0 0 1 32 32v320a32 32 0 0 1-32 32h-32a192 192 0 0 1-96-358.4 352 352 0 0 1 704 0M256 448a128 128 0 1 0 0 256zm640 128a128 128 0 0 0-128-128v256a128 128 0 0 0 128-128"
    })]));
  }
}), service_default = _sfc_main230;

// src/components/set-up.vue
import { defineComponent as _defineComponent231 } from "vue";
import { createElementVNode as _createElementVNode231, openBlock as _openBlock231, createElementBlock as _createElementBlock231 } from "vue";
var _sfc_main231 = /* @__PURE__ */ _defineComponent231({
  name: "SetUp",
  __name: "set-up",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock231(), _createElementBlock231("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode231("path", {
        fill: "currentColor",
        d: "M224 160a64 64 0 0 0-64 64v576a64 64 0 0 0 64 64h576a64 64 0 0 0 64-64V224a64 64 0 0 0-64-64zm0-64h576a128 128 0 0 1 128 128v576a128 128 0 0 1-128 128H224A128 128 0 0 1 96 800V224A128 128 0 0 1 224 96"
      }),
      _createElementVNode231("path", {
        fill: "currentColor",
        d: "M384 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      }),
      _createElementVNode231("path", {
        fill: "currentColor",
        d: "M480 320h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32m160 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      }),
      _createElementVNode231("path", {
        fill: "currentColor",
        d: "M288 640h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      })
    ]));
  }
}), set_up_default = _sfc_main231;

// src/components/setting.vue
import { defineComponent as _defineComponent232 } from "vue";
import { createElementVNode as _createElementVNode232, openBlock as _openBlock232, createElementBlock as _createElementBlock232 } from "vue";
var _sfc_main232 = /* @__PURE__ */ _defineComponent232({
  name: "Setting",
  __name: "setting",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock232(), _createElementBlock232("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode232("path", {
      fill: "currentColor",
      d: "M600.7 64a32 32 0 0 1 30.5 22.2l35.2 109.4a348 348 0 0 1 42.4 24.5l112.4-24.2a32 32 0 0 1 34.4 15.4l88.7 153.5a32 32 0 0 1-4 37.5l-77.1 85.1a357 357 0 0 1 0 49l77 85.3a32 32 0 0 1 4.1 37.5l-88.7 153.6a32 32 0 0 1-34.4 15.3l-112.4-24.2q-20.2 13.6-42.4 24.5l-35.2 109.4a32 32 0 0 1-30.5 22.2H423.3a32 32 0 0 1-30.5-22.2l-35.1-109.3a352 352 0 0 1-42.6-24.7l-112.3 24.3a32 32 0 0 1-34.4-15.4L79.7 659.2a32 32 0 0 1 4-37.5l77.1-85.3a357 357 0 0 1 0-48.8l-77-85.3a32 32 0 0 1-4.1-37.5l88.7-153.6a32 32 0 0 1 34.4-15.3l112.3 24.3a355 355 0 0 1 42.6-24.7l35.2-109.3A32 32 0 0 1 423.2 64zm-23.4 64H446.7l-36.3 113-24.5 12a294 294 0 0 0-34.9 20.2l-22.6 15.3-116.2-25-65.3 113 79.7 88.3-2 27.1a293 293 0 0 0 0 40.2l2 27.1-79.8 88.2L212 760.6l116.2-25 22.7 15.2a294 294 0 0 0 34.8 20.1l24.5 12L446.7 896h130.7L614 782.8l24.4-11.9a288 288 0 0 0 34.8-20l22.6-15.3 116.3 25 65.2-113.2-79.7-88.2 2-27.1a293 293 0 0 0 0-40.3l-2-27.1 79.8-88.1L812 263.4l-116.3 25-22.6-15.2a288 288 0 0 0-34.8-20.1L614 241zM512 320a192 192 0 1 1 0 384 192 192 0 0 1 0-384m0 64a128 128 0 1 0 0 256 128 128 0 0 0 0-256"
    })]));
  }
}), setting_default = _sfc_main232;

// src/components/share.vue
import { defineComponent as _defineComponent233 } from "vue";
import { createElementVNode as _createElementVNode233, openBlock as _openBlock233, createElementBlock as _createElementBlock233 } from "vue";
var _sfc_main233 = /* @__PURE__ */ _defineComponent233({
  name: "Share",
  __name: "share",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock233(), _createElementBlock233("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode233("path", {
      fill: "currentColor",
      d: "M679.9 348.8 378 537.4a128 128 0 0 1 5.1 52.2l280 105a128 128 0 1 1-22.5 59.8l-279.9-105a128 128 0 1 1-16.6-166.2l301.7-188.6a128 128 0 1 1 34 54.3z"
    })]));
  }
}), share_default = _sfc_main233;

// src/components/ship.vue
import { defineComponent as _defineComponent234 } from "vue";
import { createElementVNode as _createElementVNode234, openBlock as _openBlock234, createElementBlock as _createElementBlock234 } from "vue";
var _sfc_main234 = /* @__PURE__ */ _defineComponent234({
  name: "Ship",
  __name: "ship",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock234(), _createElementBlock234("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode234("path", {
      fill: "currentColor",
      d: "M512 386.9V448h405.6a32 32 0 0 1 30.7 40.8l-76.5 268A192 192 0 0 1 687.2 896H336.8a192 192 0 0 1-184.6-139.3l-76.6-268a32 32 0 0 1 30.8-40.7H448V117.9a32 32 0 0 1 47.4-28.1l13.8 7.6L512 96v2.9l231.7 126.4a32 32 0 0 1-2 57.2zm0-70.3 144.8-65.8-144.8-79zm0 195.4H148.9l18.2 64H857l18.2-64zM185.4 640l28.4 99.2a128 128 0 0 0 123 92.8h350.4a128 128 0 0 0 123-92.8l28.4-99.2z"
    })]));
  }
}), ship_default = _sfc_main234;

// src/components/shop.vue
import { defineComponent as _defineComponent235 } from "vue";
import { createElementVNode as _createElementVNode235, openBlock as _openBlock235, createElementBlock as _createElementBlock235 } from "vue";
var _sfc_main235 = /* @__PURE__ */ _defineComponent235({
  name: "Shop",
  __name: "shop",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock235(), _createElementBlock235("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode235("path", {
      fill: "currentColor",
      d: "M704 704h64v192H256V704h64v64h384zm188.5-152.2c2 7.8 3.5 15.8 3.5 24.2a96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0c0-8.4 1.4-16.4 3.4-24.2L192 128h640z"
    })]));
  }
}), shop_default = _sfc_main235;

// src/components/shopping-bag.vue
import { defineComponent as _defineComponent236 } from "vue";
import { createElementVNode as _createElementVNode236, openBlock as _openBlock236, createElementBlock as _createElementBlock236 } from "vue";
var _sfc_main236 = /* @__PURE__ */ _defineComponent236({
  name: "ShoppingBag",
  __name: "shopping-bag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock236(), _createElementBlock236("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode236("path", {
      fill: "currentColor",
      d: "M704 320v96a32 32 0 0 1-32 32h-32V320H384v128h-32a32 32 0 0 1-32-32v-96H192v576h640V320zm-384-64a192 192 0 1 1 384 0h160a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zm64 0h256a128 128 0 1 0-256 0"
    }), _createElementVNode236("path", {
      fill: "currentColor",
      d: "M192 704h640v64H192z"
    })]));
  }
}), shopping_bag_default = _sfc_main236;

// src/components/shopping-cart-full.vue
import { defineComponent as _defineComponent237 } from "vue";
import { createElementVNode as _createElementVNode237, openBlock as _openBlock237, createElementBlock as _createElementBlock237 } from "vue";
var _sfc_main237 = /* @__PURE__ */ _defineComponent237({
  name: "ShoppingCartFull",
  __name: "shopping-cart-full",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock237(), _createElementBlock237("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode237("path", {
      fill: "currentColor",
      d: "M432 928a48 48 0 1 1 0-96 48 48 0 0 1 0 96m320 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96M96 128a32 32 0 0 1 0-64h160a32 32 0 0 1 31.4 25.7L320.6 256H928a32 32 0 0 1 31.3 38.7l-96 448A32 32 0 0 1 832 768H384a32 32 0 0 1-31.4-25.7L229.8 128zm314.2 576h396l82.2-384h-555z"
    }), _createElementVNode237("path", {
      fill: "currentColor",
      d: "M699.6 256 608 146l-91.6 110zM558.8 105a64 64 0 0 1 98.4 0l179.2 215H379.6z"
    })]));
  }
}), shopping_cart_full_default = _sfc_main237;

// src/components/shopping-cart.vue
import { defineComponent as _defineComponent238 } from "vue";
import { createElementVNode as _createElementVNode238, openBlock as _openBlock238, createElementBlock as _createElementBlock238 } from "vue";
var _sfc_main238 = /* @__PURE__ */ _defineComponent238({
  name: "ShoppingCart",
  __name: "shopping-cart",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock238(), _createElementBlock238("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode238("path", {
      fill: "currentColor",
      d: "M432 928a48 48 0 1 1 0-96 48 48 0 0 1 0 96m320 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96M96 128a32 32 0 0 1 0-64h160a32 32 0 0 1 31.4 25.7L320.6 256H928a32 32 0 0 1 31.3 38.7l-96 448A32 32 0 0 1 832 768H384a32 32 0 0 1-31.4-25.7L229.8 128zm314.2 576h396l82.2-384h-555z"
    })]));
  }
}), shopping_cart_default = _sfc_main238;

// src/components/shopping-trolley.vue
import { defineComponent as _defineComponent239 } from "vue";
import { createElementVNode as _createElementVNode239, openBlock as _openBlock239, createElementBlock as _createElementBlock239 } from "vue";
var _sfc_main239 = /* @__PURE__ */ _defineComponent239({
  name: "ShoppingTrolley",
  __name: "shopping-trolley",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock239(), _createElementBlock239("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode239("path", {
      fill: "currentColor",
      d: "M368 833q-20 0-33.5 13.5C321 860 321 866.7 321 880s4.5 24.5 13.5 33.5 20.2 13.8 33.5 14.5q20-1 33.5-14.5C415 900 415 893.3 415 880s-4.5-24.5-13.5-33.5S381.3 833 368 833m439-193a31.4 31.4 0 0 0 31-24l112-448q3-15-6.5-27.5C934 128 929 128 919 128H96q-14 0-23 9c-9 9-9 13.7-9 23s3 17 9 23 13.7 9 23 9h96v576h672q14 0 23-9c9-9 9-13.7 9-23s-3-17-9-23-13.7-9-23-9H256v-64zM256 192h622l-96 384H256zm432 641q-20 0-33.5 13.5C641 860 641 866.7 641 880s4.5 24.5 13.5 33.5 20.2 13.8 33.5 14.5q20-1 33.5-14.5C735 900 735 893.3 735 880s-4.5-24.5-13.5-33.5S701.3 833 688 833"
    })]));
  }
}), shopping_trolley_default = _sfc_main239;

// src/components/smoking.vue
import { defineComponent as _defineComponent240 } from "vue";
import { createElementVNode as _createElementVNode240, openBlock as _openBlock240, createElementBlock as _createElementBlock240 } from "vue";
var _sfc_main240 = /* @__PURE__ */ _defineComponent240({
  name: "Smoking",
  __name: "smoking",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock240(), _createElementBlock240("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode240("path", {
      fill: "currentColor",
      d: "M256 576v128h640V576zm-32-64h704a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H224a32 32 0 0 1-32-32V544a32 32 0 0 1 32-32"
    }), _createElementVNode240("path", {
      fill: "currentColor",
      d: "M704 576h64v128h-64zM256 64h64v320h-64zM128 192h64v192h-64zM64 512h64v256H64z"
    })]));
  }
}), smoking_default = _sfc_main240;

// src/components/soccer.vue
import { defineComponent as _defineComponent241 } from "vue";
import { createElementVNode as _createElementVNode241, openBlock as _openBlock241, createElementBlock as _createElementBlock241 } from "vue";
var _sfc_main241 = /* @__PURE__ */ _defineComponent241({
  name: "Soccer",
  __name: "soccer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock241(), _createElementBlock241("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode241("path", {
      fill: "currentColor",
      d: "M418.5 871 152.3 604.8c-16.6 94-2.4 178.6 42.9 224 45 45 129.3 58.8 223.3 42.2m72.3-18.1a573 573 0 0 0 224.8-137.3A573 573 0 0 0 853 490.8l-319-319a579 579 0 0 0-227.5 138.5 568 568 0 0 0-136 222.2zM871 418.5c16.6-94 2.7-178.4-42.2-223.3-44.5-44.5-128.7-58-222.6-41.5zM150 874C37 761 61 465 261 265c200-199.8 499.9-228 613-115 113 113 86.7 411-113.2 610.9S262.9 987 149.9 874m452.6-497.7 22.7-22.7a32 32 0 0 1 45.2 45.2l-22.7 22.7 45.3 45.3a32 32 0 1 1-45.3 45.2l-45.2-45.2-45.3 45.2 45.3 45.2a32 32 0 1 1-45.3 45.3L512 557.2l-45.2 45.3 45.2 45.2a32 32 0 1 1-45.2 45.3l-45.3-45.3-22.7 22.7a32 32 0 1 1-45.2-45.2l22.7-22.7-45.3-45.3a32 32 0 1 1 45.3-45.2l45.2 45.2 45.3-45.2-45.3-45.2a32 32 0 1 1 45.3-45.3l45.2 45.3 45.2-45.3-45.2-45.2a32 32 0 0 1 45.2-45.3z"
    })]));
  }
}), soccer_default = _sfc_main241;

// src/components/sold-out.vue
import { defineComponent as _defineComponent242 } from "vue";
import { createElementVNode as _createElementVNode242, openBlock as _openBlock242, createElementBlock as _createElementBlock242 } from "vue";
var _sfc_main242 = /* @__PURE__ */ _defineComponent242({
  name: "SoldOut",
  __name: "sold-out",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock242(), _createElementBlock242("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode242("path", {
      fill: "currentColor",
      d: "M704 288h131a32 32 0 0 1 31.9 28.8L886.4 512H822l-16-160H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0v-96H218l-51.3 512H512v64H131.3a32 32 0 0 1-31.8-35.2l57.6-576A32 32 0 0 1 189 288H320v-22.3C320 154.7 405.5 64 512 64s192 90.7 192 201.7zm-64 0v-22.3c0-76.5-57.7-137.7-128-137.7s-128 61.2-128 137.7V288zm201.4 476.2a32 32 0 1 1 45.3 45.1l-128 128a32 32 0 0 1-45.3 0l-128-128a32 32 0 1 1 45.3-45.2l73.3 73.4V608a32 32 0 1 1 64 0v229.5l73.4-73.4z"
    })]));
  }
}), sold_out_default = _sfc_main242;

// src/components/sort-down.vue
import { defineComponent as _defineComponent243 } from "vue";
import { createElementVNode as _createElementVNode243, openBlock as _openBlock243, createElementBlock as _createElementBlock243 } from "vue";
var _sfc_main243 = /* @__PURE__ */ _defineComponent243({
  name: "SortDown",
  __name: "sort-down",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock243(), _createElementBlock243("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode243("path", {
      fill: "currentColor",
      d: "M576 96v709.6L333.3 562.8A32 32 0 1 0 288 608l297.4 297.3a32 32 0 0 0 54.6-22.6V96a32 32 0 0 0-64 0"
    })]));
  }
}), sort_down_default = _sfc_main243;

// src/components/sort-up.vue
import { defineComponent as _defineComponent244 } from "vue";
import { createElementVNode as _createElementVNode244, openBlock as _openBlock244, createElementBlock as _createElementBlock244 } from "vue";
var _sfc_main244 = /* @__PURE__ */ _defineComponent244({
  name: "SortUp",
  __name: "sort-up",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock244(), _createElementBlock244("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode244("path", {
      fill: "currentColor",
      d: "M384 141.2V928a32 32 0 1 0 64 0V218.6l242.7 242.6A32 32 0 1 0 736 416L438.6 118.7a32 32 0 0 0-54.6 22.5"
    })]));
  }
}), sort_up_default = _sfc_main244;

// src/components/sort.vue
import { defineComponent as _defineComponent245 } from "vue";
import { createElementVNode as _createElementVNode245, openBlock as _openBlock245, createElementBlock as _createElementBlock245 } from "vue";
var _sfc_main245 = /* @__PURE__ */ _defineComponent245({
  name: "Sort",
  __name: "sort",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock245(), _createElementBlock245("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode245("path", {
      fill: "currentColor",
      d: "M384 96a32 32 0 0 1 64 0v786.8a32 32 0 0 1-54.6 22.6L96 608a32 32 0 0 1 0-45.3h.2a32 32 0 0 1 45.1 0l242.8 243zm192 45.2a32 32 0 0 1 54.6-22.5L928 416a32 32 0 0 1 0 45.3h-.2a32 32 0 0 1-45.1 0L640 218.5V928a32 32 0 1 1-64 0z"
    })]));
  }
}), sort_default = _sfc_main245;

// src/components/stamp.vue
import { defineComponent as _defineComponent246 } from "vue";
import { createElementVNode as _createElementVNode246, openBlock as _openBlock246, createElementBlock as _createElementBlock246 } from "vue";
var _sfc_main246 = /* @__PURE__ */ _defineComponent246({
  name: "Stamp",
  __name: "stamp",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock246(), _createElementBlock246("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode246("path", {
      fill: "currentColor",
      d: "M624 476v164h144a128 128 0 0 1 128 128H128a128 128 0 0 1 128-128h144V476a192 192 0 1 1 224 0M128 896v-64h768v64z"
    })]));
  }
}), stamp_default = _sfc_main246;

// src/components/star-filled.vue
import { defineComponent as _defineComponent247 } from "vue";
import { createElementVNode as _createElementVNode247, openBlock as _openBlock247, createElementBlock as _createElementBlock247 } from "vue";
var _sfc_main247 = /* @__PURE__ */ _defineComponent247({
  name: "StarFilled",
  __name: "star-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock247(), _createElementBlock247("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode247("path", {
      fill: "currentColor",
      d: "M313.6 924.5a70 70 0 0 1-74.2-5.4 70 70 0 0 1-28-68.9l38-220.9L89 473a70.4 70.4 0 0 1 3.7-104.3A70 70 0 0 1 128 353l221.8-32.3 99.2-201a70.4 70.4 0 0 1 100.2-28.5 70 70 0 0 1 26 28.6l99.2 201 221.8 32.2a70.4 70.4 0 0 1 39 120L774.7 629.5l38 220.9a70.4 70.4 0 0 1-102.2 74.2L512 820.1z"
    })]));
  }
}), star_filled_default = _sfc_main247;

// src/components/star.vue
import { defineComponent as _defineComponent248 } from "vue";
import { createElementVNode as _createElementVNode248, openBlock as _openBlock248, createElementBlock as _createElementBlock248 } from "vue";
var _sfc_main248 = /* @__PURE__ */ _defineComponent248({
  name: "Star",
  __name: "star",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock248(), _createElementBlock248("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode248("path", {
      fill: "currentColor",
      d: "m512 747.8 228.2 120a6.4 6.4 0 0 0 9.2-6.7L706 607l184.5-180a6.4 6.4 0 0 0-3.5-10.8L632 379 517.7 147.9a6.4 6.4 0 0 0-11.6 0l-114 231.2L137 416a6.4 6.4 0 0 0-3.5 11L318 607l-43.6 254a6.4 6.4 0 0 0 9.3 6.8zM313.6 924.5a70.4 70.4 0 0 1-102.1-74.3l37.8-220.9L89 473a70.4 70.4 0 0 1 39-120.1l221.8-32.3 99.2-201a70.4 70.4 0 0 1 126.2 0l99.2 201L896.2 353a70.4 70.4 0 0 1 39 120L774.7 629.5l38 220.9a70.4 70.4 0 0 1-102.2 74.2L512 820.1z"
    })]));
  }
}), star_default = _sfc_main248;

// src/components/stopwatch.vue
import { defineComponent as _defineComponent249 } from "vue";
import { createElementVNode as _createElementVNode249, openBlock as _openBlock249, createElementBlock as _createElementBlock249 } from "vue";
var _sfc_main249 = /* @__PURE__ */ _defineComponent249({
  name: "Stopwatch",
  __name: "stopwatch",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock249(), _createElementBlock249("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode249("path", {
      fill: "currentColor",
      d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
    }), _createElementVNode249("path", {
      fill: "currentColor",
      d: "M672 234.9q-58.7 261.6-122.7 372.5c-64 110.8-202.6 30.8-138.6-80q64-110.9 261.3-292.6z"
    })]));
  }
}), stopwatch_default = _sfc_main249;

// src/components/success-filled.vue
import { defineComponent as _defineComponent250 } from "vue";
import { createElementVNode as _createElementVNode250, openBlock as _openBlock250, createElementBlock as _createElementBlock250 } from "vue";
var _sfc_main250 = /* @__PURE__ */ _defineComponent250({
  name: "SuccessFilled",
  __name: "success-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock250(), _createElementBlock250("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode250("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-55.8 536.4-99.5-99.6a38.4 38.4 0 1 0-54.4 54.3L429.1 682a38.3 38.3 0 0 0 54.3 0l262.4-262.5a38.4 38.4 0 1 0-54.3-54.3z"
    })]));
  }
}), success_filled_default = _sfc_main250;

// src/components/sugar.vue
import { defineComponent as _defineComponent251 } from "vue";
import { createElementVNode as _createElementVNode251, openBlock as _openBlock251, createElementBlock as _createElementBlock251 } from "vue";
var _sfc_main251 = /* @__PURE__ */ _defineComponent251({
  name: "Sugar",
  __name: "sugar",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock251(), _createElementBlock251("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode251("path", {
      fill: "currentColor",
      d: "m801.7 349.2 4.5 4.5a128 128 0 0 1 0 181L534.7 806a128 128 0 0 1-181.1 0l-4.5-4.4-19.4 109.7a64 64 0 0 1-108.3 34.1l-143-143a64 64 0 0 1 34.2-108.2l109.8-19.4-4.5-4.5a128 128 0 0 1 0-181l271.4-271.5a128 128 0 0 1 181.1 0l4.5 4.4 19.4-109.5a64 64 0 0 1 108.3-34l142.6 143A64 64 0 0 1 911 330zM253 547.9h447.2v2.2l60.8-60.8a64 64 0 0 0 18.7-44.4H352.8L263 534.7a64 64 0 0 0-10.2 13.2zm0 64q4.2 7.1 10.2 13.3l135.7 135.7a64 64 0 0 0 90.5 0l149.1-149zm490-231L625.3 263.1a64 64 0 0 0-90.5 0l-118 117.8zM123.8 757.3l143 143L291 762.7a25.6 25.6 0 0 0-29.7-29.6zM757.3 124 733 261.4a25.6 25.6 0 0 0 29.6 29.7L900 267z"
    })]));
  }
}), sugar_default = _sfc_main251;

// src/components/suitcase-line.vue
import { defineComponent as _defineComponent252 } from "vue";
import { createElementVNode as _createElementVNode252, openBlock as _openBlock252, createElementBlock as _createElementBlock252 } from "vue";
var _sfc_main252 = /* @__PURE__ */ _defineComponent252({
  name: "SuitcaseLine",
  __name: "suitcase-line",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock252(), _createElementBlock252("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode252("path", {
      fill: "currentColor",
      d: "M922.5 229.5A126 126 0 0 0 832 192H704v-64a65 65 0 0 0-64-64H384a65 65 0 0 0-64 64v64H192q-54 1-90.5 37.5C65 266 64.7 284 64 320v448q1 54 37.5 90.5C138 895 156 895.3 192 896h640q54-1 90.5-37.5C959 822 959.3 804 960 768V320q-1-54-37.5-90.5M384 128h256v64H384zM256 832h-64a65 65 0 0 1-64-64V448h128zm448 0H320V448h384zm192-64a65 65 0 0 1-64 64h-64V448h128zm0-384H128v-64a65 65 0 0 1 64-64h640a65 65 0 0 1 64 64z"
    })]));
  }
}), suitcase_line_default = _sfc_main252;

// src/components/suitcase.vue
import { defineComponent as _defineComponent253 } from "vue";
import { createElementVNode as _createElementVNode253, openBlock as _openBlock253, createElementBlock as _createElementBlock253 } from "vue";
var _sfc_main253 = /* @__PURE__ */ _defineComponent253({
  name: "Suitcase",
  __name: "suitcase",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock253(), _createElementBlock253("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode253("path", {
      fill: "currentColor",
      d: "M128 384h768v-64a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64zm0 64v320a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V448zm64-256h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128"
    }), _createElementVNode253("path", {
      fill: "currentColor",
      d: "M384 128v64h256v-64zm0-64h256a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64H384a64 64 0 0 1-64-64v-64a64 64 0 0 1 64-64"
    })]));
  }
}), suitcase_default = _sfc_main253;

// src/components/sunny.vue
import { defineComponent as _defineComponent254 } from "vue";
import { createElementVNode as _createElementVNode254, openBlock as _openBlock254, createElementBlock as _createElementBlock254 } from "vue";
var _sfc_main254 = /* @__PURE__ */ _defineComponent254({
  name: "Sunny",
  __name: "sunny",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock254(), _createElementBlock254("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode254("path", {
      fill: "currentColor",
      d: "M512 704a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m0-704a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 768a32 32 0 0 1 32 32v64a32 32 0 1 1-64 0v-64a32 32 0 0 1 32-32M195.2 195.2a32 32 0 0 1 45.2 0l45.3 45.2a32 32 0 1 1-45.3 45.3l-45.2-45.3a32 32 0 0 1 0-45.2m543.1 543.1a32 32 0 0 1 45.3 0l45.2 45.3a32 32 0 0 1-45.2 45.2l-45.3-45.2a32 32 0 0 1 0-45.3M64 512a32 32 0 0 1 32-32h64a32 32 0 0 1 0 64H96a32 32 0 0 1-32-32m768 0a32 32 0 0 1 32-32h64a32 32 0 1 1 0 64h-64a32 32 0 0 1-32-32M195.2 828.8a32 32 0 0 1 0-45.2l45.2-45.3a32 32 0 0 1 45.3 45.3l-45.3 45.2a32 32 0 0 1-45.2 0m543.1-543.1a32 32 0 0 1 0-45.3l45.3-45.2a32 32 0 0 1 45.2 45.2l-45.2 45.3a32 32 0 0 1-45.3 0"
    })]));
  }
}), sunny_default = _sfc_main254;

// src/components/sunrise.vue
import { defineComponent as _defineComponent255 } from "vue";
import { createElementVNode as _createElementVNode255, openBlock as _openBlock255, createElementBlock as _createElementBlock255 } from "vue";
var _sfc_main255 = /* @__PURE__ */ _defineComponent255({
  name: "Sunrise",
  __name: "sunrise",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock255(), _createElementBlock255("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode255("path", {
      fill: "currentColor",
      d: "M32 768h960a32 32 0 1 1 0 64H32a32 32 0 1 1 0-64m129.4-96a352 352 0 0 1 701.2 0h-64.3a288 288 0 0 0-572.6 0zM512 128a32 32 0 0 1 32 32v96a32 32 0 0 1-64 0v-96a32 32 0 0 1 32-32m407.3 168.7a32 32 0 0 1 0 45.3l-67.8 67.8a32 32 0 1 1-45.3-45.3l67.8-67.8a32 32 0 0 1 45.3 0m-814.6 0a32 32 0 0 1 45.3 0l67.8 67.8a32 32 0 1 1-45.3 45.3L104.7 342a32 32 0 0 1 0-45.3"
    })]));
  }
}), sunrise_default = _sfc_main255;

// src/components/sunset.vue
import { defineComponent as _defineComponent256 } from "vue";
import { createElementVNode as _createElementVNode256, openBlock as _openBlock256, createElementBlock as _createElementBlock256 } from "vue";
var _sfc_main256 = /* @__PURE__ */ _defineComponent256({
  name: "Sunset",
  __name: "sunset",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock256(), _createElementBlock256("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode256("path", {
      fill: "currentColor",
      d: "M82.6 640a448 448 0 1 1 858.8 0h-67.2a384 384 0 1 0-724.2 0zM32 704h960q32 0 32 32t-32 32H32q-32 0-32-32t32-32m256 128h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
    })]));
  }
}), sunset_default = _sfc_main256;

// src/components/switch-button.vue
import { defineComponent as _defineComponent257 } from "vue";
import { createElementVNode as _createElementVNode257, openBlock as _openBlock257, createElementBlock as _createElementBlock257 } from "vue";
var _sfc_main257 = /* @__PURE__ */ _defineComponent257({
  name: "SwitchButton",
  __name: "switch-button",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock257(), _createElementBlock257("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode257("path", {
      fill: "currentColor",
      d: "M352 159.9v70.5a352 352 0 1 0 320 0v-70.5A416.1 416.1 0 0 1 512 960a416 416 0 0 1-160-800.1"
    }), _createElementVNode257("path", {
      fill: "currentColor",
      d: "M512 64q32 0 32 32v320q0 32-32 32t-32-32V96q0-32 32-32"
    })]));
  }
}), switch_button_default = _sfc_main257;

// src/components/switch-filled.vue
import { defineComponent as _defineComponent258 } from "vue";
import { createElementVNode as _createElementVNode258, openBlock as _openBlock258, createElementBlock as _createElementBlock258 } from "vue";
var _sfc_main258 = /* @__PURE__ */ _defineComponent258({
  name: "SwitchFilled",
  __name: "switch-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock258(), _createElementBlock258("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode258("path", {
      fill: "currentColor",
      d: "M247.5 358.4a72.7 72.7 0 0 0 72.3 72.4c39.9 0 72.4-32.6 72.4-72.4S359.6 286 319.8 286s-72.3 32.6-72.3 72.4"
    }), _createElementVNode258("path", {
      fill: "currentColor",
      d: "M492.4 128H324.7a197 197 0 0 0-139 57.6 197 197 0 0 0-57.7 139v374.1a197 197 0 0 0 121.4 181.8 197 197 0 0 0 75.3 15h167.7c3 0 5.4-2.5 5.4-5.5V133.4c.6-3-1.8-5.4-5.4-5.4m-56.1 705.9H324.7a132 132 0 0 1-95.4-39.9 134 134 0 0 1-39.8-95.3v-374c-.1-17.8 3.4-35.4 10.2-51.7a132 132 0 0 1 29.6-43.7 135 135 0 0 1 95.4-39.8h111.6zm402-647.7a197 197 0 0 0-139-57.6H580.5c-3 0-4.8 2.4-4.8 4.8v757.2c-.6 3 1.7 5.4 5.4 5.4h118.2a197 197 0 0 0 139-57.6 197 197 0 0 0 57.7-139V325.2a197 197 0 0 0-57.6-139M727 628c-42.8 0-77.8-35-77.8-77.8s35-77.8 77.8-77.8 77.8 35 77.8 77.8-35 77.8-77.8 77.8"
    })]));
  }
}), switch_filled_default = _sfc_main258;

// src/components/switch.vue
import { defineComponent as _defineComponent259 } from "vue";
import { createElementVNode as _createElementVNode259, openBlock as _openBlock259, createElementBlock as _createElementBlock259 } from "vue";
var _sfc_main259 = /* @__PURE__ */ _defineComponent259({
  name: "Switch",
  __name: "switch",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock259(), _createElementBlock259("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode259("path", {
      fill: "currentColor",
      d: "M118.7 438.7a32 32 0 0 1 0-45.3L416 96l4.5-3.8a32 32 0 0 1 40.7 3.8l3.8 4.5a32 32 0 0 1-3.8 40.8L218.6 384H928a32 32 0 1 1 0 64H141.2a32 32 0 0 1-22.5-9.3M64 608a32 32 0 0 1 32-32h786.8a32 32 0 0 1 22.6 54.6L608 928l-4.5 3.8a32 32 0 0 1-40.8-49l243-242.8H96a32 32 0 0 1-32-32"
    })]));
  }
}), switch_default = _sfc_main259;

// src/components/takeaway-box.vue
import { defineComponent as _defineComponent260 } from "vue";
import { createElementVNode as _createElementVNode260, openBlock as _openBlock260, createElementBlock as _createElementBlock260 } from "vue";
var _sfc_main260 = /* @__PURE__ */ _defineComponent260({
  name: "TakeawayBox",
  __name: "takeaway-box",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock260(), _createElementBlock260("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode260("path", {
      fill: "currentColor",
      d: "M832 384H192v448h640zM96 320h832V128H96zm800 64v480a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V384H64a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h896a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zM416 512h192a32 32 0 0 1 0 64H416a32 32 0 0 1 0-64"
    })]));
  }
}), takeaway_box_default = _sfc_main260;

// src/components/ticket.vue
import { defineComponent as _defineComponent261 } from "vue";
import { createElementVNode as _createElementVNode261, openBlock as _openBlock261, createElementBlock as _createElementBlock261 } from "vue";
var _sfc_main261 = /* @__PURE__ */ _defineComponent261({
  name: "Ticket",
  __name: "ticket",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock261(), _createElementBlock261("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode261("path", {
      fill: "currentColor",
      d: "M640 832H64V640a128 128 0 1 0 0-256V192h576v160h64V192h256v192a128 128 0 1 0 0 256v192H704V672h-64zm0-416v192h64V416z"
    })]));
  }
}), ticket_default = _sfc_main261;

// src/components/tickets.vue
import { defineComponent as _defineComponent262 } from "vue";
import { createElementVNode as _createElementVNode262, openBlock as _openBlock262, createElementBlock as _createElementBlock262 } from "vue";
var _sfc_main262 = /* @__PURE__ */ _defineComponent262({
  name: "Tickets",
  __name: "tickets",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock262(), _createElementBlock262("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode262("path", {
      fill: "currentColor",
      d: "M192 128v768h640V128zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m160 448h384v64H320zm0-192h192v64H320zm0 384h384v64H320z"
    })]));
  }
}), tickets_default = _sfc_main262;

// src/components/timer.vue
import { defineComponent as _defineComponent263 } from "vue";
import { createElementVNode as _createElementVNode263, openBlock as _openBlock263, createElementBlock as _createElementBlock263 } from "vue";
var _sfc_main263 = /* @__PURE__ */ _defineComponent263({
  name: "Timer",
  __name: "timer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock263(), _createElementBlock263("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode263("path", {
        fill: "currentColor",
        d: "M512 896a320 320 0 1 0 0-640 320 320 0 0 0 0 640m0 64a384 384 0 1 1 0-768 384 384 0 0 1 0 768"
      }),
      _createElementVNode263("path", {
        fill: "currentColor",
        d: "M512 320a32 32 0 0 1 32 32l-.5 224a32 32 0 1 1-64 0l.5-224a32 32 0 0 1 32-32"
      }),
      _createElementVNode263("path", {
        fill: "currentColor",
        d: "M448 576a64 64 0 1 0 128 0 64 64 0 1 0-128 0m96-448v128h-64V128h-96a32 32 0 0 1 0-64h256a32 32 0 1 1 0 64z"
      })
    ]));
  }
}), timer_default = _sfc_main263;

// src/components/toilet-paper.vue
import { defineComponent as _defineComponent264 } from "vue";
import { createElementVNode as _createElementVNode264, openBlock as _openBlock264, createElementBlock as _createElementBlock264 } from "vue";
var _sfc_main264 = /* @__PURE__ */ _defineComponent264({
  name: "ToiletPaper",
  __name: "toilet-paper",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock264(), _createElementBlock264("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode264("path", {
      fill: "currentColor",
      d: "M595.2 128H320a192 192 0 0 0-192 192v576h384V352c0-90.5 32.4-171.2 83.2-224M736 64c123.7 0 224 129 224 288S859.7 640 736 640H576v320H64V320A256 256 0 0 1 320 64zM576 352v224h160c84.4 0 160-97.3 160-224s-75.6-224-160-224-160 97.3-160 224"
    }), _createElementVNode264("path", {
      fill: "currentColor",
      d: "M736 448c-35.3 0-64-43-64-96s28.7-96 64-96 64 43 64 96-28.7 96-64 96"
    })]));
  }
}), toilet_paper_default = _sfc_main264;

// src/components/tools.vue
import { defineComponent as _defineComponent265 } from "vue";
import { createElementVNode as _createElementVNode265, openBlock as _openBlock265, createElementBlock as _createElementBlock265 } from "vue";
var _sfc_main265 = /* @__PURE__ */ _defineComponent265({
  name: "Tools",
  __name: "tools",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock265(), _createElementBlock265("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode265("path", {
      fill: "currentColor",
      d: "M764.4 254.7A352 352 0 0 1 850.8 404H960v192H850.8a352 352 0 0 1-86.4 149.4l54.7 94.7L653 936l-54.6-94.7a353 353 0 0 1-172.5 0L371 936 205 840l54.7-94.7A352 352 0 0 1 173.2 596H64V404h109.2a352 352 0 0 1 86.4-149.3L204.8 160 371 64h.2l54.7 94.6a353 353 0 0 1 172.4 0L652.8 64h.1l166.3 96zM704 500a192 192 0 1 0-384 0 192 192 0 0 0 384 0"
    })]));
  }
}), tools_default = _sfc_main265;

// src/components/top-left.vue
import { defineComponent as _defineComponent266 } from "vue";
import { createElementVNode as _createElementVNode266, openBlock as _openBlock266, createElementBlock as _createElementBlock266 } from "vue";
var _sfc_main266 = /* @__PURE__ */ _defineComponent266({
  name: "TopLeft",
  __name: "top-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock266(), _createElementBlock266("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode266("path", {
      fill: "currentColor",
      d: "M256 256h416a32 32 0 1 0 0-64H224a32 32 0 0 0-32 32v448a32 32 0 0 0 64 0z"
    }), _createElementVNode266("path", {
      fill: "currentColor",
      d: "M246.7 201.3a32 32 0 0 0-45.4 45.4l544 544a32 32 0 0 0 45.4-45.4z"
    })]));
  }
}), top_left_default = _sfc_main266;

// src/components/top-right.vue
import { defineComponent as _defineComponent267 } from "vue";
import { createElementVNode as _createElementVNode267, openBlock as _openBlock267, createElementBlock as _createElementBlock267 } from "vue";
var _sfc_main267 = /* @__PURE__ */ _defineComponent267({
  name: "TopRight",
  __name: "top-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock267(), _createElementBlock267("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode267("path", {
      fill: "currentColor",
      d: "M768 256H353.6a32 32 0 1 1 0-64H800a32 32 0 0 1 32 32v448a32 32 0 0 1-64 0z"
    }), _createElementVNode267("path", {
      fill: "currentColor",
      d: "M777.3 201.3a32 32 0 0 1 45.4 45.4l-544 544a32 32 0 0 1-45.4-45.4z"
    })]));
  }
}), top_right_default = _sfc_main267;

// src/components/top.vue
import { defineComponent as _defineComponent268 } from "vue";
import { createElementVNode as _createElementVNode268, openBlock as _openBlock268, createElementBlock as _createElementBlock268 } from "vue";
var _sfc_main268 = /* @__PURE__ */ _defineComponent268({
  name: "Top",
  __name: "top",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock268(), _createElementBlock268("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode268("path", {
      fill: "currentColor",
      d: "M572.2 205.3v600.3a30.1 30.1 0 1 1-60.2 0V205.3L292.4 438.6a29 29 0 0 1-42.7 0 33.4 33.4 0 0 1 0-45.2l271-288a29 29 0 0 1 42.7 0l271.1 288a33.4 33.4 0 0 1 0 45.2 29 29 0 0 1-42.6 0z"
    })]));
  }
}), top_default = _sfc_main268;

// src/components/trend-charts.vue
import { defineComponent as _defineComponent269 } from "vue";
import { createElementVNode as _createElementVNode269, openBlock as _openBlock269, createElementBlock as _createElementBlock269 } from "vue";
var _sfc_main269 = /* @__PURE__ */ _defineComponent269({
  name: "TrendCharts",
  __name: "trend-charts",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock269(), _createElementBlock269("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode269("path", {
      fill: "currentColor",
      d: "M128 896V128h768v768zm291.7-327.3 128 102.4L728 469.3 680 426.7 540.3 583.3l-128-102.4L232 682.7l47.8 42.6zM816 352a48 48 0 1 0-96 0 48 48 0 0 0 96 0"
    })]));
  }
}), trend_charts_default = _sfc_main269;

// src/components/trophy-base.vue
import { defineComponent as _defineComponent270 } from "vue";
import { createElementVNode as _createElementVNode270, openBlock as _openBlock270, createElementBlock as _createElementBlock270 } from "vue";
var _sfc_main270 = /* @__PURE__ */ _defineComponent270({
  name: "TrophyBase",
  __name: "trophy-base",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock270(), _createElementBlock270("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode270("path", {
      fill: "currentColor",
      d: "M918.4 201.6A29 29 0 0 0 896 192H768V96c0-9.6-3.2-16-9.6-22.4S745.6 64 736 64H288c-9.6 0-16 3.2-22.4 9.6S256 86.4 256 96v96H128c-9.6 0-16 3.2-22.4 9.6S96 217.6 96 224c3.2 108.8 25.6 185.6 64 224a215 215 0 0 0 127.7 62q16.2 30.6 41.9 56.4c40.9 40.9 91 65.5 150.4 71.9V768h-96c-9.6 0-16 3.2-22.4 9.6S352 790.4 352 800s3.2 16 9.6 22.4 12.8 9.6 22.4 9.6h256c9.6 0 16-3.2 22.4-9.6s9.6-12.8 9.6-22.4-3.2-16-9.6-22.4-12.8-9.6-22.4-9.6h-96V637.3c59.4-7.7 109.5-30 150.4-70.9q25.8-25.8 42.8-56.5c49-6.6 90-27.8 126.8-61.9 38.4-38.4 60.8-112 64-224 0-6.4-3.2-16-9.6-22.4M256 438.4c-19.2-6.4-35.2-19.2-51.2-35.2-22.4-22.4-35.2-70.4-41.6-147.2H256zm390.4 80C608 553.6 566.4 576 512 576s-99.2-19.2-134.4-57.6S320 438.4 320 384V128h384v256q0 81.6-57.6 134.4m172.8-115.2c-16 16-32 25.6-51.2 35.2V256h92.8c-6.4 76.8-19.2 124.8-41.6 147.2M768 896H256c-9.6 0-16 3.2-22.4 9.6S224 918.4 224 928s3.2 16 9.6 22.4 12.8 9.6 22.4 9.6h512c9.6 0 16-3.2 22.4-9.6s9.6-12.8 9.6-22.4-3.2-16-9.6-22.4-12.8-9.6-22.4-9.6"
    })]));
  }
}), trophy_base_default = _sfc_main270;

// src/components/trophy.vue
import { defineComponent as _defineComponent271 } from "vue";
import { createElementVNode as _createElementVNode271, openBlock as _openBlock271, createElementBlock as _createElementBlock271 } from "vue";
var _sfc_main271 = /* @__PURE__ */ _defineComponent271({
  name: "Trophy",
  __name: "trophy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock271(), _createElementBlock271("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode271("path", {
      fill: "currentColor",
      d: "M480 896V702a256 256 0 0 1-216-190h-32.6a96 96 0 0 1-92-68.4L93.7 290.9a76.8 76.8 0 0 1 73.6-98.9H256V96a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32v96h88.8a76.8 76.8 0 0 1 73.6 98.9l-46 152.6a96 96 0 0 1-91.8 68.5h-32.7A256 256 0 0 1 544 702v194h128a32 32 0 1 1 0 64H352a32 32 0 1 1 0-64zm224-448V128H320v320a192 192 0 1 0 384 0m64 0h24.6a32 32 0 0 0 30.6-22.8l45.9-152.8a12.8 12.8 0 0 0-12.3-16.4H768zm-512 0V256h-88.8a12.8 12.8 0 0 0-12.3 16.4l45.9 152.8a32 32 0 0 0 30.6 22.8z"
    })]));
  }
}), trophy_default = _sfc_main271;

// src/components/turn-off.vue
import { defineComponent as _defineComponent272 } from "vue";
import { createElementVNode as _createElementVNode272, openBlock as _openBlock272, createElementBlock as _createElementBlock272 } from "vue";
var _sfc_main272 = /* @__PURE__ */ _defineComponent272({
  name: "TurnOff",
  __name: "turn-off",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock272(), _createElementBlock272("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode272("path", {
      fill: "currentColor",
      d: "M330 257.1a254.9 254.9 0 0 0 0 509.8h364a254.9 254.9 0 0 0 0-509.8zm0-72.8h364a327.7 327.7 0 1 1 0 655.4H330a327.7 327.7 0 1 1 0-655.4"
    }), _createElementVNode272("path", {
      fill: "currentColor",
      d: "M330 621.2a109.2 109.2 0 1 0 0-218.4 109.2 109.2 0 0 0 0 218.4m0 72.8a182 182 0 1 1 0-364 182 182 0 0 1 0 364"
    })]));
  }
}), turn_off_default = _sfc_main272;

// src/components/umbrella.vue
import { defineComponent as _defineComponent273 } from "vue";
import { createElementVNode as _createElementVNode273, openBlock as _openBlock273, createElementBlock as _createElementBlock273 } from "vue";
var _sfc_main273 = /* @__PURE__ */ _defineComponent273({
  name: "Umbrella",
  __name: "umbrella",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock273(), _createElementBlock273("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode273("path", {
      fill: "currentColor",
      d: "M320 768a32 32 0 1 1 64 0 64 64 0 0 0 128 0V512H64a448 448 0 1 1 896 0H576v256a128 128 0 1 1-256 0m570.7-320a384.1 384.1 0 0 0-757.4 0z"
    })]));
  }
}), umbrella_default = _sfc_main273;

// src/components/unlock.vue
import { defineComponent as _defineComponent274 } from "vue";
import { createElementVNode as _createElementVNode274, openBlock as _openBlock274, createElementBlock as _createElementBlock274 } from "vue";
var _sfc_main274 = /* @__PURE__ */ _defineComponent274({
  name: "Unlock",
  __name: "unlock",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock274(), _createElementBlock274("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode274("path", {
      fill: "currentColor",
      d: "M224 448a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V480a32 32 0 0 0-32-32zm0-64h576a96 96 0 0 1 96 96v384a96 96 0 0 1-96 96H224a96 96 0 0 1-96-96V480a96 96 0 0 1 96-96"
    }), _createElementVNode274("path", {
      fill: "currentColor",
      d: "M512 544a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V576a32 32 0 0 1 32-32m178.3-295.3A192 192 0 0 0 320 320v64h352l96 38.4V448H256V320a256 256 0 0 1 493.8-95.1z"
    })]));
  }
}), unlock_default = _sfc_main274;

// src/components/upload-filled.vue
import { defineComponent as _defineComponent275 } from "vue";
import { createElementVNode as _createElementVNode275, openBlock as _openBlock275, createElementBlock as _createElementBlock275 } from "vue";
var _sfc_main275 = /* @__PURE__ */ _defineComponent275({
  name: "UploadFilled",
  __name: "upload-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock275(), _createElementBlock275("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode275("path", {
      fill: "currentColor",
      d: "M544 864V672h128L512 480 352 672h128v192H320v-1.6c-5.4.3-10.5 1.6-16 1.6A240 240 0 0 1 64 624a239 239 0 0 1 212.6-237.2A240 240 0 0 1 512 192a240 240 0 0 1 235.5 194.8A239 239 0 0 1 959.9 624a240 240 0 0 1-240 240c-5.3 0-10.5-1.3-16-1.6v1.6z"
    })]));
  }
}), upload_filled_default = _sfc_main275;

// src/components/upload.vue
import { defineComponent as _defineComponent276 } from "vue";
import { createElementVNode as _createElementVNode276, openBlock as _openBlock276, createElementBlock as _createElementBlock276 } from "vue";
var _sfc_main276 = /* @__PURE__ */ _defineComponent276({
  name: "Upload",
  __name: "upload",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock276(), _createElementBlock276("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode276("path", {
      fill: "currentColor",
      d: "M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m384-578.3V704h-64V247.3L237.2 490 192 444.8 508.8 128l316.8 316.8-45.3 45.2z"
    })]));
  }
}), upload_default = _sfc_main276;

// src/components/user-filled.vue
import { defineComponent as _defineComponent277 } from "vue";
import { createElementVNode as _createElementVNode277, openBlock as _openBlock277, createElementBlock as _createElementBlock277 } from "vue";
var _sfc_main277 = /* @__PURE__ */ _defineComponent277({
  name: "UserFilled",
  __name: "user-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock277(), _createElementBlock277("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode277("path", {
      fill: "currentColor",
      d: "M288 320a224 224 0 1 0 448 0 224 224 0 1 0-448 0m544 608H160a32 32 0 0 1-32-32v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 0 1-32 32z"
    })]));
  }
}), user_filled_default = _sfc_main277;

// src/components/user.vue
import { defineComponent as _defineComponent278 } from "vue";
import { createElementVNode as _createElementVNode278, openBlock as _openBlock278, createElementBlock as _createElementBlock278 } from "vue";
var _sfc_main278 = /* @__PURE__ */ _defineComponent278({
  name: "User",
  __name: "user",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock278(), _createElementBlock278("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode278("path", {
      fill: "currentColor",
      d: "M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m320 320v-96a96 96 0 0 0-96-96H288a96 96 0 0 0-96 96v96a32 32 0 1 1-64 0v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 1 1-64 0"
    })]));
  }
}), user_default = _sfc_main278;

// src/components/van.vue
import { defineComponent as _defineComponent279 } from "vue";
import { createElementVNode as _createElementVNode279, openBlock as _openBlock279, createElementBlock as _createElementBlock279 } from "vue";
var _sfc_main279 = /* @__PURE__ */ _defineComponent279({
  name: "Van",
  __name: "van",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock279(), _createElementBlock279("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode279("path", {
      fill: "currentColor",
      d: "M128.9 736H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v96h164.5a32 32 0 0 1 31.7 27.1l54.1 352a32 32 0 0 1-31.6 36.9h-91.5a144 144 0 1 1-286.3 0H415.1a144 144 0 1 1-286.3 0zm23.4-64a144 144 0 0 1 239.4 0h176.6c17.1-25.6 42.3-45.4 71.8-55.8V256H128v416zm655.4 0h77.7l-19.7-128H704v64.9A144 144 0 0 1 807.7 672M856 480l-14.7-96H704v96zM688 832a80 80 0 1 0 0-160 80 80 0 0 0 0 160m-416 0a80 80 0 1 0 0-160 80 80 0 0 0 0 160"
    })]));
  }
}), van_default = _sfc_main279;

// src/components/video-camera-filled.vue
import { defineComponent as _defineComponent280 } from "vue";
import { createElementVNode as _createElementVNode280, openBlock as _openBlock280, createElementBlock as _createElementBlock280 } from "vue";
var _sfc_main280 = /* @__PURE__ */ _defineComponent280({
  name: "VideoCameraFilled",
  __name: "video-camera-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock280(), _createElementBlock280("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode280("path", {
      fill: "currentColor",
      d: "m768 576 192-64v320l-192-64v96a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V480a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zM192 768v64h384v-64zm192-480a160 160 0 0 1 320 0 160 160 0 0 1-320 0m64 0a96 96 0 1 0 192 0 96 96 0 0 0-192 0m-320 32a128 128 0 1 1 256 0 128 128 0 0 1-256 0m64 0a64 64 0 1 0 128 0 64 64 0 0 0-128 0"
    })]));
  }
}), video_camera_filled_default = _sfc_main280;

// src/components/video-camera.vue
import { defineComponent as _defineComponent281 } from "vue";
import { createElementVNode as _createElementVNode281, openBlock as _openBlock281, createElementBlock as _createElementBlock281 } from "vue";
var _sfc_main281 = /* @__PURE__ */ _defineComponent281({
  name: "VideoCamera",
  __name: "video-camera",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock281(), _createElementBlock281("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode281("path", {
      fill: "currentColor",
      d: "M704 768V256H128v512zm64-416 192-96v512l-192-96v128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 71.6v176.8l128 64V359.6zM192 320h192v64H192z"
    })]));
  }
}), video_camera_default = _sfc_main281;

// src/components/video-pause.vue
import { defineComponent as _defineComponent282 } from "vue";
import { createElementVNode as _createElementVNode282, openBlock as _openBlock282, createElementBlock as _createElementBlock282 } from "vue";
var _sfc_main282 = /* @__PURE__ */ _defineComponent282({
  name: "VideoPause",
  __name: "video-pause",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock282(), _createElementBlock282("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode282("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-96-544q32 0 32 32v256q0 32-32 32t-32-32V384q0-32 32-32m192 0q32 0 32 32v256q0 32-32 32t-32-32V384q0-32 32-32"
    })]));
  }
}), video_pause_default = _sfc_main282;

// src/components/video-play.vue
import { defineComponent as _defineComponent283 } from "vue";
import { createElementVNode as _createElementVNode283, openBlock as _openBlock283, createElementBlock as _createElementBlock283 } from "vue";
var _sfc_main283 = /* @__PURE__ */ _defineComponent283({
  name: "VideoPlay",
  __name: "video-play",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock283(), _createElementBlock283("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode283("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-48-247.6L668.6 512 464 375.6zm10.6-342.7 249.5 166.4a48 48 0 0 1 0 79.8L474.6 718.3a48 48 0 0 1-74.6-40V345.6a48 48 0 0 1 74.6-40z"
    })]));
  }
}), video_play_default = _sfc_main283;

// src/components/view.vue
import { defineComponent as _defineComponent284 } from "vue";
import { createElementVNode as _createElementVNode284, openBlock as _openBlock284, createElementBlock as _createElementBlock284 } from "vue";
var _sfc_main284 = /* @__PURE__ */ _defineComponent284({
  name: "View",
  __name: "view",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock284(), _createElementBlock284("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode284("path", {
      fill: "currentColor",
      d: "M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352m0 64c-225.3 0-384.1 208-436.8 288 52.6 79.9 211.5 288 436.8 288s384.1-208 436.8-288C896.2 432.1 737.3 224 512 224m0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448m0 64a160 160 0 0 0-160 160c0 88.2 71.7 160 160 160s160-71.8 160-160-71.7-160-160-160"
    })]));
  }
}), view_default = _sfc_main284;

// src/components/wallet-filled.vue
import { defineComponent as _defineComponent285 } from "vue";
import { createElementVNode as _createElementVNode285, openBlock as _openBlock285, createElementBlock as _createElementBlock285 } from "vue";
var _sfc_main285 = /* @__PURE__ */ _defineComponent285({
  name: "WalletFilled",
  __name: "wallet-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock285(), _createElementBlock285("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode285("path", {
      fill: "currentColor",
      d: "M688 512a112 112 0 1 0 0 224h208v160H128V352h768v160zm32 160h-32a48 48 0 0 1 0-96h32a48 48 0 0 1 0 96m-80-544 128 160H384z"
    })]));
  }
}), wallet_filled_default = _sfc_main285;

// src/components/wallet.vue
import { defineComponent as _defineComponent286 } from "vue";
import { createElementVNode as _createElementVNode286, openBlock as _openBlock286, createElementBlock as _createElementBlock286 } from "vue";
var _sfc_main286 = /* @__PURE__ */ _defineComponent286({
  name: "Wallet",
  __name: "wallet",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock286(), _createElementBlock286("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode286("path", {
        fill: "currentColor",
        d: "M640 288h-64V128H128v704h384v32a32 32 0 0 0 32 32H96a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h512a32 32 0 0 1 32 32z"
      }),
      _createElementVNode286("path", {
        fill: "currentColor",
        d: "M128 320v512h768V320zm-32-64h832a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32"
      }),
      _createElementVNode286("path", {
        fill: "currentColor",
        d: "M704 640a64 64 0 1 1 0-128 64 64 0 0 1 0 128"
      })
    ]));
  }
}), wallet_default = _sfc_main286;

// src/components/warn-triangle-filled.vue
import { defineComponent as _defineComponent287 } from "vue";
import { createElementVNode as _createElementVNode287, openBlock as _openBlock287, createElementBlock as _createElementBlock287 } from "vue";
var _sfc_main287 = /* @__PURE__ */ _defineComponent287({
  name: "WarnTriangleFilled",
  __name: "warn-triangle-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock287(), _createElementBlock287("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode287("path", {
      fill: "currentColor",
      d: "M929 755.8 574.6 203.3a74 74 0 0 0-62.6-32.6 74 74 0 0 0-62.6 32.6L95 755.8a59 59 0 0 0 0 65 74 74 0 0 0 62.6 32.6h708.8c25.8 0 49.7-12.4 62.6-32.5s12.9-45 0-65M554.7 768h-85.4v-85.3h85.4zm0-426.7V640h-85.4V341.3z"
    })]));
  }
}), warn_triangle_filled_default = _sfc_main287;

// src/components/warning-filled.vue
import { defineComponent as _defineComponent288 } from "vue";
import { createElementVNode as _createElementVNode288, openBlock as _openBlock288, createElementBlock as _createElementBlock288 } from "vue";
var _sfc_main288 = /* @__PURE__ */ _defineComponent288({
  name: "WarningFilled",
  __name: "warning-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock288(), _createElementBlock288("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode288("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 192a58.4 58.4 0 0 0-58.2 63.7L477 576.1a35 35 0 0 0 69.8 0l23.3-256.4A58.4 58.4 0 0 0 512 256m0 512a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4"
    })]));
  }
}), warning_filled_default = _sfc_main288;

// src/components/warning.vue
import { defineComponent as _defineComponent289 } from "vue";
import { createElementVNode as _createElementVNode289, openBlock as _openBlock289, createElementBlock as _createElementBlock289 } from "vue";
var _sfc_main289 = /* @__PURE__ */ _defineComponent289({
  name: "Warning",
  __name: "warning",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock289(), _createElementBlock289("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode289("path", {
      fill: "currentColor",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m48-176a48 48 0 1 1-96 0 48 48 0 0 1 96 0m-48-464a32 32 0 0 1 32 32v288a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
    })]));
  }
}), warning_default = _sfc_main289;

// src/components/watch.vue
import { defineComponent as _defineComponent290 } from "vue";
import { createElementVNode as _createElementVNode290, openBlock as _openBlock290, createElementBlock as _createElementBlock290 } from "vue";
var _sfc_main290 = /* @__PURE__ */ _defineComponent290({
  name: "Watch",
  __name: "watch",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock290(), _createElementBlock290("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode290("path", {
        fill: "currentColor",
        d: "M512 768a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
      }),
      _createElementVNode290("path", {
        fill: "currentColor",
        d: "M480 352a32 32 0 0 1 32 32v160a32 32 0 0 1-64 0V384a32 32 0 0 1 32-32"
      }),
      _createElementVNode290("path", {
        fill: "currentColor",
        d: "M480 512h128q32 0 32 32t-32 32H480q-32 0-32-32t32-32m128-256V128H416v128h-64V64h320v192zM416 768v128h192V768h64v192H352V768z"
      })
    ]));
  }
}), watch_default = _sfc_main290;

// src/components/watermelon.vue
import { defineComponent as _defineComponent291 } from "vue";
import { createElementVNode as _createElementVNode291, openBlock as _openBlock291, createElementBlock as _createElementBlock291 } from "vue";
var _sfc_main291 = /* @__PURE__ */ _defineComponent291({
  name: "Watermelon",
  __name: "watermelon",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock291(), _createElementBlock291("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode291("path", {
      fill: "currentColor",
      d: "m683 600.3-43.6 162.8-61.8-16.5 53.2-198.5-54.8-54.9-158.4 158.4-45.2-45.2L530.8 448 475 392.4l-198.5 53.2-16.5-61.8 162.8-43.6L282.8 200A384 384 0 0 0 824 741.2zm231.6 141a448 448 0 1 1-632-632z"
    })]));
  }
}), watermelon_default = _sfc_main291;

// src/components/wind-power.vue
import { defineComponent as _defineComponent292 } from "vue";
import { createElementVNode as _createElementVNode292, openBlock as _openBlock292, createElementBlock as _createElementBlock292 } from "vue";
var _sfc_main292 = /* @__PURE__ */ _defineComponent292({
  name: "WindPower",
  __name: "wind-power",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock292(), _createElementBlock292("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode292("path", {
      fill: "currentColor",
      d: "M160 64q32 0 32 32v832q0 32-32 32t-32-32V96q0-32 32-32m416 354.6L704 407V169l-128-11.6zm-64 5.8V151.6L320 134V160h-64V64l616.7 56a96 96 0 0 1 87.3 95.7v144.6a96 96 0 0 1-87.3 95.6L256 512V224h64v218zm256-23.2 98.9-9a32 32 0 0 0 29.1-31.9V215.7a32 32 0 0 0-29.1-31.9l-98.9-9z"
    })]));
  }
}), wind_power_default = _sfc_main292;

// src/components/zoom-in.vue
import { defineComponent as _defineComponent293 } from "vue";
import { createElementVNode as _createElementVNode293, openBlock as _openBlock293, createElementBlock as _createElementBlock293 } from "vue";
var _sfc_main293 = /* @__PURE__ */ _defineComponent293({
  name: "ZoomIn",
  __name: "zoom-in",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock293(), _createElementBlock293("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode293("path", {
      fill: "currentColor",
      d: "m795.9 750.7 125 125a32 32 0 0 1-45.3 45.2l-125-125a416 416 0 1 1 45.3-45.2zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704m-32-384v-96a32 32 0 0 1 64 0v96h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64z"
    })]));
  }
}), zoom_in_default = _sfc_main293;

// src/components/zoom-out.vue
import { defineComponent as _defineComponent294 } from "vue";
import { createElementVNode as _createElementVNode294, openBlock as _openBlock294, createElementBlock as _createElementBlock294 } from "vue";
var _sfc_main294 = /* @__PURE__ */ _defineComponent294({
  name: "ZoomOut",
  __name: "zoom-out",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock294(), _createElementBlock294("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [_createElementVNode294("path", {
      fill: "currentColor",
      d: "m795.9 750.7 125 125a32 32 0 0 1-45.3 45.2l-125-125a416 416 0 1 1 45.3-45.2zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704M352 448h256a32 32 0 0 1 0 64H352a32 32 0 0 1 0-64"
    })]));
  }
}), zoom_out_default = _sfc_main294;
export {
  add_location_default as AddLocation,
  aim_default as Aim,
  alarm_clock_default as AlarmClock,
  apple_default as Apple,
  arrow_down_default as ArrowDown,
  arrow_down_bold_default as ArrowDownBold,
  arrow_left_default as ArrowLeft,
  arrow_left_bold_default as ArrowLeftBold,
  arrow_right_default as ArrowRight,
  arrow_right_bold_default as ArrowRightBold,
  arrow_up_default as ArrowUp,
  arrow_up_bold_default as ArrowUpBold,
  avatar_default as Avatar,
  back_default as Back,
  baseball_default as Baseball,
  basketball_default as Basketball,
  bell_default as Bell,
  bell_filled_default as BellFilled,
  bicycle_default as Bicycle,
  bottom_default as Bottom,
  bottom_left_default as BottomLeft,
  bottom_right_default as BottomRight,
  bowl_default as Bowl,
  box_default as Box,
  briefcase_default as Briefcase,
  brush_default as Brush,
  brush_filled_default as BrushFilled,
  burger_default as Burger,
  calendar_default as Calendar,
  camera_default as Camera,
  camera_filled_default as CameraFilled,
  caret_bottom_default as CaretBottom,
  caret_left_default as CaretLeft,
  caret_right_default as CaretRight,
  caret_top_default as CaretTop,
  cellphone_default as Cellphone,
  chat_dot_round_default as ChatDotRound,
  chat_dot_square_default as ChatDotSquare,
  chat_line_round_default as ChatLineRound,
  chat_line_square_default as ChatLineSquare,
  chat_round_default as ChatRound,
  chat_square_default as ChatSquare,
  check_default as Check,
  checked_default as Checked,
  cherry_default as Cherry,
  chicken_default as Chicken,
  chrome_filled_default as ChromeFilled,
  circle_check_default as CircleCheck,
  circle_check_filled_default as CircleCheckFilled,
  circle_close_default as CircleClose,
  circle_close_filled_default as CircleCloseFilled,
  circle_plus_default as CirclePlus,
  circle_plus_filled_default as CirclePlusFilled,
  clock_default as Clock,
  close_default as Close,
  close_bold_default as CloseBold,
  cloudy_default as Cloudy,
  coffee_default as Coffee,
  coffee_cup_default as CoffeeCup,
  coin_default as Coin,
  cold_drink_default as ColdDrink,
  collection_default as Collection,
  collection_tag_default as CollectionTag,
  comment_default as Comment,
  compass_default as Compass,
  connection_default as Connection,
  coordinate_default as Coordinate,
  copy_document_default as CopyDocument,
  cpu_default as Cpu,
  credit_card_default as CreditCard,
  crop_default as Crop,
  d_arrow_left_default as DArrowLeft,
  d_arrow_right_default as DArrowRight,
  d_caret_default as DCaret,
  data_analysis_default as DataAnalysis,
  data_board_default as DataBoard,
  data_line_default as DataLine,
  delete_default as Delete,
  delete_filled_default as DeleteFilled,
  delete_location_default as DeleteLocation,
  dessert_default as Dessert,
  discount_default as Discount,
  dish_default as Dish,
  dish_dot_default as DishDot,
  document_default as Document,
  document_add_default as DocumentAdd,
  document_checked_default as DocumentChecked,
  document_copy_default as DocumentCopy,
  document_delete_default as DocumentDelete,
  document_remove_default as DocumentRemove,
  download_default as Download,
  drizzling_default as Drizzling,
  edit_default as Edit,
  edit_pen_default as EditPen,
  eleme_default as Eleme,
  eleme_filled_default as ElemeFilled,
  element_plus_default as ElementPlus,
  expand_default as Expand,
  failed_default as Failed,
  female_default as Female,
  files_default as Files,
  film_default as Film,
  filter_default as Filter,
  finished_default as Finished,
  first_aid_kit_default as FirstAidKit,
  flag_default as Flag,
  fold_default as Fold,
  folder_default as Folder,
  folder_add_default as FolderAdd,
  folder_checked_default as FolderChecked,
  folder_delete_default as FolderDelete,
  folder_opened_default as FolderOpened,
  folder_remove_default as FolderRemove,
  food_default as Food,
  football_default as Football,
  fork_spoon_default as ForkSpoon,
  fries_default as Fries,
  full_screen_default as FullScreen,
  goblet_default as Goblet,
  goblet_full_default as GobletFull,
  goblet_square_default as GobletSquare,
  goblet_square_full_default as GobletSquareFull,
  gold_medal_default as GoldMedal,
  goods_default as Goods,
  goods_filled_default as GoodsFilled,
  grape_default as Grape,
  grid_default as Grid,
  guide_default as Guide,
  handbag_default as Handbag,
  headset_default as Headset,
  help_default as Help,
  help_filled_default as HelpFilled,
  hide_default as Hide,
  histogram_default as Histogram,
  home_filled_default as HomeFilled,
  hot_water_default as HotWater,
  house_default as House,
  ice_cream_default as IceCream,
  ice_cream_round_default as IceCreamRound,
  ice_cream_square_default as IceCreamSquare,
  ice_drink_default as IceDrink,
  ice_tea_default as IceTea,
  info_filled_default as InfoFilled,
  iphone_default as Iphone,
  key_default as Key,
  knife_fork_default as KnifeFork,
  lightning_default as Lightning,
  link_default as Link,
  list_default as List,
  loading_default as Loading,
  location_default as Location,
  location_filled_default as LocationFilled,
  location_information_default as LocationInformation,
  lock_default as Lock,
  lollipop_default as Lollipop,
  magic_stick_default as MagicStick,
  magnet_default as Magnet,
  male_default as Male,
  management_default as Management,
  map_location_default as MapLocation,
  medal_default as Medal,
  memo_default as Memo,
  menu_default as Menu,
  message_default as Message,
  message_box_default as MessageBox,
  mic_default as Mic,
  microphone_default as Microphone,
  milk_tea_default as MilkTea,
  minus_default as Minus,
  money_default as Money,
  monitor_default as Monitor,
  moon_default as Moon,
  moon_night_default as MoonNight,
  more_default as More,
  more_filled_default as MoreFilled,
  mostly_cloudy_default as MostlyCloudy,
  mouse_default as Mouse,
  mug_default as Mug,
  mute_default as Mute,
  mute_notification_default as MuteNotification,
  no_smoking_default as NoSmoking,
  notebook_default as Notebook,
  notification_default as Notification,
  odometer_default as Odometer,
  office_building_default as OfficeBuilding,
  open_default as Open,
  operation_default as Operation,
  opportunity_default as Opportunity,
  orange_default as Orange,
  paperclip_default as Paperclip,
  partly_cloudy_default as PartlyCloudy,
  pear_default as Pear,
  phone_default as Phone,
  phone_filled_default as PhoneFilled,
  picture_default as Picture,
  picture_filled_default as PictureFilled,
  picture_rounded_default as PictureRounded,
  pie_chart_default as PieChart,
  place_default as Place,
  platform_default as Platform,
  plus_default as Plus,
  pointer_default as Pointer,
  position_default as Position,
  postcard_default as Postcard,
  pouring_default as Pouring,
  present_default as Present,
  price_tag_default as PriceTag,
  printer_default as Printer,
  promotion_default as Promotion,
  quartz_watch_default as QuartzWatch,
  question_filled_default as QuestionFilled,
  rank_default as Rank,
  reading_default as Reading,
  reading_lamp_default as ReadingLamp,
  refresh_default as Refresh,
  refresh_left_default as RefreshLeft,
  refresh_right_default as RefreshRight,
  refrigerator_default as Refrigerator,
  remove_default as Remove,
  remove_filled_default as RemoveFilled,
  right_default as Right,
  robot_default as Robot,
  scale_to_original_default as ScaleToOriginal,
  school_default as School,
  scissor_default as Scissor,
  search_default as Search,
  select_default as Select,
  sell_default as Sell,
  semi_select_default as SemiSelect,
  service_default as Service,
  set_up_default as SetUp,
  setting_default as Setting,
  share_default as Share,
  ship_default as Ship,
  shop_default as Shop,
  shopping_bag_default as ShoppingBag,
  shopping_cart_default as ShoppingCart,
  shopping_cart_full_default as ShoppingCartFull,
  shopping_trolley_default as ShoppingTrolley,
  smoking_default as Smoking,
  soccer_default as Soccer,
  sold_out_default as SoldOut,
  sort_default as Sort,
  sort_down_default as SortDown,
  sort_up_default as SortUp,
  stamp_default as Stamp,
  star_default as Star,
  star_filled_default as StarFilled,
  stopwatch_default as Stopwatch,
  success_filled_default as SuccessFilled,
  sugar_default as Sugar,
  suitcase_default as Suitcase,
  suitcase_line_default as SuitcaseLine,
  sunny_default as Sunny,
  sunrise_default as Sunrise,
  sunset_default as Sunset,
  switch_default as Switch,
  switch_button_default as SwitchButton,
  switch_filled_default as SwitchFilled,
  takeaway_box_default as TakeawayBox,
  ticket_default as Ticket,
  tickets_default as Tickets,
  timer_default as Timer,
  toilet_paper_default as ToiletPaper,
  tools_default as Tools,
  top_default as Top,
  top_left_default as TopLeft,
  top_right_default as TopRight,
  trend_charts_default as TrendCharts,
  trophy_default as Trophy,
  trophy_base_default as TrophyBase,
  turn_off_default as TurnOff,
  umbrella_default as Umbrella,
  unlock_default as Unlock,
  upload_default as Upload,
  upload_filled_default as UploadFilled,
  user_default as User,
  user_filled_default as UserFilled,
  van_default as Van,
  video_camera_default as VideoCamera,
  video_camera_filled_default as VideoCameraFilled,
  video_pause_default as VideoPause,
  video_play_default as VideoPlay,
  view_default as View,
  wallet_default as Wallet,
  wallet_filled_default as WalletFilled,
  warn_triangle_filled_default as WarnTriangleFilled,
  warning_default as Warning,
  warning_filled_default as WarningFilled,
  watch_default as Watch,
  watermelon_default as Watermelon,
  wind_power_default as WindPower,
  zoom_in_default as ZoomIn,
  zoom_out_default as ZoomOut
};
